const translations = {
  ja: {
    // Common
    login: 'ログイン',
    logout: 'ログアウト',
    register: '新規登録',
    email: 'メールアドレス',
    password: 'パスワード',
    name: '氏名',
    phone: '電話番号',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    update: '更新',
    withdraw: '出金',
    deposit_method: '入金方法',
    confirm: '確認',
    loading: '読み込み中...',
    back: '戻る',
    submit: '送信',
    search: '検索',
    processing: '処理中...',
    fee: '手数料',
    total: '合計',
    amount: '金額',
    balance: '残高',
    bank_account: '銀行口座',

    // Landing Page
    landing_login: 'ログイン',
    landing_hero_title_1: '日本からブラジルへ',
    landing_hero_title_2: '簡単・安心',
    landing_hero_title_3: '送金',
    landing_hero_desc: '最短3クリックで送金完了。低コスト・高速送金で、大切な人に確実にお金を届けます。',
    landing_cta: '今すぐ始める',
    landing_calculator: '為替計算機',
    landing_fee_label: '送金手数料',
    landing_arrival: '以内に着金',
    landing_click_send: 'クリック送金',
    landing_send_amount: '送金額',
    landing_why_title: 'なぜPRC Remitを選ぶのか',
    landing_why_subtitle: '安心・安全・便利な国際送金サービス',
    landing_feature_fast: '高速送金',
    landing_feature_fast_desc: 'PIX対応で最短数分で着金。銀行振込でも24時間以内に確実にお届けします。',
    landing_feature_secure: '安心のセキュリティ',
    landing_feature_secure_desc: '金融庁認可の資金移動業者。KYC・AML完全対応で、安心してご利用いただけます。',
    landing_feature_cheap: '低コスト',
    landing_feature_cheap_desc: '手数料はわずか¥{fee}。明瞭な料金体系で、隠れた費用は一切ありません。',
    landing_how_title: 'ご利用方法',
    landing_how_subtitle: '3つのステップで簡単に送金できます',
    landing_step1_title: 'アカウント登録',
    landing_step1_desc: 'メールアドレスとパスワードで簡単に登録。本人確認（KYC）を完了してください。',
    landing_step2_title: '受取人を登録',
    landing_step2_desc: 'ブラジルの受取人情報（PIXキーまたは銀行口座）を登録します。',
    landing_step3_title: '送金実行',
    landing_step3_desc: '金額を入力して送金。銀行振込でお支払いいただくと、すぐに送金処理が開始されます。',
    landing_pricing_title: '料金プラン',
    landing_pricing_subtitle: 'シンプルで明瞭な料金体系',
    landing_per_transfer: '1回の送金につき',
    landing_exchange_rate: '為替レート',
    landing_market_rate: '市場レート',
    landing_markup_about: 'マークアップ約{rate}%',
    landing_no_hidden: '隠れた費用なし',
    landing_pix_bank: 'PIX・銀行振込対応',
    landing_24h_support: '24時間サポート',
    landing_cta_title: '今すぐ送金を始めましょう',
    landing_cta_desc: 'アカウント登録は無料。数分で始められます。',
    landing_cta_button: '無料でアカウント作成',
    landing_footer_desc: '日本からブラジルへの国際送金サービス。安心・安全・便利にご利用いただけます。',
    landing_footer_service: 'サービス',
    landing_footer_company: '会社情報',
    landing_footer_transfer_methods: '送金方法',
    landing_footer_pricing: '料金',
    landing_footer_docs: '説明用資料',
    pwa_install_title: 'アプリをインストール',
    pwa_install_desc: 'ホーム画面に追加して素早くアクセス',
    pwa_install_btn: 'インストール',
    pwa_ios_title: 'ホーム画面に追加',
    pwa_ios_desc: '以下の手順でアプリをインストールできます',
    pwa_ios_step1: 'Safari下部の共有ボタン（↑）をタップ',
    pwa_ios_step2: '「ホーム画面に追加」を選択',
    pwa_ios_step3: '「追加」をタップして完了',
    pwa_ios_close: '閉じる',
    landing_footer_about: '会社概要',
    landing_footer_terms: '利用規約',
    landing_footer_privacy: 'プライバシーポリシー',
    landing_footer_admin: '管理者ログイン',

    // Send Money
    send_title: '送金する',
    send_subtitle: '残高からブラジルへ送金',
    send_balance: '利用可能残高',
    send_insufficient: '残高が不足しています（不足額: ¥{amount}）',
    send_kyc_required_title: '送金にはKYC認証が必要です',
    send_kyc_required_desc: '送金を行う前に、本人確認手続きを完了してください。',
    send_step1: '送金額を入力',
    send_amount_label: '送金額',
    send_amount: '送金額',
    send_fee: '手数料',
    send_total: '合計支払い額',
    send_deduct: '残高から引き落とし',
    send_receive: '受取額',
    send_rate: '為替レート',
    send_step2: '受取人を選択',
    send_no_recipients: '受取人が登録されていません',
    send_add_recipient: '受取人を追加',
    send_recipient_label: '受取人',
    send_select_recipient: '受取人を選択...',
    send_btn_processing: '処理中...',
    send_btn_insufficient: '残高不足',
    send_btn_submit: '残高から送金する',
    send_go_deposit: '入金ページへ',
    send_success_title: '送金が完了しました',
    send_success_desc: '残高から引き落とされ、送金処理が開始されました',
    send_success_toast: '送金が完了しました！残高から引き落としされました。',
    send_error: '送金に失敗しました',
    send_kyc_error: 'KYC認証が必要です',
    send_select_error: '受取人を選択してください',
    send_balance_error: '残高が不足しています。入金してから再度お試しください。',
    send_id: '送金ID',
    send_total_deducted: '合計引き落とし額',
    send_go_history: '送金履歴へ',
    send_new: '新しい送金',
    send_currency_hint_jpy: '手数料は送金額から差し引かれます',
    send_currency_hint_brl: '受取人に届く金額を指定します（手数料は別途加算）',
    send_fee_exceeds: '送金額が手数料より少ないです。金額を増やしてください。',
    send_input_amount: '入力額',
    send_net_amount: '手数料差引後',
    send_total_debit: '残高引落額',
    send_free_transfer: '紹介特典: 手数料無料！',
    send_tier_discount: '段階特典: 手数料{percent}%OFF',

    // Referral
    nav_referral: '紹介',
    ref_title: '紹介プログラム',
    ref_subtitle: '友達を紹介して手数料無料特典をゲット！',
    ref_total: '紹介数',
    ref_completed: '完了',
    ref_pending: '保留中',
    ref_free_transfers: '無料送金回数',
    ref_your_code: 'あなたの紹介コード',
    ref_link_copied: 'リンクをコピーしました',
    ref_code_copied: 'コードをコピーしました',
    ref_share_message: 'PRC Remitで日本からブラジルへ簡単に送金！今すぐ登録して初回手数料無料: {link}',
    ref_share_subject: 'PRC Remit - 日本→ブラジル送金',
    ref_email: 'メール',
    ref_tier_title: '段階ボーナス',
    ref_current_tier: '現在のランク',
    ref_fee_discount: '手数料割引',
    ref_people: '人',
    ref_history: '紹介履歴',
    ref_no_referrals: 'まだ紹介がありません。コードを共有して始めましょう！',
    ref_status_completed: '完了',
    ref_status_pending: '保留中',

    // Registration Referral
    register_referral_code: '紹介コード（任意）',
    register_referral_placeholder: '紹介コードを入力',
    register_referral_applied: '紹介コードが適用されます！初回手数料無料',

    // Admin Referrals
    admin_nav_referrals: '紹介管理',
    admin_ref_title: '紹介管理',
    admin_ref_total: '総紹介数',
    admin_ref_completed: '完了',
    admin_ref_pending: '保留中',
    admin_ref_codes: '発行コード数',
    admin_ref_tab_list: '紹介一覧',
    admin_ref_tab_settings: '設定',
    admin_ref_referrer: '紹介者',
    admin_ref_referee: '被紹介者',
    admin_ref_status: 'ステータス',
    admin_ref_date: '日付',
    admin_ref_empty: '紹介データがありません',
    admin_ref_referrer_reward: '紹介者特典（無料送金回数）',
    admin_ref_referee_reward: '被紹介者特典（無料送金回数）',
    admin_ref_free_desc: '初回送金完了時に付与',
    admin_ref_min_amount: '最低送金額',
    admin_ref_tier_enabled: '段階制ボーナスを有効にする',
    admin_ref_tier_config: '段階設定',
    admin_ref_tier_name: 'ランク名',
    admin_ref_tier_min: '必要紹介数',
    admin_ref_tier_discount: '割引率(%)',
    admin_ref_settings_saved: '紹介設定を保存しました',

    // Transfer History
    history_title: '送金履歴',
    history_subtitle: 'あなたの送金記録',
    history_empty_title: '送金履歴がありません',
    history_empty_desc: '送金を行うとここに表示されます',
    history_amount: '送金額',

    // Exchange Calculator
    calc_title: '為替計算機',
    calc_subtitle: '送金前に金額をシミュレーション',
    calc_amount_label: '送金したい金額 (JPY)',
    calc_amount: '送金額',
    calc_note: '※ 為替レートは市場状況により変動します。最終的なレートは送金時に確定されます。',

    // Login
    login_success: 'ログインに成功しました',
    login_error: 'ログインに失敗しました',
    login_bio_success: '生体認証でログインしました',
    login_bio_error: '生体認証に失敗しました。パスワードでログインしてください。',
    login_go_register: 'ログイン',

    // Register
    register_go_login: 'ログイン',

    // Status
    status_pending: '保留中',
    status_processing: '処理中',
    status_completed: '完了',
    status_failed: '失敗',
    status_cancelled: 'キャンセル',
    history_payment_status: '支払い状況',
    payment_awaiting: '未入金',
    payment_paid: '入金済み',
    payment_confirmed: '確認済み',

    // Calculator extra
    calc_rate_title: '為替レート情報',
    calc_market_rate: '市場レート',
    calc_markup: 'マークアップ',
    calc_applied_rate: '適用レート',
    close: '閉じる',
    create: '作成',
    actions: '操作',
    details: '詳細',
    status: 'ステータス',
    date: '日付',
    amount: '金額',
    method: '方法',
    note: '備考',
    all: 'すべて',
    active: '有効',
    suspended: '停止',
    restricted: '制限',
    user: 'ユーザー',
    admin: '管理者',
    pending: '保留中',
    approved: '承認済み',
    rejected: '却下',
    submitted: '審査中',
    confirmed: '確認済み',
    processing: '処理中',
    completed: '完了',
    failed: '失敗',
    cancelled: 'キャンセル',
    yes: 'はい',
    no: 'いいえ',
    none: 'なし',
    total: '合計',
    jpy: 'JPY',
    brl: 'BRL',

    // Nav
    nav_dashboard: 'ダッシュボード',
    nav_deposit: '入金',
    nav_send: '送金',
    nav_recipients: '受取人',
    nav_history: '履歴',
    nav_exchange: '為替計算',
    nav_kyc: 'KYC認証',
    nav_income_cert: '年収証明書',
    nav_residence_card: '在留カード',
    nav_notifications: '通知',
    nav_profile: 'プロフィール',
    nav_support: 'サポート',

    // Dashboard
    dashboard_greeting: 'こんにちは、{name}さん',
    dashboard_welcome: 'PRC Remitダッシュボードへようこそ',
    dashboard_balance: '残高',
    dashboard_transfer_count: '送金回数',
    dashboard_total_sent: '総送金額',
    dashboard_deposit_btn: '入金',
    dashboard_send_btn: '送金',
    dashboard_send_money: '送金する',
    dashboard_send_desc: 'ブラジルへ送金',
    dashboard_recipients: '受取人管理',
    dashboard_recipients_desc: '受取人を追加・編集',
    dashboard_history: '送金履歴',
    dashboard_history_desc: '過去の送金を確認',
    dashboard_exchange_rate: '現在の為替レート',
    dashboard_per_jpy: '1 JPY あたり',
    dashboard_open_calc: '為替計算機を開く',
    dashboard_recent: '最近の送金',
    dashboard_view_all: 'すべて表示',
    dashboard_no_transfers: 'まだ送金履歴がありません',
    dashboard_first_transfer: '最初の送金を始める',

    // KYC
    kyc_required: '本人確認（KYC）が必要です',
    kyc_required_desc: '送金を行うには、本人確認手続きを完了してください。',
    kyc_start: 'KYC認証を始める',
    kyc_title: '本人確認（KYC）',
    kyc_subtitle: '安全な送金のために本人確認を完了してください',
    kyc_status_title: 'KYC提出済み',
    kyc_status_under_review: '審査中です。確認完了までしばらくお待ちください。',
    kyc_status_approved: 'KYCが承認されました',
    kyc_status_approved_desc: '本人確認が承認されました。送金をご利用いただけます。',
    kyc_status_rejected: 'KYCが却下されました',
    kyc_status_rejected_desc: '本人確認が却下されました。再提出してください。',
    kyc_resubmit: '再提出する',
    kyc_submit_form: '本人確認書類を提出',
    kyc_doc_type: '書類種類',
    kyc_doc_type_passport: 'パスポート',
    kyc_doc_type_residence: '在留カード',
    kyc_doc_type_license: '運転免許証',
    kyc_doc_number: '書類番号',
    kyc_full_name: '氏名（書類記載通り）',
    kyc_dob: '生年月日',
    kyc_address: '住所',
    kyc_occupation: '職業',
    kyc_purpose: '送金目的',
    kyc_purpose_family: '家族への送金',
    kyc_purpose_savings: '貯蓄・投資',
    kyc_purpose_education: '教育費',
    kyc_purpose_business: 'ビジネス',
    kyc_purpose_other: 'その他',
    kyc_documents: '本人確認書類（画像・PDF、最大3枚）',
    kyc_upload: 'クリックしてファイルを選択',
    kyc_upload_limit: 'アップロード上限に達しました',
    kyc_upload_desc: '表面・裏面など（JPEG、PNG、WebP、PDF対応・最大10MB）',
    kyc_uploading: 'アップロード中...',
    kyc_submit_btn: 'KYC書類を提出する',
    kyc_submitting: '提出中...',
    kyc_submitted_docs: '提出書類',
    kyc_submitted_at: '提出日',

    // Status badges
    status_pending: '保留中',
    status_processing: '処理中',
    status_completed: '完了',
    status_failed: '失敗',
    status_cancelled: 'キャンセル',

    // Login
    login_title: 'ログイン',
    login_desc: 'アカウントにログインしてください',
    login_no_account: 'アカウントをお持ちでない方は',
    login_error: 'メールアドレスまたはパスワードが正しくありません',
    login_biometric: '指紋/顔認証でログイン',
    login_bio_required_title: '生体認証が必要です',
    login_bio_required_desc: 'このアカウントには生体認証が設定されています。指紋またはFace IDで認証してください。',
    login_bio_verify: '生体認証で確認',
    login_bio_locked: '生体認証の試行回数を超えました。パスワードでログインしてください。',
    login_bio_locked_hint: '生体認証が一時的にロックされました。パスワードでログインしてください。',
    login_bio_waiting: '生体認証を確認中...',
    login_bio_attempts: '試行回数: {{current}}/{{max}}',
    login_bio_error: '生体認証に失敗しました',
    login_use_password: 'パスワードでログイン',
    login_2fa_title: '二要素認証',
    login_2fa_desc: '認証アプリに表示されている6桁のコードを入力してください',
    login_2fa_verify: '認証する',
    login_2fa_verifying: '確認中...',
    login_2fa_back: '戻る',

    // Register
    register_title: '新規登録',
    register_desc: 'アカウントを作成してください',
    register_has_account: '既にアカウントをお持ちの方は',
    verify_title: 'メール認証',
    verify_desc: '以下のメールアドレスに認証コードを送信しました',
    verify_page_desc: '登録時に送信された6桁の認証コードを入力してください',
    verify_code_label: '認証コード',
    verify_code_sent: '認証コードをメールに送信しました',
    verify_code_invalid: '6桁の認証コードを入力してください',
    verify_button: '認証する',
    verify_success: 'メール認証が完了しました',
    verify_failed: '認証に失敗しました',
    verify_no_code: 'コードが届かない場合',
    verify_resend: 'コードを再送信',
    verify_resent: '新しい認証コードを送信しました',
    verify_resend_failed: '再送信に失敗しました',
    verify_enter_email: 'メールアドレスを入力してください',
    verify_complete_title: '認証完了',
    verify_complete_desc: 'メールアドレスの認証が完了しました。ログインしてご利用ください。',
    register_btn: '登録する',
    register_registering: '登録中...',

    // Deposit
    deposit_title: '残高・入金管理',
    deposit_subtitle: 'アカウントに入金して送金に利用',
    deposit_card_title: 'カード入金',
    deposit_card_subtitle: '即時反映',
    deposit_card_btn: 'クレジットカードで入金',
    deposit_card_processing: '処理中...',
    deposit_bank_title: '銀行振込',
    deposit_bank_subtitle: '手動確認',
    deposit_bank_info: '振込先情報',
    deposit_bank_name: '銀行名',
    deposit_branch_name: '支店名',
    deposit_account_type: '口座種別',
    deposit_account_number: '口座番号',
    deposit_account_holder: '口座名義',
    deposit_amount: '入金額 (JPY)',
    deposit_reference: '振込名義人・参照番号',
    deposit_receipt: '振込明細書（任意）',
    deposit_submit: '入金申請を提出',
    deposit_history: '入金履歴',
    deposit_no_history: '入金履歴がありません',
    deposit_select_amount: '入金額を選択してください',
    deposit_success_title: '入金完了',
    deposit_success_reflected: '残高に反映されました',
    deposit_success_go_dashboard: 'ダッシュボードへ',
    deposit_pending_title: '処理中',
    deposit_pending_desc: '決済処理中です。しばらくお待ちください。',
    deposit_pending_back: '入金ページへ戻る',
    deposit_error_title: 'エラー',
    deposit_error_desc: '決済の確認に失敗しました',
    deposit_checking: '決済確認中...',

    // Send Money
    send_title: '送金',
    send_subtitle: 'ブラジルへ安全に送金',
    send_select_recipient: '受取人を選択',
    send_add_recipient: '新しい受取人を追加',
    send_amount_jpy: '送金額 (JPY)',
    send_fee: '手数料',
    send_exchange_rate: '為替レート',
    send_recipient_gets: '受取金額',
    send_total: '合計引落額',
    send_balance: '残高',
    send_insufficient: '残高不足です',
    send_deposit_first: '入金ページへ',
    send_confirm: '送金内容を確認',
    send_confirm_title: '送金確認',
    send_confirm_desc: '以下の内容で送金しますか？',
    send_recipient: '受取人',
    send_execute: '送金を実行する',
    send_executing: '送金処理中...',
    send_complete_title: '送金完了',
    send_complete_desc: '送金手続きが完了しました',
    send_transfer_id: '送金ID',
    send_view_history: '送金履歴を見る',
    send_new_transfer: '新しい送金',

    // Recipients
    recipients_title: '受取人管理',
    recipients_subtitle: 'ブラジルの受取人を管理',
    recipients_add: '受取人を追加',
    recipients_none: 'まだ受取人が登録されていません',
    recipients_add_first: '最初の受取人を追加してみましょう',
    recipients_name: '受取人名',
    recipients_bank: '銀行名',
    recipients_branch: '支店コード',
    recipients_account: '口座番号',
    recipients_type: '口座種類',
    recipients_pix: 'PIXキー',
    recipients_cpf: 'CPF番号',
    recipients_relationship: '続柄',
    recipients_edit: '受取人を編集',
    recipients_delete_confirm: 'この受取人を削除しますか？',
    recipients_checking: '普通',
    recipients_savings: '貯蓄',

    // Transfer History
    history_title: '送金履歴',
    history_subtitle: '過去の送金記録',
    history_no_records: 'まだ送金履歴がありません',
    history_first_send: '最初の送金をしてみましょう',
    history_go_send: '送金ページへ',
    history_recipient: '受取人',
    history_amount: '送金額',
    history_fee: '手数料',
    history_rate: 'レート',
    history_date: '日付',

    // Exchange Calculator
    exchange_title: '為替計算機',
    exchange_subtitle: 'JPY → BRL リアルタイムレート',
    exchange_amount_label: '送金額 (JPY)',
    exchange_result: '受取金額 (BRL)',
    exchange_rate_label: '為替レート',
    exchange_fee_label: '手数料',
    exchange_total_label: '合計引落額',
    exchange_live: 'ライブレート',

    // Profile
    profile_title: 'プロフィール',
    profile_subtitle: 'アカウント情報の確認・編集',
    profile_personal: '個人情報',
    profile_address: '住所',
    profile_dob: '生年月日',
    profile_occupation: '職業',
    profile_income: '年収',
    profile_update: 'プロフィールを更新',
    profile_updating: '更新中...',
    profile_photo: 'プロフィール写真',
    profile_stats: '利用統計',
    profile_total_transfers: '総送金件数',
    profile_total_amount: '総送金額',
    profile_total_recipients: '登録受取人数',
    profile_biometric: '生体認証',
    profile_biometric_not_supported: 'このブラウザでは生体認証に対応していません',
    profile_biometric_register: '生体認証を登録する',
    profile_biometric_add: '別のデバイスを追加',
    profile_biometric_max: '登録上限（5件）に達しました',
    profile_biometric_registering: '登録中...',
    profile_biometric_device: 'デバイス',
    profile_biometric_registered: '登録日',
    profile_2fa_title: '二要素認証 (2FA)',
    profile_2fa_enabled: '有効',
    profile_2fa_disabled: '無効',
    profile_2fa_totp: 'TOTP認証アプリ',
    profile_2fa_active: '二要素認証が有効です',
    profile_2fa_enter_code: '認証コードを入力',
    profile_2fa_disable: '無効化',
    profile_2fa_setup: '二要素認証を設定する',
    profile_2fa_setup_title: '二要素認証の設定',
    profile_2fa_scan_desc: 'Google Authenticator などの認証アプリで以下のQRコードをスキャンしてください。',
    profile_2fa_manual: '手動入力用シークレットキー:',
    profile_2fa_code_label: '認証コード',
    profile_2fa_code_placeholder: '6桁のコードを入力',
    profile_2fa_activate: '有効化する',

    // Support
    support_title: 'サポート',
    support_subtitle: 'お困りのことがあればお気軽にお問い合わせください',
    support_faq: 'よくある質問',
    support_contact: 'お問い合わせ',
    support_email: 'メールでのお問い合わせ',
    support_hours: '営業時間',
    support_hours_value: '平日 9:00 - 18:00',

    // Notifications
    notif_title: '通知',
    notif_mark_all: 'すべて既読',
    notif_empty: '通知はありません',
    notif_view_all: 'すべての通知を見る',
    notif_page_title: '通知',
    notif_page_subtitle: 'お知らせと更新情報',
    notif_total: '全通知',
    notif_unread: '未読',
    notif_read: '既読',
    notif_clear_read: '既読を削除',
    notif_filter_all: 'すべて',
    notif_filter_unread: '未読',
    notif_filter_read: '既読',
    notif_filter_empty: '該当する通知はありません',
    notif_view_detail: '詳細を見る',
    notif_mark_read: '既読にする',

    // Admin Nav
    admin_nav_dashboard: 'ダッシュボード',
    admin_nav_users: 'ユーザー管理',
    admin_nav_transfers: '送金管理',
    admin_nav_deposits: '入金管理',
    admin_nav_kyc: 'KYC審査',
    admin_nav_income_cert: '年収証明書',
    admin_nav_residence_card: '在留カード',
    admin_nav_email: 'メール',
    admin_nav_aml: 'AML監視',
    admin_nav_balance_cert: '残高証明書',

    // Balance Certificate
    bal_cert_title: '残高証明書管理',
    bal_cert_subtitle: 'ユーザーへの残高証明書の発行・送信管理',
    bal_cert_send_all: '全員に送信',
    bal_cert_send_all_confirm: '全ユーザーに残高証明書を送信しますか？',
    bal_cert_sent: '{count}件の残高証明書を送信しました',
    bal_cert_send_failed: '送信に失敗しました',
    bal_cert_delete_confirm: 'この証明書記録を削除しますか？',
    bal_cert_schedule_settings: 'スケジュール設定',
    bal_cert_schedule_desc: '残高証明書の自動送信スケジュールを設定',
    bal_cert_schedule_saved: 'スケジュールを保存しました',
    bal_cert_auto_schedule: '自動送信スケジュール',
    bal_cert_auto_enabled: '自動送信を有効にする',
    bal_cert_schedule_disabled: '無効',
    bal_cert_day_of_week: '送信曜日',
    bal_cert_hour: '時',
    bal_cert_minute: '分',
    bal_cert_col_date: '発行日時',
    bal_cert_col_user: 'ユーザー',
    bal_cert_col_balance: '残高',
    bal_cert_col_email_status: 'メール送信',
    bal_cert_col_type: '種別',
    bal_cert_sent_status: '送信済',
    bal_cert_unsent_status: '未送信',
    bal_cert_type_auto: '自動',
    bal_cert_type_manual: '手動',
    bal_cert_empty: '残高証明書の記録がありません',
    bal_cert_detail_title: '残高証明書詳細',
    bal_cert_sent_at: '送信日時',
    day_monday: '月曜日',
    day_tuesday: '火曜日',
    day_wednesday: '水曜日',
    day_thursday: '木曜日',
    day_friday: '金曜日',
    day_saturday: '土曜日',
    day_sunday: '日曜日',
    admin_nav_reports: 'レポート',
    admin_nav_settings: '手数料設定',
    admin_nav_company: '会社概要',

    // Company Profile
    company_admin_title: '会社概要',
    company_admin_subtitle: 'フロント画面に表示される会社情報を管理します',
    company_page_title: '会社概要',
    company_page_subtitle: 'PRC Remitについて',
    company_back: 'トップへ戻る',
    company_no_data: '会社情報はまだ登録されていません',
    company_company_name: '会社名',
    company_representative: '代表者',
    company_established: '設立',
    company_capital: '資本金',
    company_license_number: '登録番号',
    company_address: '所在地',
    company_phone: '電話番号',
    company_email: 'メールアドレス',
    company_website: 'ウェブサイト',
    company_business_description: '事業内容',
    company_save_btn: '会社概要を保存',
    company_saved: '会社概要を更新しました',
    company_save_failed: '会社概要の更新に失敗しました',

    // Legal Pages (Terms & Privacy)
    admin_nav_terms: '利用規約',
    admin_nav_privacy: 'プライバシーポリシー',
    legal_title_label: 'タイトル',
    legal_revised_label: '最終改定日',
    legal_content_label: '本文',
    legal_content_hint: '改行はそのまま反映されます',
    legal_last_revised: '最終改定',
    legal_no_data: 'まだ登録されていません',
    terms_admin_title: '利用規約',
    terms_admin_subtitle: 'フロント画面に表示される利用規約を管理します',
    terms_page_title: '利用規約',
    terms_title_placeholder: 'PRC Remit 利用規約',
    terms_content_placeholder: '利用規約の内容を入力してください...',
    terms_save_btn: '利用規約を保存',
    terms_saved: '利用規約を更新しました',
    terms_save_failed: '利用規約の更新に失敗しました',
    privacy_admin_title: 'プライバシーポリシー',
    privacy_admin_subtitle: 'フロント画面に表示されるプライバシーポリシーを管理します',
    privacy_page_title: 'プライバシーポリシー',
    privacy_title_placeholder: 'PRC Remit プライバシーポリシー',
    privacy_content_placeholder: 'プライバシーポリシーの内容を入力してください...',
    privacy_save_btn: 'プライバシーポリシーを保存',
    privacy_saved: 'プライバシーポリシーを更新しました',
    privacy_save_failed: 'プライバシーポリシーの更新に失敗しました',

    // Content Pages
    content_save_failed: '保存に失敗しました',
    admin_nav_transfer_methods: '送金方法',
    admin_nav_pricing: '料金',
    admin_nav_faq: 'FAQ',
    admin_nav_footer: 'フッター',
    tm_admin_title: '送金方法',
    tm_admin_subtitle: 'フロント画面に表示される送金方法を管理します',
    tm_page_title: '送金方法',
    tm_title_placeholder: 'PRC Remit 送金方法',
    tm_content_placeholder: '送金方法の内容を入力してください...',
    tm_save_btn: '送金方法を保存',
    transfer_methods_saved: '送金方法を更新しました',
    pricing_admin_title: '料金',
    pricing_admin_subtitle: 'フロント画面に表示される料金情報を管理します',
    pricing_page_title: '料金',
    pricing_title_placeholder: 'PRC Remit 料金案内',
    pricing_content_placeholder: '料金情報の内容を入力してください...',
    pricing_save_btn: '料金情報を保存',
    pricing_saved: '料金情報を更新しました',
    faq_admin_title: 'FAQ',
    faq_admin_subtitle: 'よくある質問と回答を管理します',
    faq_page_title: 'よくある質問',
    faq_page_subtitle: 'PRC Remitについてのよくある質問',
    faq_add: '質問を追加',
    faq_save_btn: 'FAQを保存',
    faq_saved: 'FAQを更新しました',
    faq_empty: 'FAQがまだ登録されていません',
    faq_question_placeholder: '質問を入力',
    faq_answer_placeholder: '回答を入力',
    footer_admin_title: 'フッター設定',
    footer_admin_subtitle: 'ランディングページのフッターに表示されるテキストを管理します',
    footer_text_label: 'フッターテキスト',
    footer_text_hint: 'ランディングページの最下部に表示されます',
    footer_preview: 'プレビュー',
    footer_save_btn: 'フッターを保存',
    footer_saved: 'フッターを更新しました',
    admin_title: '管理者',

    // Admin Dashboard
    admin_dash_total_users: '総ユーザー数',
    admin_dash_total_transfers: '総送金件数',
    admin_dash_pending_kyc: '未審査KYC',
    admin_dash_aml_flags: 'AMLフラグ',

    // Admin Users
    admin_users_title: 'ユーザー管理',
    admin_users_subtitle: 'ユーザーの管理・編集',
    admin_users_create: '新規登録',
    admin_users_edit: 'ユーザー情報編集',
    admin_users_role_admin: '管理者',
    admin_users_role_user: 'ユーザー',
    admin_users_create_desc: '管理者としてユーザーを作成します',
    admin_users_search: 'ユーザーを検索...',
    admin_users_actions: '操作',
    admin_users_balance: '残高',
    admin_users_role: 'ロール',
    admin_users_kyc: 'KYC',
    admin_users_status: 'ステータス',
    admin_users_no_results: 'ユーザーが見つかりません',
    admin_users_create_title: 'ユーザーを作成',
    admin_users_edit_title: 'ユーザーを編集',
    admin_users_kyc_status: 'KYCステータス',
    admin_users_account_status: 'アカウントステータス',
    admin_users_initial_balance: '初期残高 (JPY)',
    admin_users_not_submitted: '未提出',
    admin_users_balance_adjust: '残高調整',
    admin_users_balance_add: '追加',
    admin_users_balance_subtract: '減算',
    admin_users_balance_amount: '金額',
    admin_users_balance_reason: '理由',
    admin_users_balance_current: '現在の残高',
    admin_users_balance_after: '調整後の残高',
    admin_users_detail_title: 'ユーザー詳細',
    admin_users_basic_info: '基本情報',
    admin_users_deposit_history: '入金履歴',
    admin_users_transfer_history: '送金履歴',
    admin_users_no_deposits: '入金履歴なし',
    admin_users_no_transfers: '送金履歴なし',
    admin_users_delete_confirm: 'このユーザーを削除しますか？この操作は取り消せません。',

    // Admin Transfers
    admin_transfers_title: '送金管理',
    admin_transfers_subtitle: '全送金の管理・状態変更',
    admin_transfers_search: '送金を検索...',
    admin_transfers_filter_status: 'ステータスで絞込',
    admin_transfers_sender: '送金者',
    admin_transfers_recipient: '受取人',
    admin_transfers_amount_jpy: '送金額(JPY)',
    admin_transfers_amount_brl: '受取額(BRL)',
    admin_transfers_rate: 'レート',
    admin_transfers_fee: '手数料',
    admin_transfers_no_results: '送金が見つかりません',
    admin_transfers_detail: '送金詳細',
    admin_transfers_edit: '送金ステータスを編集',
    admin_transfers_delete_confirm: 'この送金を削除しますか？',

    // Admin Deposits
    admin_deposits_title: '入金管理',
    admin_deposits_subtitle: '入金申請の管理・承認',
    admin_deposits_create: '入金を追加',
    admin_deposits_search: '入金を検索...',
    admin_deposits_filter_status: 'ステータスで絞込',
    admin_deposits_user: 'ユーザー',
    admin_deposits_no_results: '入金が見つかりません',
    admin_deposits_deposit_id: '入金ID',
    admin_deposits_detail: '入金詳細',
    admin_deposits_edit: '入金を編集',
    admin_deposits_approve: '承認',
    admin_deposits_reject: '却下',
    admin_deposits_delete_confirm: 'この入金を削除しますか？',
    admin_deposits_create_title: '入金を追加',
    admin_deposits_user_id: 'ユーザーID',

    // Admin KYC
    admin_kyc_title: 'KYC審査',
    admin_kyc_subtitle: '本人確認書類の審査',
    admin_kyc_search: 'KYCを検索...',
    admin_kyc_filter_status: 'ステータスで絞込',
    admin_kyc_doc_type: '書類種類',
    admin_kyc_doc_number: '書類番号',
    admin_kyc_submitted_at: '提出日',
    admin_kyc_no_results: 'KYCリクエストが見つかりません',
    admin_kyc_approve: '承認',
    admin_kyc_reject: '却下',
    admin_kyc_edit: 'KYCを編集',
    admin_kyc_documents: '提出書類',
    admin_kyc_preview: '書類プレビュー',
    admin_kyc_purpose: '送金目的',
    admin_kyc_passport: 'パスポート',
    admin_kyc_residence_card: '在留カード',
    admin_kyc_drivers_license: '運転免許証',

    // Admin AML
    admin_aml_title: 'AML監視',
    admin_aml_subtitle: 'マネーロンダリング対策',
    admin_aml_search: 'AMLフラグを検索...',
    admin_aml_user: 'ユーザー',
    admin_aml_flag_type: 'フラグ種類',
    admin_aml_risk_level: 'リスクレベル',
    admin_aml_description: '説明',
    admin_aml_transfer_id: '送金ID',
    admin_aml_no_results: 'AMLフラグが見つかりません',
    admin_aml_delete_confirm: 'このAMLフラグを削除しますか？',
    admin_aml_risk_high: '高',
    admin_aml_risk_medium: '中',
    admin_aml_risk_low: '低',

    // Admin Reports
    admin_reports_title: 'レポート',
    admin_reports_subtitle: '送金・ユーザー・売上の統計データ',
    admin_reports_total_transfers: '総送金件数',
    admin_reports_total_volume: '総送金額',
    admin_reports_fee_revenue: '手数料収入',
    admin_reports_total_users: '総ユーザー数',
    admin_reports_this_month: '今月',
    admin_reports_kyc_approved: 'KYC承認',
    admin_reports_daily_chart: '過去7日間の送金量',
    admin_reports_daily_chart_desc: '日別の送金額と件数',
    admin_reports_user_stats: 'ユーザー統計',
    admin_reports_user_stats_desc: 'アクティブユーザーとKYC状況',
    admin_reports_active_users: 'アクティブユーザー',
    admin_reports_kyc_approved_users: 'KYC承認済み',
    admin_reports_new_users: '今月の新規登録',
    admin_reports_today_transfers: '本日の送金',
    admin_reports_week_transfers: '今週の送金',
    admin_reports_top_users: '送金額トップユーザー',
    admin_reports_top_users_desc: '累計送金額ランキング',
    admin_reports_no_data: 'データがありません',
    admin_reports_rank: '#',
    admin_reports_count: '送金件数',
    admin_reports_volume: '累計送金額',

    // Admin Settings
    admin_settings_title: '手数料設定',
    admin_settings_subtitle: '送金手数料とマークアップの設定',
    admin_settings_flat_fee: '固定手数料 (JPY)',
    admin_settings_markup: '為替マークアップ (%)',
    admin_settings_save: '設定を保存',
    admin_settings_saving: '保存中...',
    admin_settings_reset: '初期値',
    admin_settings_revenue: '収益構造',
    admin_settings_fee_per: '固定手数料収入',
    admin_settings_spread_per: '為替スプレッド収入',
    admin_settings_total_revenue: '合計収益',
    admin_settings_per_transfer: '/ 件',
    admin_settings_bank_title: '振込先情報',
    admin_settings_bank_subtitle: 'ユーザーの入金ページに表示される銀行口座情報',
    admin_settings_bank_name: '銀行名',
    admin_settings_branch_name: '支店名',
    admin_settings_account_type: '口座種別',
    admin_settings_account_number: '口座番号',
    admin_settings_account_holder: '口座名義',
    admin_settings_bank_notes: '備考（任意）',
    admin_settings_bank_save: '振込先情報を保存',

    // Logo Settings
    admin_settings_logo_title: '会社ロゴ',
    admin_settings_logo_subtitle: 'サイト全体に表示される会社のロゴマーク',
    admin_settings_logo_current: '現在のロゴ',
    admin_settings_logo_upload: 'ロゴをアップロード',
    admin_settings_logo_uploading: 'アップロード中...',
    admin_settings_logo_change: 'ロゴを変更',
    admin_settings_logo_delete: 'ロゴを削除',
    admin_settings_logo_deleting: '削除中...',
    admin_settings_logo_success: 'ロゴをアップロードしました',
    admin_settings_logo_delete_success: 'ロゴを削除しました',
    admin_settings_logo_error: 'ロゴのアップロードに失敗しました',
    admin_settings_logo_delete_error: 'ロゴの削除に失敗しました',
    admin_settings_logo_formats: '対応形式: JPEG, PNG, WebP, SVG（最大5MB）',
    admin_settings_logo_default: 'デフォルトロゴ使用中',

    // Landing Settings
    admin_settings_landing_title: 'ランディングページ表示',
    admin_settings_landing_subtitle: 'トップページの計算機ウィジェットに表示する送金額',
    admin_settings_landing_amount_label: '表示送金額（JPY）',
    admin_settings_landing_amount_desc: 'ランディングページのヒーローセクションに表示されるサンプル送金額',
    admin_settings_landing_saved: '表示設定を保存しました',
    admin_settings_landing_error: '表示設定の保存に失敗しました',
    admin_settings_landing_invalid: '有効な金額を入力してください',
    admin_settings_hero_title: 'ヒーローテキスト編集',
    admin_settings_hero_line1: 'タイトル1行目',
    admin_settings_hero_line2: 'タイトル2行目（強調色）',
    admin_settings_hero_line3: 'タイトル3行目',
    admin_settings_hero_desc: '説明文',
    admin_settings_hero_hint: '空白の場合はデフォルトテキストが使用されます。JA/PT/ENタブで各言語を編集できます。',

    settings_market_rate_title: '市場為替レート',
    settings_market_rate_subtitle: 'Frankfurter API（ECB）から3時間毎に自動取得',
    settings_current_rate: '現在の市場レート',
    settings_manual_mode: '手動設定',
    settings_live_mode: 'ライブ',
    settings_last_updated: '最終更新',
    settings_source: 'データソース',
    settings_source_manual: '手動設定',
    settings_auto_refresh: '自動更新',
    settings_every_3h: '3時間ごとに自動更新',
    settings_next_refresh: '次回更新',
    settings_refresh_now: '今すぐ更新',
    settings_refreshing: '更新中...',
    settings_manual_rate: '手動レート設定',
    settings_override: '手動設定',
    settings_enable_auto: '自動取得に戻す',
    settings_rate_refreshed: '為替レートを更新しました',
    settings_rate_refresh_failed: 'レート更新に失敗しました',
    settings_rate_invalid: '有効なレートを入力してください',
    settings_rate_overridden: '為替レートを手動設定しました',
    settings_rate_auto_enabled: '自動レート取得を有効にしました',
    settings_fee_title: '手数料設定',
    settings_flat_fee_desc: '各送金に加算される固定手数料',
    settings_markup_desc: '市場レートに上乗せするマークアップ率',
    settings_saved: '手数料設定を更新しました',
    settings_save_failed: '設定の更新に失敗しました',
    settings_bank_saved: '振込先情報を更新しました',
    settings_bank_save_failed: '振込先情報の更新に失敗しました',
    settings_simulation_title: 'シミュレーション',
    settings_sim_amount: '送金額',
    settings_sim_fee: '固定手数料',
    settings_sim_total: '合計支払い額',
    settings_sim_market_rate: '市場レート',
    settings_sim_applied_rate: '適用レート（マークアップ後）',
    settings_sim_receive: '受取額',

    // Admin Login
    admin_login_title: '管理者ログイン',
    admin_login_desc: '管理者アカウントでログイン',

    // Login
    login_success: 'ログインに成功しました',
    login_fail: 'ログインに失敗しました',
    login_email_not_verified: 'メールアドレスが未認証です。認証コードを確認してください。',
    deposit_receipt_uploaded: '領収書をアップロードしました',
    deposit_receipt_upload_fail: 'ファイルのアップロードに失敗しました',

    // Send extra
    send_kyc_required: 'KYC認証が必要です',
    send_select_recipient: '受取人を選択してください',
    send_insufficient_balance: '残高が不足しています。入金してから再度お試しください。',

    // Admin Toast Messages
    admin_users_created: 'ユーザーを作成しました',
    admin_users_create_failed: 'ユーザーの作成に失敗しました',
    admin_users_updated: 'ユーザー情報を更新しました',
    admin_users_update_failed: 'ユーザー情報の更新に失敗しました',
    admin_users_deleted: 'ユーザーを削除しました',
    admin_users_delete_failed: 'ユーザーの削除に失敗しました',
    admin_users_balance_updated: '残高を更新しました',
    admin_users_balance_failed: '残高の更新に失敗しました',
    admin_users_password_placeholder: '新しいパスワードを入力（変更しない場合は空欄）',
    admin_users_password_hint: '空欄の場合、パスワードは変更されません。6文字以上で入力してください。',
    admin_users_deposit_added: '入金を追加しました',
    admin_users_deposit_failed: '入金の追加に失敗しました',
    admin_transfers_updated: '送金情報を更新しました',
    admin_transfers_update_failed: '送金情報の更新に失敗しました',
    admin_transfers_deleted: '送金記録を削除しました',
    admin_transfers_delete_failed: '送金記録の削除に失敗しました',
    admin_transfers_delete_confirm: 'この送金を削除しますか？',
    admin_transfers_payment_status: '支払ステータス',
    admin_transfers_period_filter: '期間指定',
    admin_transfers_count_records: '件の送金記録',
    admin_transfers_transfer_id: '送金ID',
    admin_kyc_reviewed: 'KYCを{action}しました',
    admin_kyc_review_failed: 'KYC審査に失敗しました',
    admin_kyc_updated: 'KYC情報を更新しました',
    admin_kyc_update_failed: 'KYC情報の更新に失敗しました',
    admin_kyc_notes: '審査コメント',
    admin_kyc_notes_placeholder: '審査コメントを入力...',
    admin_kyc_review_title: 'KYC審査',
    admin_deposits_confirmed: '入金を承認しました',
    admin_deposits_confirm_failed: '入金の承認に失敗しました',
    admin_deposits_rejected: '入金を拒否しました',
    admin_deposits_reject_failed: '入金の拒否に失敗しました',
    admin_deposits_reject_confirm: 'この入金を拒否しますか？',
    admin_deposits_deleted: '入金を削除しました',
    admin_deposits_delete_failed: '入金の削除に失敗しました',
    admin_deposits_pending_count: '承認待ち: {count}件',
    admin_deposits_method_bank: '銀行振込',
    admin_deposits_method_convenience: 'コンビニ払い',
    admin_deposits_method_admin: '管理者手動',
    admin_deposits_method_stripe: 'Stripe',
    admin_deposits_status_confirmed: '確認済み',
    admin_deposits_status_rejected: '拒否',
    admin_aml_resolved: 'AMLフラグを解決しました',
    admin_aml_resolve_failed: 'AMLフラグの解決に失敗しました',
    admin_aml_deleted: 'AMLフラグを削除しました',
    admin_aml_delete_failed: 'AMLフラグの削除に失敗しました',
    admin_aml_risk_prefix: 'リスク',
    admin_aml_status_open: '未解決',
    admin_aml_status_investigating: '調査中',
    admin_aml_status_resolved: '解決済み',
    admin_aml_status_false_positive: '誤検知',
    admin_aml_resolve: '解決',
    admin_aml_investigate: '調査',
    admin_aml_false_positive_btn: '誤検知',
    admin_reports_loading: '読み込み中...',
    admin_reports_error: 'データの取得に失敗しました',
    admin_data_not_found: 'データが見つかりません',
    status_active: 'アクティブ',
    status_suspended: '停止',
    status_frozen: '凍結',
    all: 'すべて',

    // Back to home
    back_to_home: 'ホームに戻る',
    // Count suffix
    count_suffix: '回',
    count_people: '人',
    count_items: '件',

    // Profile extra
    profile_account_info: 'アカウント情報と統計',
    profile_bio_success: '生体認証を登録しました。次回から指紋でログインできます。',
    profile_bio_cancel: '生体認証の登録がキャンセルされました',
    profile_bio_fail: '生体認証の登録に失敗しました',
    profile_bio_delete_confirm: 'この生体認証を削除しますか？',
    profile_bio_deleted: '生体認証を削除しました',
    profile_bio_delete_fail: '生体認証の削除に失敗しました',
    profile_2fa_setup_fail: '2FA設定の開始に失敗しました',
    profile_2fa_verified: '二要素認証を有効にしました',
    profile_2fa_invalid_code: '認証コードが正しくありません',
    profile_2fa_disabled_msg: '二要素認証を無効にしました',
    profile_updated: 'プロフィールを更新しました',
    profile_update_fail: 'プロフィールの更新に失敗しました',
    profile_image_size: 'ファイルサイズは5MB以下にしてください',
    profile_image_updated: 'プロフィール画像を更新しました',
    profile_image_fail: '画像のアップロードに失敗しました',
    profile_not_set: '未設定',
    profile_basic_info: '基本情報',
    profile_annual_income_unit: '万円',
    profile_registered_at: '登録',
    profile_kyc_docs: '本人確認書類',
    profile_go_kyc: 'KYCページへ',
    profile_kyc_status_label: 'KYCステータス',
    profile_kyc_needed: '本人確認が必要です',
    profile_kyc_under_review: '審査中です',
    profile_kyc_completed: '本人確認が完了しています',
    profile_kyc_rejected_msg: '本人確認が却下されました',
    profile_recent_transfers: '最近の送金',
    profile_bio_fingerprint: '生体認証（指紋）',
    profile_bio_login_desc: '指紋やFace IDでログイン',
    profile_bio_device_name: '生体認証デバイス',
    profile_bio_none_desc: '生体認証が登録されていません。登録すると、次回から指紋やFace IDでログインできます。',

    // KYC extra
    kyc_submitted_toast: 'KYC申請を提出しました',
    kyc_submit_fail: 'KYC申請に失敗しました',
    kyc_files_uploaded: '{count}件のファイルをアップロードしました',
    kyc_upload_fail: 'ファイルのアップロードに失敗しました',
    kyc_status_pending_title: '審査中',
    kyc_status_pending_desc: 'KYC申請を審査中です。通常1～2営業日で結果をお知らせします。',
    kyc_status_approved_title: '承認済み',
    kyc_status_approved_full: 'KYC認証が完了しました。送金をご利用いただけます。',
    kyc_status_rejected_title: '却下',
    kyc_status_rejected_full: 'KYC申請が却下されました。詳細は下記をご確認ください。',
    kyc_reviewer_notes: '審査コメント',
    kyc_page_subtitle: '本人確認手続き',
    kyc_form_title: '本人確認書類の提出',
    kyc_form_desc: '送金を行うためには、本人確認（KYC）が必要です。以下の情報を入力してください。',
    kyc_doc_type_label: '身分証明書の種類',
    kyc_full_name_label: '氏名（フルネーム）',
    kyc_purpose_placeholder: '例: 家族への送金、留学費支払いなど',
    kyc_submit_button: 'KYCを提出',

    // KYC residence
    kyc_residence_section: '在留資格情報',
    kyc_residence_status: '在留資格',
    kyc_residence_status_placeholder: '在留資格を選択',
    kyc_residence_card_number: '在留カード番号',
    kyc_residence_period: '在留期間（満了日）',
    kyc_residence_permanent: '永住者',
    kyc_residence_long_term: '定住者',
    kyc_residence_spouse: '日本人の配偶者等',
    kyc_residence_work: '就労ビザ（技術・人文知識・国際業務等）',
    kyc_residence_student: '留学',
    kyc_residence_technical: '技能実習',
    kyc_residence_specified: '特定技能',
    kyc_residence_other: 'その他',

    // KYC photo sides
    kyc_photo_front: '表面',
    kyc_photo_back: '裏面',
    kyc_photo_angled: '斜め面',
    kyc_photo_desc: '本人確認書類の写真を3面（表面・裏面・斜め面）アップロードしてください。',

    // Recipients extra
    recipients_added: '受取人を追加しました',
    recipients_add_fail: '受取人の追加に失敗しました',
    recipients_deleted: '受取人を削除しました',
    recipients_delete_fail: '受取人の削除に失敗しました',
    recipients_new_title: '新しい受取人を追加',
    recipients_new_desc: '送金先の情報を入力してください',
    recipients_method: '受取方法',
    recipients_bank_account: '銀行口座',
    recipients_pix_placeholder: 'CPF, E-mail, 電話番号, またはランダムキー',
    recipients_branch_number: '支店番号',
    recipients_nationality: '国籍',
    recipients_postal_code: '郵便番号',
    recipients_address: '住所',
    recipients_phone: '電話番号',
    recipients_email: 'Eメール',
    recipients_transfer_purpose: '送金目的',
    recipients_fund_source: '送金資金源',
    recipients_edit_title: '受取人を編集',
    recipients_edit_desc: '受取人の情報を変更してください',
    recipients_updated: '受取人情報を更新しました',
    recipients_update_fail: '受取人情報の更新に失敗しました',
    recipients_save: '保存する',
    recipients_personal_info: '個人情報',
    recipients_bank_info: '銀行情報',
    recipients_transfer_info: '送金関連情報',
    recipients_relationship_family: '家族',
    recipients_relationship_friend: '友人',
    recipients_relationship_business: 'ビジネス',
    recipients_relationship_self: '本人',
    recipients_relationship_other: 'その他',
    recipients_purpose_living: '生活費',
    recipients_purpose_education: '教育費',
    recipients_purpose_business: 'ビジネス',
    recipients_purpose_investment: '投資',
    recipients_purpose_gift: '贈与',
    recipients_purpose_other: 'その他',
    recipients_fund_salary: '給与',
    recipients_fund_savings: '貯蓄',
    recipients_fund_business: '事業収入',
    recipients_fund_investment: '投資収益',
    recipients_fund_other: 'その他',

    // Recipient Invitation
    invite_title: '受取人を招待',
    invite_subtitle: '受取人に直接情報を入力してもらいます',
    invite_name: '受取人名',
    invite_email: '受取人のメールアドレス',
    invite_email_optional: '（任意 - メールで招待リンクを送信）',
    invite_send: '招待リンクを作成',
    invite_sending: '作成中...',
    invite_success: '招待リンクを作成しました',
    invite_fail: '招待の作成に失敗しました',
    invite_link_label: '招待リンク',
    invite_copied: 'リンクをコピーしました',
    invite_share_email: 'メール',
    invite_share_line: 'LINE',
    invite_share_whatsapp: 'WhatsApp',
    invite_share_copy: 'コピー',
    invite_share_title: '共有方法を選択',
    invite_share_message: '{name}さん、以下のリンクから受取人情報を入力してください: {link}',
    invite_pending: '入力待ち',
    invite_completed: '入力済み',
    invite_tab_list: '受取人一覧',
    invite_tab_invitations: '招待管理',
    invite_empty: '招待がありません',
    invite_delete_confirm: 'この招待を削除しますか？',
    invite_deleted: '招待を削除しました',
    invite_btn: '招待して入力してもらう',
    invite_form_title: '受取人情報の入力',
    invite_form_subtitle: '{sender}さんがあなたを送金の受取人として登録したいと考えています。以下の情報を入力してください。',
    invite_form_submit: '情報を送信する',
    invite_form_submitting: '送信中...',
    invite_form_success_title: '情報を送信しました',
    invite_form_success_desc: '入力いただいた情報は送金者に共有されました。ありがとうございました。',
    invite_form_expired: 'このリンクは既に使用済みです',
    invite_form_not_found: '招待が見つかりません',
    invite_email_sent: 'メールを送信しました',

    // Document pages
    income_cert_title: '年収証明書',
    income_cert_desc: '年収証明書の写真をアップロードしてください',
    income_cert_photo: '書類の写真',
    income_cert_annual: '年収金額',
    income_cert_monthly: '月給金額',
    residence_card_title: '在留カード',
    residence_card_desc: '在留カードの写真をアップロードしてください',
    residence_card_photo: '在留カードの写真',
    residence_card_number: '在留カード番号',
    residence_card_expiry: '期限年月日',
    residence_card_front: '表面',
    residence_card_back: '裏面',
    residence_card_both_required: '表面と裏面の両方の写真が必要です',
    doc_status_pending: '審査中',
    doc_status_approved: '承認済み',
    doc_status_rejected: '却下',
    doc_status_not_submitted: '未提出',
    doc_photo_uploaded: '写真をアップロードしました',
    doc_upload_fail: 'アップロードに失敗しました',
    doc_photo_required: '写真が必要です',
    doc_submitted: '提出しました',
    doc_submit_fail: '提出に失敗しました',
    doc_submit: '提出する',
    doc_submitting: '提出中...',
    doc_click_upload: 'クリックして写真をアップロード',
    doc_uploading: 'アップロード中...',
    doc_change_photo: '写真を変更',
    doc_submitted_at: '提出日',
    doc_reviewer_notes: '審査メモ',
    doc_delete_confirm: '削除してもよろしいですか？',
    doc_deleted: '削除しました',
    doc_delete_fail: '削除に失敗しました',
    doc_delete_resubmit: '削除して再提出',
    doc_update: '内容を更新',
    doc_updating: '更新中...',
    doc_updated: '更新しました',
    doc_update_confirm: 'この書類を更新しますか？ステータスは再審査待ちになります。',
    doc_add_new: '新しく追加',
    doc_history: '提出履歴',
    doc_current: '最新',
    admin_income_cert_title: '年収証明書管理',
    admin_income_cert_desc: 'ユーザーの年収証明書を確認・編集します',
    admin_income_cert_review: '年収証明書を審査',
    admin_income_cert_edit: '年収証明書を編集',
    admin_residence_card_title: '在留カード管理',
    admin_residence_card_desc: 'ユーザーの在留カードを確認・編集します',
    admin_residence_card_review: '在留カードを審査',
    admin_residence_card_edit: '在留カードを編集',
    admin_doc_user: 'ユーザー',
    admin_doc_status: 'ステータス',
    admin_doc_actions: '操作',
    admin_doc_approve: '承認',
    admin_doc_reject: '却下',
    admin_doc_approved: '承認しました',
    admin_doc_rejected: '却下しました',
    admin_doc_updated: '更新しました',
    admin_no_documents: '書類がありません',
    admin_email_title: 'メール管理',
    admin_email_desc: 'メールの送受信を確認・管理します',
    admin_email_refresh: '更新',
    admin_email_compose: '新規作成',
    admin_email_compose_desc: 'メールを送信します',
    admin_email_from: '差出人',
    admin_email_to: '宛先',
    admin_email_subject: '件名',
    admin_email_body: '本文',
    admin_email_date: '日付',
    admin_email_send: '送信',
    admin_email_sending: '送信中...',
    admin_email_sent: 'メールを送信しました',
    admin_email_reply: '返信',
    admin_email_back: '戻る',
    admin_email_messages: '件',
    admin_email_empty: 'メールがありません',
    admin_email_fetch_fail: 'メールの取得に失敗しました',
    admin_email_fill_all: '全ての項目を入力してください',
    admin_email_manage_accounts: 'アカウント管理',
    admin_email_accounts_title: 'メールアカウント一覧',
    admin_email_add_account: 'アカウント追加',
    admin_email_add_account_desc: 'メールアカウントの接続情報を入力してください',
    admin_email_address: 'メールアドレス',
    admin_email_password: 'パスワード',
    admin_email_label: 'ラベル',
    admin_email_server: 'サーバー',
    admin_email_port: 'ポート',
    admin_email_test: 'テスト',
    admin_email_test_ok: '接続テスト成功',
    admin_email_account_added: 'アカウントを追加しました',
    admin_email_account_deleted: 'アカウントを削除しました',
    admin_email_delete_confirm: 'このアカウントを削除しますか？',
    admin_email_no_accounts: 'アカウントがありません',
    register_password_mismatch: 'パスワードが一致しません',
    register_password_min: 'パスワードは6文字以上で入力してください',
    register_success: '登録に成功しました',
    register_fail: '登録に失敗しました',
    register_create_account: 'アカウント作成',
    register_phone_optional: '電話番号（任意）',
    register_confirm_password: 'パスワード（確認）',
    register_name_placeholder: '山田 太郎',

    // Support extra
    support_contact_methods: 'お問い合わせ方法',
    support_email_title: 'メール',
    support_email_desc: '24時間以内に回答いたします',
    support_phone_title: '電話',
    support_phone_hours: '平日 9:00-18:00',
    support_chat_title: 'チャット',
    support_chat_desc: '即座に対応可能',
    support_chat_start: 'チャットを開始',
    support_faq_q1: '送金にかかる時間は？',
    support_faq_a1: 'PIXの場合は最短数分、銀行振込の場合は24時間以内に着金します。',
    support_faq_q2: '手数料はいくらですか？',
    support_faq_a2: '一律¥500の手数料がかかります。隠れた費用は一切ありません。',
    support_faq_q3: 'KYC認証は必須ですか？',
    support_faq_a3: 'はい、送金を行うためには本人確認（KYC）が必要です。これは日本の法律で義務付けられています。',
    support_faq_q4: '送金限度額はありますか？',
    support_faq_a4: '1回の送金は最大100万円までです。より大きな金額を送りたい場合はサポートにご相談ください。',

    // Admin Dashboard extra
    admin_dash_title: 'ダッシュボード',
    admin_dash_subtitle: 'システム全体の概要',
    admin_dash_total_volume: '送金総額',
    admin_dash_pending_kyc_alert: '審査待ちKYC: {count}件',
    admin_dash_pending_kyc_desc: 'KYC申請が審査待ちです',
    admin_dash_deposits: '入金件数',
    admin_dash_pending_deposits: '件の入金が承認待ち',
    admin_dash_pending_deposits_desc: '入金の確認と承認が必要です',
    admin_dash_aml_alert: '件のAMLフラグ',
    admin_dash_aml_alert_desc: 'AMLフラグの確認が必要です',
    admin_dash_aml_open: 'オープンフラグ',
    admin_dash_referral_uses: '紹介利用数',
    admin_dash_email_accounts: 'メールアカウント',
    admin_dash_recipients: '受取人',
    admin_dash_registered: '登録済み',
    admin_dash_documents: '書類管理',
    admin_dash_management: 'その他管理',
    admin_dash_recent_transfers: '最近の送金',
    admin_dash_recent_users: '最近の登録ユーザー',
    view_all: 'すべて表示',
    total: '合計',
    pending: '承認待ち',
    no_data: 'データなし',
    loading: '読み込み中...',

    // Admin Login extra
    admin_login_no_permission: '管理者権限がありません',
    admin_login_success: 'ログインに成功しました',
    admin_login_fail: 'ログインに失敗しました',
    admin_login_loading: 'ログイン中...',

    // Missing keys - General
    deposit: '入金',
    saving: '保存中...',
    login_or: 'または',
    not_entered: '未入力',
    no_records: '記録なし',
    error_occurred: 'エラーが発生しました',

    // Deposit page
    deposit_invalid_amount: '有効な金額を入力してください',
    deposit_submitted: '入金申請を提出しました',
    deposit_submit_failed: '入金申請に失敗しました',
    deposit_reference_placeholder: '振込名義人や振込日時など',
    deposit_receipt_label: '振込明細書の写真をアップロード',
    deposit_receipt_alt: '明細書',
    deposit_receipt_preview_alt: '振込明細書',

    // Print-related
    print_title_history: 'PRC Remit - 送金履歴',
    print_title_admin: 'PRC Remit - 送金管理一覧',
    print_date: '印刷日',
    print_period: '期間',
    print_period_all: '全期間',
    print_no_start: '開始日なし',
    print_no_end: '終了日なし',
    print_total_jpy: '送金総額(JPY)',
    print_total_brl: '受取総額(BRL)',
    print_total_fee: '手数料合計',
    print_col_no: 'No.',
    print_col_date: '日時',
    print_col_recipient: '受取人',
    print_col_sender: '送金者',
    print_col_amount_jpy: '送金額(JPY)',
    print_col_fee: '手数料',
    print_col_total_jpy: '合計(JPY)',
    print_col_amount_brl: '受取額(BRL)',
    print_col_rate: 'レート',
    print_col_status: '状態',
    print_col_id: '送金ID',
    print_col_payment: '決済',
    print_footer_user: 'この書類は送金記録の参考資料です',
    print_footer_admin: 'この書類は送金管理記録です',
    print_admin_label: '管理者用',
    print_license: '許可番号',
    print_representative: '代表者',
    print_items: '件',
    print_address: '住所',
    print_phone: '電話番号',
    print_email: 'メールアドレス',
    print_website: 'ウェブサイト',
    print_payment_unpaid: '未払い',
    print_payment_paid: '支払済',
    print_payment_confirmed: '確認済',
    print_pdf_read: 'PDFから読み取り完了（{fields}）',
    print_settlement_id: '明細番号',
    print_settled_amount: '確定金額',

    // Admin AML page
    aml_subtitle: 'マネーロンダリング対策・解決記録管理',
    aml_created_at: '発生日時',
    aml_resolve_record: '解決記録',
    aml_resolve_title: 'AML解決記録',
    aml_resolve_detail_title: 'AML解決記録 詳細',
    aml_resolve_type: '解決種別',
    aml_resolver_name: '担当者氏名',
    aml_resolved_date: '解決年月日',
    aml_resolution_notes: '対応記録',
    aml_resolution_notes_placeholder: '対応内容を記録...',
    aml_id_upload: '身分証明書アップロード',
    aml_id_doc: '身分証明書',
    aml_id_front: '表面',
    aml_id_back: '裏面',
    aml_save_resolve: '解決記録を保存',
    aml_resolved_at: '解決処理日時',
    aml_resolver_label: '担当者',
    aml_resolved_date_label: '解決日',
    aml_notes_label: '対応記録',
    aml_id_attached: '身分証明書添付あり',
    aml_image_only: '画像ファイルのみアップロード可能です',
    aml_upload_success: '{side}をアップロードしました',
    aml_upload_failed: 'アップロードに失敗しました',
    aml_name_required: '担当者氏名を入力してください',
    aml_date_required: '解決年月日を入力してください',
    aml_resolve_failed: '解決処理に失敗しました',
    aml_delete_failed: '削除に失敗しました',
    aml_flag_label: 'フラグ',
    aml_name_placeholder: '例: 山田太郎',
    aml_user_id: 'ユーザーID',
    aml_risk_prefix: 'リスク',

    // AML Enhanced
    aml_stats_title: 'AML統計',
    aml_stats_total: '累計フラグ',
    aml_stats_open: '未解決',
    aml_stats_investigating: '調査中',
    aml_stats_resolved: '解決済み',
    aml_stats_false_positive: '誤検知',
    aml_stats_high_risk: '高リスク（未解決）',
    aml_stats_medium_risk: '中リスク（未解決）',
    aml_stats_low_risk: '低リスク（未解決）',
    aml_stats_today: '本日',
    aml_stats_week: '今週',
    aml_stats_month: '今月',
    aml_stats_held: '保留中送金',
    aml_stats_risky_users: '高リスクユーザー',
    aml_settings_title: 'AML設定',
    aml_settings_desc: '検知ルールの閾値を設定',
    aml_settings_high_amount: '高額送金閾値 (JPY)',
    aml_settings_medium_amount: '注意送金額閾値 (JPY)',
    aml_settings_daily_limit: '日次累計上限 (JPY)',
    aml_settings_weekly_limit: '週次累計上限 (JPY)',
    aml_settings_hourly_freq: '1時間内頻度上限 (件)',
    aml_settings_same_recipient: '同一受取人日次上限 (件)',
    aml_settings_new_user_amount: '新規ユーザー高額閾値 (JPY)',
    aml_settings_new_user_days: '新規ユーザー期間 (日)',
    aml_settings_night_start: '深夜開始時刻 (JST)',
    aml_settings_night_end: '深夜終了時刻 (JST)',
    aml_settings_night_threshold: '深夜送金閾値 (JPY)',
    aml_settings_round_threshold: '端数パターン閾値 (JPY)',
    aml_settings_auto_hold: '高リスク時自動保留',
    aml_settings_saved: 'AML設定を保存しました',
    aml_settings_save_failed: 'AML設定の保存に失敗しました',
    aml_tab_flags: 'フラグ一覧',
    aml_tab_stats: '統計',
    aml_tab_settings: '設定',
    aml_tab_users: 'リスクユーザー',
    aml_filter_all: 'すべて',
    aml_filter_open: '未解決',
    aml_filter_investigating: '調査中',
    aml_filter_resolved: '解決済み',
    aml_filter_high: '高リスク',
    aml_filter_medium: '中リスク',
    aml_filter_low: '低リスク',
    aml_set_investigating: '調査中にする',
    aml_user_name: 'ユーザー名',
    aml_user_email: 'メール',
    aml_user_risk_score: 'リスクスコア',
    aml_user_risk_tier: 'リスクレベル',
    aml_risk_critical: '重大',
    aml_flag_type_labels: '検知種別',
    aml_flag_high_amount: '高額送金',
    aml_flag_high_frequency: '高頻度送金',
    aml_flag_daily_limit: '日次上限超過',
    aml_flag_weekly_limit: '週次上限超過',
    aml_flag_same_recipient: '同一受取人集中',
    aml_flag_new_user_high_value: '新規ユーザー高額',
    aml_flag_night_transfer: '深夜送金',
    aml_flag_round_amount_pattern: '端数パターン',

    // Admin Transfers extra
    admin_transfers_edit_title: '送金ステータス編集',
    admin_transfers_completion_info: '送金完了情報',
    admin_transfers_settlement_id: '送金ID明細番号',
    admin_transfers_completed_date: '送金確定年月日',
    admin_transfers_completed_required: '送金確定年月日を入力してください',
    admin_transfers_settled_amount: '送金確定金額',
    admin_transfers_proof: '送金証明書',
    admin_transfers_proof_pdf: '送金証明書PDF',
    admin_transfers_open_new_tab: '新しいタブで開く',
    admin_transfers_not_uploaded: '未アップロード',
    admin_transfers_completed_at: '完了日時',
    admin_transfers_edit_status_btn: 'ステータスを編集',
    admin_transfers_pdf_only: 'PDFファイルのみアップロード可能です',
    admin_transfers_pdf_uploaded: 'PDFをアップロードしました',
    admin_transfers_upload_failed: 'アップロードに失敗しました',
    admin_transfers_status_label: 'ステータス',
    admin_transfers_payment_label: '支払いステータス',
    admin_transfers_settlement_placeholder: '例: TXN-20260315-001',
    admin_transfers_required: '必須',

    // Admin Deposits extra
    admin_deposits_method_label: '入金方法',
    admin_deposits_status_label: 'ステータス',
    admin_deposits_request_date: '申請日時',
    admin_deposits_process_date: '処理日時',
    admin_deposits_memo: 'メモ',
    admin_deposits_user_memo: 'ユーザーメモ',
    admin_deposits_receipt: '振込明細書',
    admin_deposits_click_enlarge: 'クリックして拡大表示',
    admin_deposits_no_receipt: '振込明細なし',
    admin_deposits_reject_confirm_text: 'この入金を拒否しますか？',
    admin_deposits_delete_confirm_text: 'この入金を削除しますか？確認済みの場合、残高から差し引かれます。',

    // Admin Referrals extra
    admin_ref_code_updated: 'コードを更新しました',
    admin_ref_code_update_failed: 'コードの更新に失敗しました',
    admin_ref_code_deleted: 'コードを削除しました',
    admin_ref_delete_failed: '削除に失敗しました',
    admin_ref_delete_confirm: '紹介コード「{code}」を削除しますか？',

    // Admin Users extra
    admin_users_details_btn: '詳細',
    admin_users_balance_manage: '残高管理',
    admin_users_edit_btn: '編集',
    admin_users_delete_btn: '削除',
    admin_users_amount_placeholder: '金額を入力',

    // Admin Settings extra
    admin_settings_account_type_default: '普通',
    admin_settings_branch_placeholder: '本店',
    admin_settings_notes_placeholder: '振込時の注意事項など',

    // Additional missing keys
    print: '印刷',
    clear_filter: 'クリア',
    date_start: '開始日',
    date_end: '終了日',
    admin_ref_code_col: '紹介コード',
    admin_ref_user_col: 'ユーザー',
    admin_ref_count_col: '紹介数',
    admin_ref_completed_col: '完了数',
    admin_ref_issued_col: '発行日',
    admin_ref_actions_col: '操作',
    admin_ref_no_codes: '発行されたコードはありません',
    admin_deposits_detail_title: '入金詳細',
    admin_deposits_user_col: 'ユーザー',
    admin_deposits_amount_col: '金額',
    admin_deposits_receipt_col: '明細書',
    admin_reports_fetch_failed: 'データの取得に失敗しました',
    admin_transfers_payment_status: '支払いステータス',
    approve: '承認',
    reject: '拒否',
    uploading: 'アップロード中...',

    // Transfer limit
    admin_users_transfer_limit: '送金限度額',
    admin_users_transfer_limit_placeholder: '例: 500000（空欄＝制限なし）',
    admin_users_transfer_limit_hint: '1回あたりの送金上限額（JPY）。空欄の場合は制限なし',
    send_transfer_limit: '送金限度額',
    send_over_limit: '送金限度額を超えています',
    send_over_limit_msg: '1回あたりの送金上限は ¥{limit} です',
  },

  pt: {
    // Common
    login: 'Entrar',
    logout: 'Sair',
    register: 'Cadastrar',
    email: 'E-mail',
    password: 'Senha',
    name: 'Nome completo',
    phone: 'Telefone',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    update: 'Atualizar',
    withdraw: 'Saque',
    deposit_method: 'Método de depósito',
    confirm: 'Confirmar',
    loading: 'Carregando...',
    back: 'Voltar',
    submit: 'Enviar',
    search: 'Buscar',
    processing: 'Processando...',
    fee: 'Taxa',
    total: 'Total',
    amount: 'Valor',
    balance: 'Saldo',
    bank_account: 'Conta bancária',

    // Landing Page
    landing_login: 'Entrar',
    landing_hero_title_1: 'Do Japão para o Brasil',
    landing_hero_title_2: 'Fácil e seguro',
    landing_hero_title_3: 'Remessa',
    landing_hero_desc: 'Envie dinheiro em 3 cliques. Transferências rápidas e baratas para quem você ama.',
    landing_cta: 'Começar agora',
    landing_calculator: 'Calculadora de câmbio',
    landing_fee_label: 'Taxa de envio',
    landing_arrival: 'Entrega',
    landing_click_send: 'Cliques',
    landing_send_amount: 'Valor do envio',
    landing_why_title: 'Por que PRC Remit?',
    landing_why_subtitle: 'Transferências internacionais seguras e convenientes',
    landing_feature_fast: 'Envio rápido',
    landing_feature_fast_desc: 'Suporte PIX para entrega quase instantânea. Transferências bancárias em até 24 horas.',
    landing_feature_secure: 'Seguro',
    landing_feature_secure_desc: 'Operador licenciado. Conformidade total com KYC/AML para sua tranquilidade.',
    landing_feature_cheap: 'Baixo custo',
    landing_feature_cheap_desc: 'Taxa a partir de ¥{fee}. Preços transparentes sem custos ocultos.',
    landing_how_title: 'Como funciona',
    landing_how_subtitle: 'Envie dinheiro em 3 passos simples',
    landing_step1_title: 'Crie sua conta',
    landing_step1_desc: 'Cadastre-se com e-mail e senha. Complete a verificação de identidade (KYC).',
    landing_step2_title: 'Adicione destinatário',
    landing_step2_desc: 'Registre os dados do destinatário no Brasil (chave PIX ou conta bancária).',
    landing_step3_title: 'Envie dinheiro',
    landing_step3_desc: 'Digite o valor e envie. Pague via transferência bancária e o processamento começa imediatamente.',
    landing_pricing_title: 'Preços',
    landing_pricing_subtitle: 'Preços simples e transparentes',
    landing_per_transfer: 'por envio',
    landing_exchange_rate: 'Câmbio',
    landing_market_rate: 'Taxa de mercado',
    landing_markup_about: 'Markup aprox. {rate}%',
    landing_no_hidden: 'Sem taxas ocultas',
    landing_pix_bank: 'PIX e transferência bancária',
    landing_24h_support: 'Suporte 24/7',
    landing_cta_title: 'Comece a enviar dinheiro hoje',
    landing_cta_desc: 'Cadastro gratuito. Comece em minutos.',
    landing_cta_button: 'Criar conta grátis',
    landing_footer_desc: 'Remessa internacional do Japão para o Brasil. Seguro e conveniente.',
    landing_footer_service: 'Serviços',
    landing_footer_company: 'Empresa',
    landing_footer_transfer_methods: 'Métodos de envio',
    landing_footer_pricing: 'Preços',
    landing_footer_docs: 'Documentacao',
    pwa_install_title: 'Instalar aplicativo',
    pwa_install_desc: 'Adicione a tela inicial para acesso rapido',
    pwa_install_btn: 'Instalar',
    pwa_ios_title: 'Adicionar a tela inicial',
    pwa_ios_desc: 'Siga os passos abaixo para instalar o app',
    pwa_ios_step1: 'Toque no botao de compartilhar (↑) na parte inferior do Safari',
    pwa_ios_step2: 'Selecione "Adicionar a Tela de Inicio"',
    pwa_ios_step3: 'Toque em "Adicionar" para concluir',
    pwa_ios_close: 'Fechar',
    landing_footer_about: 'Sobre nós',
    landing_footer_terms: 'Termos de uso',
    landing_footer_privacy: 'Privacidade',
    landing_footer_admin: 'Login admin',

    // Send Money
    send_title: 'Enviar dinheiro',
    send_subtitle: 'Transferir do saldo para o Brasil',
    send_balance: 'Saldo disponível',
    send_insufficient: 'Saldo insuficiente (falta: ¥{amount})',
    send_kyc_required_title: 'Verificação KYC necessária',
    send_kyc_required_desc: 'Complete a verificação de identidade antes de enviar.',
    send_step1: 'Digite o valor',
    send_amount_label: 'Valor',
    send_amount: 'Valor do envio',
    send_fee: 'Taxa',
    send_total: 'Total a pagar',
    send_deduct: 'Deduzir do saldo',
    send_receive: 'Destinatário recebe',
    send_rate: 'Câmbio',
    send_step2: 'Selecionar destinatário',
    send_no_recipients: 'Nenhum destinatário cadastrado',
    send_add_recipient: 'Adicionar destinatário',
    send_recipient_label: 'Destinatário',
    send_select_recipient: 'Selecionar destinatário...',
    send_btn_processing: 'Processando...',
    send_btn_insufficient: 'Saldo insuficiente',
    send_btn_submit: 'Enviar do saldo',
    send_go_deposit: 'Ir para depósito',
    send_success_title: 'Envio concluído',
    send_success_desc: 'Deduzido do saldo e o processamento foi iniciado',
    send_success_toast: 'Envio concluído! Deduzido do seu saldo.',
    send_error: 'Falha no envio',
    send_kyc_error: 'Verificação KYC necessária',
    send_select_error: 'Selecione um destinatário',
    send_balance_error: 'Saldo insuficiente. Deposite primeiro.',
    send_id: 'ID do envio',
    send_total_deducted: 'Total deduzido',
    send_go_history: 'Ver histórico',
    send_new: 'Nova transferência',
    send_currency_hint_jpy: 'A taxa será deduzida do valor enviado',
    send_currency_hint_brl: 'Especifique o valor que o destinatário receberá (taxa adicionada separadamente)',
    send_fee_exceeds: 'O valor é menor que a taxa. Aumente o valor.',
    send_input_amount: 'Valor digitado',
    send_net_amount: 'Após dedução da taxa',
    send_total_debit: 'Deduzido do saldo',
    send_free_transfer: 'Beneficio: Transferencia gratis!',
    send_tier_discount: 'Nivel: {percent}% de desconto na taxa',
    nav_referral: 'Indicacoes',
    ref_title: 'Programa de Indicacao',
    ref_subtitle: 'Convide amigos e ganhe transferencias gratis!',
    ref_total: 'Total de Indicacoes',
    ref_completed: 'Concluidas',
    ref_pending: 'Pendentes',
    ref_free_transfers: 'Transferencias Gratis',
    ref_your_code: 'Seu Codigo de Indicacao',
    ref_link_copied: 'Link copiado',
    ref_code_copied: 'Codigo copiado',
    ref_share_message: 'Envie dinheiro do Japao para o Brasil facilmente com PRC Remit! Registre-se agora: {link}',
    ref_share_subject: 'PRC Remit - Transferencia Japao para Brasil',
    ref_email: 'Email',
    ref_tier_title: 'Bonus de Nivel',
    ref_current_tier: 'Nivel Atual',
    ref_fee_discount: 'Desconto na Taxa',
    ref_people: 'pessoas',
    ref_history: 'Historico de Indicacoes',
    ref_no_referrals: 'Sem indicacoes ainda. Compartilhe seu codigo!',
    ref_status_completed: 'Concluido',
    ref_status_pending: 'Pendente',
    register_referral_code: 'Codigo de indicacao (opcional)',
    register_referral_applied: 'Codigo aplicado! Primeira transferencia gratis',
    admin_nav_referrals: 'Indicacoes',
    admin_ref_title: 'Gestao de Indicacoes',
    admin_ref_total: 'Total',
    admin_ref_completed: 'Concluidas',
    admin_ref_pending: 'Pendentes',
    admin_ref_codes: 'Codigos Emitidos',
    admin_ref_tab_list: 'Lista',
    admin_ref_tab_settings: 'Configuracoes',
    admin_ref_referrer: 'Indicador',
    admin_ref_referee: 'Indicado',
    admin_ref_status: 'Status',
    admin_ref_date: 'Data',
    admin_ref_empty: 'Sem dados de indicacao',
    admin_ref_referrer_reward: 'Recompensa do indicador',
    admin_ref_referee_reward: 'Recompensa do indicado',
    admin_ref_free_desc: 'Concedido ao completar primeira transferencia',
    admin_ref_min_amount: 'Valor minimo',
    admin_ref_tier_enabled: 'Habilitar bonus de nivel',
    admin_ref_tier_config: 'Configuracao de Niveis',
    admin_ref_tier_name: 'Nome do Nivel',
    admin_ref_tier_min: 'Indicacoes Minimas',
    admin_ref_tier_discount: 'Desconto (%)',
    admin_ref_settings_saved: 'Configuracoes de indicacao salvas',
    send_new: 'Novo envio',

    // Transfer History
    history_title: 'Histórico de envios',
    history_subtitle: 'Seus registros de envio',
    history_empty_title: 'Sem histórico de envios',
    history_empty_desc: 'Seus envios aparecerão aqui',
    history_amount: 'Valor',

    // Exchange Calculator
    calc_title: 'Calculadora de Câmbio',
    calc_subtitle: 'Simule antes de enviar',
    calc_amount_label: 'Valor a enviar (JPY)',
    calc_amount: 'Valor do envio',
    calc_note: '* As taxas de câmbio flutuam. A taxa final é determinada no momento do envio.',

    // Login
    login_success: 'Login realizado',
    login_error: 'Falha no login',
    login_bio_success: 'Login biométrico realizado',
    login_bio_error: 'Falha na biometria. Use a senha.',
    login_go_register: 'Entrar',

    // Register
    register_go_login: 'Entrar',

    // Status
    status_pending: 'Pendente',
    status_processing: 'Processando',
    status_completed: 'Concluído',
    status_failed: 'Falhou',
    status_cancelled: 'Cancelado',
    history_payment_status: 'Status pagamento',
    payment_awaiting: 'Aguardando',
    payment_paid: 'Pago',
    payment_confirmed: 'Confirmado',

    // Calculator extra
    calc_rate_title: 'Informações do câmbio',
    calc_market_rate: 'Taxa de mercado',
    calc_markup: 'Markup',
    calc_applied_rate: 'Taxa aplicada',
    close: 'Fechar',
    create: 'Criar',
    actions: 'Ações',
    details: 'Detalhes',
    status: 'Status',
    date: 'Data',
    amount: 'Valor',
    method: 'Método',
    note: 'Observação',
    all: 'Todos',
    active: 'Ativo',
    suspended: 'Suspenso',
    restricted: 'Restrito',
    user: 'Usuário',
    admin: 'Admin',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    submitted: 'Enviado',
    confirmed: 'Confirmado',
    processing: 'Processando',
    completed: 'Concluído',
    failed: 'Falhou',
    cancelled: 'Cancelado',
    yes: 'Sim',
    no: 'Não',
    none: 'Nenhum',
    total: 'Total',
    jpy: 'JPY',
    brl: 'BRL',

    // Nav
    nav_dashboard: 'Painel',
    nav_deposit: 'Depósito',
    nav_send: 'Enviar',
    nav_recipients: 'Destinatários',
    nav_history: 'Histórico',
    nav_exchange: 'Câmbio',
    nav_kyc: 'Verificação KYC',
    nav_income_cert: 'Comprovante de renda',
    nav_residence_card: 'Cartão de residência',
    nav_notifications: 'Notificações',
    nav_profile: 'Perfil',
    nav_support: 'Suporte',

    // Dashboard
    dashboard_greeting: 'Olá, {name}',
    dashboard_welcome: 'Bem-vindo ao painel PRC Remit',
    dashboard_balance: 'Saldo',
    dashboard_transfer_count: 'Transferências',
    dashboard_total_sent: 'Total enviado',
    dashboard_deposit_btn: 'Depositar',
    dashboard_send_btn: 'Enviar',
    dashboard_send_money: 'Enviar dinheiro',
    dashboard_send_desc: 'Enviar para o Brasil',
    dashboard_recipients: 'Destinatários',
    dashboard_recipients_desc: 'Adicionar e editar',
    dashboard_history: 'Histórico',
    dashboard_history_desc: 'Ver transferências anteriores',
    dashboard_exchange_rate: 'Taxa de câmbio atual',
    dashboard_per_jpy: 'por 1 JPY',
    dashboard_open_calc: 'Abrir calculadora',
    dashboard_recent: 'Transferências recentes',
    dashboard_view_all: 'Ver tudo',
    dashboard_no_transfers: 'Nenhuma transferência ainda',
    dashboard_first_transfer: 'Fazer primeira transferência',

    // KYC
    kyc_required: 'Verificação KYC necessária',
    kyc_required_desc: 'Complete a verificação de identidade para enviar dinheiro.',
    kyc_start: 'Iniciar verificação KYC',
    kyc_title: 'Verificação de Identidade (KYC)',
    kyc_subtitle: 'Complete a verificação para transferências seguras',
    kyc_status_title: 'KYC Enviado',
    kyc_status_under_review: 'Em análise. Aguarde a confirmação.',
    kyc_status_approved: 'KYC Aprovado',
    kyc_status_approved_desc: 'Sua identidade foi verificada. Você pode enviar dinheiro.',
    kyc_status_rejected: 'KYC Rejeitado',
    kyc_status_rejected_desc: 'Sua verificação foi rejeitada. Por favor, reenvie.',
    kyc_resubmit: 'Reenviar',
    kyc_submit_form: 'Enviar documentos de identidade',
    kyc_doc_type: 'Tipo de documento',
    kyc_doc_type_passport: 'Passaporte',
    kyc_doc_type_residence: 'Cartão de residência',
    kyc_doc_type_license: 'Carteira de motorista',
    kyc_doc_number: 'Número do documento',
    kyc_full_name: 'Nome completo (como no documento)',
    kyc_dob: 'Data de nascimento',
    kyc_address: 'Endereço',
    kyc_occupation: 'Profissão',
    kyc_purpose: 'Objetivo da transferência',
    kyc_purpose_family: 'Envio para família',
    kyc_purpose_savings: 'Poupança/Investimento',
    kyc_purpose_education: 'Educação',
    kyc_purpose_business: 'Negócios',
    kyc_purpose_other: 'Outro',
    kyc_documents: 'Documentos de identidade (imagem/PDF, até 3)',
    kyc_upload: 'Clique para selecionar arquivo',
    kyc_upload_limit: 'Limite de upload atingido',
    kyc_upload_desc: 'Frente e verso (JPEG, PNG, WebP, PDF - máx 10MB)',
    kyc_uploading: 'Enviando...',
    kyc_submit_btn: 'Enviar documentos KYC',
    kyc_submitting: 'Enviando...',
    kyc_submitted_docs: 'Documentos enviados',
    kyc_submitted_at: 'Data de envio',

    // Status
    status_pending: 'Pendente',
    status_processing: 'Processando',
    status_completed: 'Concluído',
    status_failed: 'Falhou',
    status_cancelled: 'Cancelado',

    // Login
    login_title: 'Entrar',
    login_desc: 'Faça login na sua conta',
    login_no_account: 'Não tem uma conta?',
    login_error: 'E-mail ou senha incorretos',
    login_biometric: 'Login com biometria',
    login_bio_required_title: 'Autenticação biométrica necessária',
    login_bio_required_desc: 'Esta conta possui autenticação biométrica configurada. Por favor, autentique com sua impressão digital ou Face ID.',
    login_bio_verify: 'Verificar com biometria',
    login_bio_locked: 'Número máximo de tentativas excedido. Faça login com senha.',
    login_bio_locked_hint: 'A autenticação biométrica foi temporariamente bloqueada. Faça login com senha.',
    login_bio_waiting: 'Verificando biometria...',
    login_bio_attempts: 'Tentativas: {{current}}/{{max}}',
    login_bio_error: 'Falha na autenticação biométrica',
    login_use_password: 'Login com senha',
    login_2fa_title: 'Autenticação em dois fatores',
    login_2fa_desc: 'Digite o código de 6 dígitos do seu aplicativo autenticador',
    login_2fa_verify: 'Verificar',
    login_2fa_verifying: 'Verificando...',
    login_2fa_back: 'Voltar',

    // Register
    register_title: 'Cadastrar',
    register_desc: 'Crie sua conta',
    register_has_account: 'Já tem uma conta?',
    register_btn: 'Cadastrar',
    register_registering: 'Cadastrando...',

    // Deposit
    deposit_title: 'Saldo e Depósitos',
    deposit_subtitle: 'Deposite para usar nas transferências',
    deposit_card_title: 'Cartão de crédito',
    deposit_card_subtitle: 'Crédito imediato',
    deposit_card_btn: 'Depositar com cartão',
    deposit_card_processing: 'Processando...',
    deposit_bank_title: 'Transferência bancária',
    deposit_bank_subtitle: 'Confirmação manual',
    deposit_bank_info: 'Dados bancários',
    deposit_bank_name: 'Banco',
    deposit_branch_name: 'Agência',
    deposit_account_type: 'Tipo de conta',
    deposit_account_number: 'Número da conta',
    deposit_account_holder: 'Titular',
    deposit_amount: 'Valor do depósito (JPY)',
    deposit_reference: 'Nome do depositante / Referência',
    deposit_receipt: 'Comprovante (opcional)',
    deposit_submit: 'Enviar solicitação',
    deposit_history: 'Histórico de depósitos',
    deposit_no_history: 'Nenhum depósito ainda',
    deposit_select_amount: 'Selecione o valor',
    deposit_success_title: 'Depósito concluído',
    deposit_success_reflected: 'Saldo atualizado',
    deposit_success_go_dashboard: 'Ir ao painel',
    deposit_pending_title: 'Processando',
    deposit_pending_desc: 'Pagamento em processamento. Aguarde.',
    deposit_pending_back: 'Voltar aos depósitos',
    deposit_error_title: 'Erro',
    deposit_error_desc: 'Falha na verificação do pagamento',
    deposit_checking: 'Verificando pagamento...',

    // Send Money
    send_title: 'Enviar dinheiro',
    send_subtitle: 'Envie dinheiro para o Brasil com segurança',
    send_select_recipient: 'Selecionar destinatário',
    send_add_recipient: 'Adicionar novo destinatário',
    send_amount_jpy: 'Valor (JPY)',
    send_fee: 'Taxa',
    send_exchange_rate: 'Taxa de câmbio',
    send_recipient_gets: 'Valor recebido',
    send_total: 'Total debitado',
    send_balance: 'Saldo',
    send_insufficient: 'Saldo insuficiente',
    send_deposit_first: 'Ir para depósitos',
    send_confirm: 'Confirmar envio',
    send_confirm_title: 'Confirmar transferência',
    send_confirm_desc: 'Deseja enviar com os dados abaixo?',
    send_recipient: 'Destinatário',
    send_execute: 'Enviar agora',
    send_executing: 'Processando...',
    send_complete_title: 'Envio concluído',
    send_complete_desc: 'Sua transferência foi processada',
    send_transfer_id: 'ID da transferência',
    send_view_history: 'Ver histórico',
    send_new_transfer: 'Nova transferência',

    // Recipients
    recipients_title: 'Destinatários',
    recipients_subtitle: 'Gerenciar destinatários no Brasil',
    recipients_add: 'Adicionar destinatário',
    recipients_none: 'Nenhum destinatário cadastrado',
    recipients_add_first: 'Adicione seu primeiro destinatário',
    recipients_name: 'Nome do destinatário',
    recipients_bank: 'Banco',
    recipients_branch: 'Código da agência',
    recipients_account: 'Número da conta',
    recipients_type: 'Tipo de conta',
    recipients_pix: 'Chave PIX',
    recipients_cpf: 'CPF',
    recipients_relationship: 'Relação',
    recipients_edit: 'Editar destinatário',
    recipients_delete_confirm: 'Excluir este destinatário?',
    recipients_checking: 'Corrente',
    recipients_savings: 'Poupança',

    // Transfer History
    history_title: 'Histórico de transferências',
    history_subtitle: 'Registro de transferências anteriores',
    history_no_records: 'Nenhuma transferência ainda',
    history_first_send: 'Faça sua primeira transferência',
    history_go_send: 'Ir para envio',
    history_recipient: 'Destinatário',
    history_amount: 'Valor',
    history_fee: 'Taxa',
    history_rate: 'Taxa câmbio',
    history_date: 'Data',

    // Exchange Calculator
    exchange_title: 'Calculadora de câmbio',
    exchange_subtitle: 'JPY → BRL Taxa em tempo real',
    exchange_amount_label: 'Valor (JPY)',
    exchange_result: 'Valor recebido (BRL)',
    exchange_rate_label: 'Taxa de câmbio',
    exchange_fee_label: 'Taxa',
    exchange_total_label: 'Total debitado',
    exchange_live: 'Taxa ao vivo',

    // Profile
    profile_title: 'Perfil',
    profile_subtitle: 'Ver e editar informações da conta',
    profile_personal: 'Informações pessoais',
    profile_address: 'Endereço',
    profile_dob: 'Data de nascimento',
    profile_occupation: 'Profissão',
    profile_income: 'Renda anual',
    profile_update: 'Atualizar perfil',
    profile_updating: 'Atualizando...',
    profile_photo: 'Foto do perfil',
    profile_stats: 'Estatísticas',
    profile_total_transfers: 'Total de transferências',
    profile_total_amount: 'Total enviado',
    profile_total_recipients: 'Destinatários cadastrados',
    profile_biometric: 'Autenticação biométrica',
    profile_biometric_not_supported: 'Biometria não suportada neste navegador',
    profile_biometric_register: 'Registrar biometria',
    profile_biometric_add: 'Adicionar outro dispositivo',
    profile_biometric_max: 'Limite de registro (5) atingido',
    profile_biometric_registering: 'Registrando...',
    profile_biometric_device: 'Dispositivo',
    profile_biometric_registered: 'Registrado em',
    profile_2fa_title: 'Autenticação em dois fatores (2FA)',
    profile_2fa_enabled: 'Ativado',
    profile_2fa_disabled: 'Desativado',
    profile_2fa_totp: 'Aplicativo TOTP',
    profile_2fa_active: 'Autenticação em dois fatores ativada',
    profile_2fa_enter_code: 'Digite o código',
    profile_2fa_disable: 'Desativar',
    profile_2fa_setup: 'Configurar 2FA',
    profile_2fa_setup_title: 'Configurar autenticação em dois fatores',
    profile_2fa_scan_desc: 'Escaneie o QR code com um aplicativo autenticador como Google Authenticator.',
    profile_2fa_manual: 'Chave secreta para inserção manual:',
    profile_2fa_code_label: 'Código de verificação',
    profile_2fa_code_placeholder: 'Código de 6 dígitos',
    profile_2fa_activate: 'Ativar',

    // Support
    support_title: 'Suporte',
    support_subtitle: 'Entre em contato se precisar de ajuda',
    support_faq: 'Perguntas frequentes',
    support_contact: 'Contato',
    support_email: 'E-mail de contato',
    support_hours: 'Horário de atendimento',
    support_hours_value: 'Dias úteis 9:00 - 18:00',

    // Notifications
    notif_title: 'Notificações',
    notif_mark_all: 'Marcar tudo como lido',
    notif_empty: 'Nenhuma notificação',
    notif_view_all: 'Ver todas as notificações',
    notif_page_title: 'Notificações',
    notif_page_subtitle: 'Avisos e atualizações',
    notif_total: 'Total',
    notif_unread: 'Não lidas',
    notif_read: 'Lidas',
    notif_clear_read: 'Limpar lidas',
    notif_filter_all: 'Todas',
    notif_filter_unread: 'Não lidas',
    notif_filter_read: 'Lidas',
    notif_filter_empty: 'Nenhuma notificação encontrada',
    notif_view_detail: 'Ver detalhes',
    notif_mark_read: 'Marcar como lido',

    // Admin Nav
    admin_nav_dashboard: 'Painel',
    admin_nav_users: 'Usuários',
    admin_nav_transfers: 'Transferências',
    admin_nav_deposits: 'Depósitos',
    admin_nav_kyc: 'Verificação KYC',
    admin_nav_income_cert: 'Comprovante de renda',
    admin_nav_residence_card: 'Cartão de residência',
    admin_nav_email: 'E-mail',
    admin_nav_aml: 'Monitoramento AML',
    admin_nav_balance_cert: 'Certificados de saldo',

    // Balance Certificate
    bal_cert_title: 'Certificados de saldo',
    bal_cert_subtitle: 'Gerenciar emissão e envio de certificados de saldo',
    bal_cert_send_all: 'Enviar para todos',
    bal_cert_send_all_confirm: 'Enviar certificados de saldo para todos os usuários?',
    bal_cert_sent: '{count} certificados enviados',
    bal_cert_send_failed: 'Falha ao enviar',
    bal_cert_delete_confirm: 'Excluir este registro?',
    bal_cert_schedule_settings: 'Configurar agendamento',
    bal_cert_schedule_desc: 'Configurar envio automático de certificados de saldo',
    bal_cert_schedule_saved: 'Agendamento salvo',
    bal_cert_auto_schedule: 'Agendamento automático',
    bal_cert_auto_enabled: 'Ativar envio automático',
    bal_cert_schedule_disabled: 'Desativado',
    bal_cert_day_of_week: 'Dia da semana',
    bal_cert_hour: 'Hora',
    bal_cert_minute: 'Minuto',
    bal_cert_col_date: 'Data de emissão',
    bal_cert_col_user: 'Usuário',
    bal_cert_col_balance: 'Saldo',
    bal_cert_col_email_status: 'E-mail',
    bal_cert_col_type: 'Tipo',
    bal_cert_sent_status: 'Enviado',
    bal_cert_unsent_status: 'Não enviado',
    bal_cert_type_auto: 'Auto',
    bal_cert_type_manual: 'Manual',
    bal_cert_empty: 'Nenhum certificado encontrado',
    bal_cert_detail_title: 'Detalhes do certificado',
    bal_cert_sent_at: 'Enviado em',
    day_monday: 'Segunda',
    day_tuesday: 'Terça',
    day_wednesday: 'Quarta',
    day_thursday: 'Quinta',
    day_friday: 'Sexta',
    day_saturday: 'Sábado',
    day_sunday: 'Domingo',
    admin_nav_reports: 'Relatórios',
    admin_nav_settings: 'Configurações',
    admin_nav_company: 'Empresa',

    // Company Profile
    company_admin_title: 'Perfil da empresa',
    company_admin_subtitle: 'Gerencie as informações exibidas na página pública',
    company_page_title: 'Sobre a empresa',
    company_page_subtitle: 'Sobre a PRC Remit',
    company_back: 'Voltar',
    company_no_data: 'Informações da empresa ainda não cadastradas',
    company_company_name: 'Nome da empresa',
    company_representative: 'Representante',
    company_established: 'Fundação',
    company_capital: 'Capital social',
    company_license_number: 'Número de registro',
    company_address: 'Endereço',
    company_phone: 'Telefone',
    company_email: 'E-mail',
    company_website: 'Website',
    company_business_description: 'Descrição do negócio',
    company_save_btn: 'Salvar',
    company_saved: 'Informações atualizadas',
    company_save_failed: 'Falha ao salvar',

    // Legal Pages (Terms & Privacy)
    admin_nav_terms: 'Termos de uso',
    admin_nav_privacy: 'Privacidade',
    legal_title_label: 'Título',
    legal_revised_label: 'Última revisão',
    legal_content_label: 'Conteúdo',
    legal_content_hint: 'Quebras de linha são preservadas',
    legal_last_revised: 'Última revisão',
    legal_no_data: 'Ainda não cadastrado',
    terms_admin_title: 'Termos de uso',
    terms_admin_subtitle: 'Gerencie os termos de uso exibidos no site',
    terms_page_title: 'Termos de uso',
    terms_title_placeholder: 'Termos de uso da PRC Remit',
    terms_content_placeholder: 'Insira o conteúdo dos termos de uso...',
    terms_save_btn: 'Salvar termos',
    terms_saved: 'Termos atualizados',
    terms_save_failed: 'Falha ao salvar',
    privacy_admin_title: 'Política de privacidade',
    privacy_admin_subtitle: 'Gerencie a política de privacidade exibida no site',
    privacy_page_title: 'Política de privacidade',
    privacy_title_placeholder: 'Política de privacidade da PRC Remit',
    privacy_content_placeholder: 'Insira o conteúdo da política de privacidade...',
    privacy_save_btn: 'Salvar política',
    privacy_saved: 'Política atualizada',
    privacy_save_failed: 'Falha ao salvar',

    // Content Pages
    content_save_failed: 'Falha ao salvar',
    admin_nav_transfer_methods: 'Métodos de envio',
    admin_nav_pricing: 'Preços',
    admin_nav_faq: 'FAQ',
    admin_nav_footer: 'Rodapé',
    tm_admin_title: 'Métodos de envio',
    tm_admin_subtitle: 'Gerencie os métodos de envio exibidos no site',
    tm_page_title: 'Métodos de envio',
    tm_title_placeholder: 'Métodos de envio PRC Remit',
    tm_content_placeholder: 'Insira o conteúdo...',
    tm_save_btn: 'Salvar',
    transfer_methods_saved: 'Métodos atualizados',
    pricing_admin_title: 'Preços',
    pricing_admin_subtitle: 'Gerencie as informações de preços',
    pricing_page_title: 'Preços',
    pricing_title_placeholder: 'Preços PRC Remit',
    pricing_content_placeholder: 'Insira as informações de preços...',
    pricing_save_btn: 'Salvar',
    pricing_saved: 'Preços atualizados',
    faq_admin_title: 'FAQ',
    faq_admin_subtitle: 'Gerencie perguntas frequentes',
    faq_page_title: 'Perguntas frequentes',
    faq_page_subtitle: 'Dúvidas sobre a PRC Remit',
    faq_add: 'Adicionar',
    faq_save_btn: 'Salvar FAQ',
    faq_saved: 'FAQ atualizado',
    faq_empty: 'Nenhuma pergunta cadastrada',
    faq_question_placeholder: 'Pergunta',
    faq_answer_placeholder: 'Resposta',
    footer_admin_title: 'Rodapé',
    footer_admin_subtitle: 'Texto exibido no rodapé da página inicial',
    footer_text_label: 'Texto do rodapé',
    footer_text_hint: 'Exibido na parte inferior da página inicial',
    footer_preview: 'Pré-visualização',
    footer_save_btn: 'Salvar rodapé',
    footer_saved: 'Rodapé atualizado',
    admin_title: 'Admin',

    // Admin Dashboard
    admin_dash_total_users: 'Total de usuários',
    admin_dash_total_transfers: 'Total de transferências',
    admin_dash_pending_kyc: 'KYC pendentes',
    admin_dash_aml_flags: 'Alertas AML',

    // Admin Users
    admin_users_title: 'Gerenciar usuários',
    admin_users_subtitle: 'Gerenciar e editar usuários',
    admin_users_create: 'Novo usuário',
    admin_users_edit: 'Editar usuário',
    admin_users_role_admin: 'Administrador',
    admin_users_role_user: 'Usuário',
    admin_users_create_desc: 'Criar usuário como administrador',
    admin_users_search: 'Buscar usuários...',
    admin_users_actions: 'Ações',
    admin_users_balance: 'Saldo',
    admin_users_role: 'Função',
    admin_users_kyc: 'KYC',
    admin_users_status: 'Status',
    admin_users_no_results: 'Nenhum usuário encontrado',
    admin_users_create_title: 'Criar usuário',
    admin_users_edit_title: 'Editar usuário',
    admin_users_kyc_status: 'Status KYC',
    admin_users_account_status: 'Status da conta',
    admin_users_initial_balance: 'Saldo inicial (JPY)',
    admin_users_not_submitted: 'Não enviado',
    admin_users_balance_adjust: 'Ajustar saldo',
    admin_users_balance_add: 'Adicionar',
    admin_users_balance_subtract: 'Subtrair',
    admin_users_balance_amount: 'Valor',
    admin_users_balance_reason: 'Motivo',
    admin_users_balance_current: 'Saldo atual',
    admin_users_balance_after: 'Saldo após ajuste',
    admin_users_detail_title: 'Detalhes do usuário',
    admin_users_basic_info: 'Informações básicas',
    admin_users_deposit_history: 'Histórico de depósitos',
    admin_users_transfer_history: 'Histórico de transferências',
    admin_users_no_deposits: 'Sem depósitos',
    admin_users_no_transfers: 'Sem transferências',
    admin_users_delete_confirm: 'Excluir este usuário? Esta ação não pode ser desfeita.',

    // Admin Transfers
    admin_transfers_title: 'Gerenciar transferências',
    admin_transfers_subtitle: 'Gerenciar e alterar status',
    admin_transfers_search: 'Buscar transferências...',
    admin_transfers_filter_status: 'Filtrar por status',
    admin_transfers_sender: 'Remetente',
    admin_transfers_recipient: 'Destinatário',
    admin_transfers_amount_jpy: 'Valor (JPY)',
    admin_transfers_amount_brl: 'Valor (BRL)',
    admin_transfers_rate: 'Taxa',
    admin_transfers_fee: 'Taxa',
    admin_transfers_no_results: 'Nenhuma transferência encontrada',
    admin_transfers_detail: 'Detalhes da transferência',
    admin_transfers_edit: 'Editar status',
    admin_transfers_delete_confirm: 'Excluir esta transferência?',

    // Admin Deposits
    admin_deposits_title: 'Gerenciar depósitos',
    admin_deposits_subtitle: 'Gerenciar e aprovar depósitos',
    admin_deposits_create: 'Adicionar depósito',
    admin_deposits_search: 'Buscar depósitos...',
    admin_deposits_filter_status: 'Filtrar por status',
    admin_deposits_user: 'Usuário',
    admin_deposits_no_results: 'Nenhum depósito encontrado',
    admin_deposits_deposit_id: 'ID do depósito',
    admin_deposits_detail: 'Detalhes do depósito',
    admin_deposits_edit: 'Editar depósito',
    admin_deposits_approve: 'Aprovar',
    admin_deposits_reject: 'Rejeitar',
    admin_deposits_delete_confirm: 'Excluir este depósito?',
    admin_deposits_create_title: 'Adicionar depósito',
    admin_deposits_user_id: 'ID do usuário',

    // Admin KYC
    admin_kyc_title: 'Verificação KYC',
    admin_kyc_subtitle: 'Revisar documentos de identidade',
    admin_kyc_search: 'Buscar KYC...',
    admin_kyc_filter_status: 'Filtrar por status',
    admin_kyc_doc_type: 'Tipo de documento',
    admin_kyc_doc_number: 'Número do documento',
    admin_kyc_submitted_at: 'Data de envio',
    admin_kyc_no_results: 'Nenhuma solicitação KYC encontrada',
    admin_kyc_approve: 'Aprovar',
    admin_kyc_reject: 'Rejeitar',
    admin_kyc_edit: 'Editar KYC',
    admin_kyc_documents: 'Documentos enviados',
    admin_kyc_preview: 'Pré-visualização',
    admin_kyc_purpose: 'Objetivo da transferência',
    admin_kyc_passport: 'Passaporte',
    admin_kyc_residence_card: 'Cartão de residência',
    admin_kyc_drivers_license: 'Carteira de motorista',

    // Admin AML
    admin_aml_title: 'Monitoramento AML',
    admin_aml_subtitle: 'Prevenção à lavagem de dinheiro',
    admin_aml_search: 'Buscar alertas AML...',
    admin_aml_user: 'Usuário',
    admin_aml_flag_type: 'Tipo de alerta',
    admin_aml_risk_level: 'Nível de risco',
    admin_aml_description: 'Descrição',
    admin_aml_transfer_id: 'ID da transferência',
    admin_aml_no_results: 'Nenhum alerta AML encontrado',
    admin_aml_delete_confirm: 'Excluir este alerta AML?',
    admin_aml_risk_high: 'Alto',
    admin_aml_risk_medium: 'Médio',
    admin_aml_risk_low: 'Baixo',

    // Admin Reports
    admin_reports_title: 'Relatórios',
    admin_reports_subtitle: 'Estatísticas de transferências, usuários e receita',
    admin_reports_total_transfers: 'Total de transferências',
    admin_reports_total_volume: 'Volume total',
    admin_reports_fee_revenue: 'Receita de taxas',
    admin_reports_total_users: 'Total de usuários',
    admin_reports_this_month: 'Este mês',
    admin_reports_kyc_approved: 'KYC aprovados',
    admin_reports_daily_chart: 'Volume dos últimos 7 dias',
    admin_reports_daily_chart_desc: 'Volume e quantidade diários',
    admin_reports_user_stats: 'Estatísticas de usuários',
    admin_reports_user_stats_desc: 'Usuários ativos e status KYC',
    admin_reports_active_users: 'Usuários ativos',
    admin_reports_kyc_approved_users: 'KYC aprovados',
    admin_reports_new_users: 'Novos este mês',
    admin_reports_today_transfers: 'Transferências hoje',
    admin_reports_week_transfers: 'Transferências esta semana',
    admin_reports_top_users: 'Top usuários por volume',
    admin_reports_top_users_desc: 'Ranking por volume acumulado',
    admin_reports_no_data: 'Sem dados',
    admin_reports_rank: '#',
    admin_reports_count: 'Transferências',
    admin_reports_volume: 'Volume acumulado',

    // Admin Settings
    admin_settings_title: 'Configurações de taxas',
    admin_settings_subtitle: 'Configurar taxas de envio e markup',
    admin_settings_flat_fee: 'Taxa fixa (JPY)',
    admin_settings_markup: 'Markup de câmbio (%)',
    admin_settings_save: 'Salvar configurações',
    admin_settings_saving: 'Salvando...',
    admin_settings_reset: 'Padrão',
    admin_settings_revenue: 'Estrutura de receita',
    admin_settings_fee_per: 'Receita por taxa fixa',
    admin_settings_spread_per: 'Receita de spread',
    admin_settings_total_revenue: 'Receita total',
    admin_settings_per_transfer: '/ envio',
    admin_settings_bank_title: 'Dados bancários',
    admin_settings_bank_subtitle: 'Informações bancárias exibidas na página de depósito',
    admin_settings_bank_name: 'Banco',
    admin_settings_branch_name: 'Agência',
    admin_settings_account_type: 'Tipo de conta',
    admin_settings_account_number: 'Número da conta',
    admin_settings_account_holder: 'Titular',
    admin_settings_bank_notes: 'Observações (opcional)',
    admin_settings_bank_save: 'Salvar dados bancários',

    // Logo Settings
    admin_settings_logo_title: 'Logo da empresa',
    admin_settings_logo_subtitle: 'Logo exibido em todo o site',
    admin_settings_logo_current: 'Logo atual',
    admin_settings_logo_upload: 'Enviar logo',
    admin_settings_logo_uploading: 'Enviando...',
    admin_settings_logo_change: 'Alterar logo',
    admin_settings_logo_delete: 'Excluir logo',
    admin_settings_logo_deleting: 'Excluindo...',
    admin_settings_logo_success: 'Logo enviado com sucesso',
    admin_settings_logo_delete_success: 'Logo excluido',
    admin_settings_logo_error: 'Falha ao enviar logo',
    admin_settings_logo_delete_error: 'Falha ao excluir logo',
    admin_settings_logo_formats: 'Formatos: JPEG, PNG, WebP, SVG (max 5MB)',
    admin_settings_logo_default: 'Usando logo padrao',

    // Landing Settings
    admin_settings_landing_title: 'Exibicao da pagina inicial',
    admin_settings_landing_subtitle: 'Valor exibido no widget da calculadora',
    admin_settings_landing_amount_label: 'Valor de exibicao (JPY)',
    admin_settings_landing_amount_desc: 'Valor de exemplo exibido na secao principal da pagina inicial',
    admin_settings_landing_saved: 'Configuracao salva',
    admin_settings_landing_error: 'Falha ao salvar',
    admin_settings_landing_invalid: 'Insira um valor valido',
    admin_settings_hero_title: 'Editar texto principal',
    admin_settings_hero_line1: 'Titulo linha 1',
    admin_settings_hero_line2: 'Titulo linha 2 (destaque)',
    admin_settings_hero_line3: 'Titulo linha 3',
    admin_settings_hero_desc: 'Descricao',
    admin_settings_hero_hint: 'Deixe em branco para usar o texto padrao. Use as abas JA/PT/EN para editar cada idioma.',

    // Market Rate Settings
    settings_market_rate_title: 'Taxa de câmbio de mercado',
    settings_market_rate_subtitle: 'Atualização automática a cada 3 horas via Frankfurter API (ECB)',
    settings_current_rate: 'Taxa atual',
    settings_manual_mode: 'Manual',
    settings_live_mode: 'Ao vivo',
    settings_last_updated: 'Última atualização',
    settings_source: 'Fonte',
    settings_source_manual: 'Configuração manual',
    settings_auto_refresh: 'Atualização automática',
    settings_every_3h: 'A cada 3 horas',
    settings_next_refresh: 'Próxima atualização',
    settings_refresh_now: 'Atualizar agora',
    settings_refreshing: 'Atualizando...',
    settings_manual_rate: 'Taxa manual',
    settings_override: 'Definir manual',
    settings_enable_auto: 'Voltar ao automático',
    settings_rate_refreshed: 'Taxa atualizada',
    settings_rate_refresh_failed: 'Falha ao atualizar taxa',
    settings_rate_invalid: 'Insira uma taxa válida',
    settings_rate_overridden: 'Taxa definida manualmente',
    settings_rate_auto_enabled: 'Atualização automática ativada',
    settings_fee_title: 'Configurações de taxas',
    settings_flat_fee_desc: 'Taxa fixa adicionada a cada envio',
    settings_markup_desc: 'Markup aplicado sobre a taxa de mercado',
    settings_saved: 'Configurações salvas',
    settings_save_failed: 'Falha ao salvar',
    settings_bank_saved: 'Dados bancários salvos',
    settings_bank_save_failed: 'Falha ao salvar dados bancários',
    settings_simulation_title: 'Simulação',
    settings_sim_amount: 'Valor do envio',
    settings_sim_fee: 'Taxa fixa',
    settings_sim_total: 'Total pago',
    settings_sim_market_rate: 'Taxa de mercado',
    settings_sim_applied_rate: 'Taxa aplicada (com markup)',
    settings_sim_receive: 'Valor recebido',

    // Admin Login
    admin_login_title: 'Login de administrador',
    admin_login_desc: 'Faça login com conta de administrador',

    // Login
    login_success: 'Login realizado',
    login_fail: 'Falha no login',
    login_email_not_verified: 'E-mail não verificado. Verifique o código de verificação.',

    // Deposit extra
    deposit_receipt_upload_fail: 'Falha ao enviar arquivo',

    // Send extra
    send_kyc_required: 'Verificação KYC necessária',
    send_select_recipient: 'Selecione um destinatário',
    send_insufficient_balance: 'Saldo insuficiente. Faça um depósito primeiro.',

    // Admin Toast Messages
    admin_users_created: 'Usuário criado',
    admin_users_create_failed: 'Falha ao criar usuário',
    admin_users_updated: 'Usuário atualizado',
    admin_users_update_failed: 'Falha ao atualizar usuário',
    admin_users_deleted: 'Usuário excluído',
    admin_users_delete_failed: 'Falha ao excluir usuário',
    admin_users_balance_updated: 'Saldo atualizado',
    admin_users_balance_failed: 'Falha ao atualizar saldo',
    admin_users_password_placeholder: 'Nova senha (deixe em branco para manter)',
    admin_users_password_hint: 'Deixe em branco para manter a senha atual. Mínimo 6 caracteres.',
    admin_users_deposit_added: 'Depósito adicionado',
    admin_users_deposit_failed: 'Falha ao adicionar depósito',
    admin_transfers_updated: 'Transferência atualizada',
    admin_transfers_update_failed: 'Falha ao atualizar transferência',
    admin_transfers_deleted: 'Registro de transferência excluído',
    admin_transfers_delete_failed: 'Falha ao excluir transferência',
    admin_transfers_delete_confirm: 'Excluir esta transferência?',
    admin_transfers_payment_status: 'Status do pagamento',
    admin_transfers_period_filter: 'Filtro de período',
    admin_transfers_count_records: ' registros de transferência',
    admin_transfers_transfer_id: 'ID da transferência',
    admin_kyc_reviewed: 'KYC {action}',
    admin_kyc_review_failed: 'Falha na análise KYC',
    admin_kyc_updated: 'KYC atualizado',
    admin_kyc_update_failed: 'Falha ao atualizar KYC',
    admin_kyc_notes: 'Comentários da análise',
    admin_kyc_notes_placeholder: 'Inserir comentários...',
    admin_kyc_review_title: 'Análise KYC',
    admin_deposits_confirmed: 'Depósito aprovado',
    admin_deposits_confirm_failed: 'Falha ao aprovar depósito',
    admin_deposits_rejected: 'Depósito rejeitado',
    admin_deposits_reject_failed: 'Falha ao rejeitar depósito',
    admin_deposits_reject_confirm: 'Rejeitar este depósito?',
    admin_deposits_deleted: 'Depósito excluído',
    admin_deposits_delete_failed: 'Falha ao excluir depósito',
    admin_deposits_pending_count: 'Pendentes: {count}',
    admin_deposits_method_bank: 'Transferência bancária',
    admin_deposits_method_convenience: 'Conveniência',
    admin_deposits_method_admin: 'Manual (admin)',
    admin_deposits_method_stripe: 'Stripe',
    admin_deposits_status_confirmed: 'Confirmado',
    admin_deposits_status_rejected: 'Rejeitado',
    admin_aml_resolved: 'Flag AML resolvido',
    admin_aml_resolve_failed: 'Falha ao resolver flag AML',
    admin_aml_deleted: 'Flag AML excluído',
    admin_aml_delete_failed: 'Falha ao excluir flag AML',
    admin_aml_risk_prefix: 'Risco',
    admin_aml_status_open: 'Aberto',
    admin_aml_status_investigating: 'Investigando',
    admin_aml_status_resolved: 'Resolvido',
    admin_aml_status_false_positive: 'Falso positivo',
    admin_aml_resolve: 'Resolver',
    admin_aml_investigate: 'Investigar',
    admin_aml_false_positive_btn: 'Falso positivo',
    admin_reports_loading: 'Carregando...',
    admin_reports_error: 'Falha ao carregar dados',
    admin_data_not_found: 'Dados não encontrados',
    status_active: 'Ativo',
    status_suspended: 'Suspenso',
    status_frozen: 'Congelado',
    all: 'Todos',

    // Back to home
    back_to_home: 'Voltar ao início',
    // Count suffix
    count_suffix: 'x',
    count_people: '',
    count_items: '',

    // Profile extra
    profile_account_info: 'Informações e estatísticas da conta',
    profile_bio_success: 'Biometria registrada. Use impressão digital no próximo login.',
    profile_bio_cancel: 'Registro de biometria cancelado',
    profile_bio_fail: 'Falha ao registrar biometria',
    profile_bio_delete_confirm: 'Excluir esta biometria?',
    profile_bio_deleted: 'Biometria excluída',
    profile_bio_delete_fail: 'Falha ao excluir biometria',
    profile_2fa_setup_fail: 'Falha ao iniciar configuração 2FA',
    profile_2fa_verified: 'Autenticação em dois fatores ativada',
    profile_2fa_invalid_code: 'Código de autenticação incorreto',
    profile_2fa_disabled_msg: 'Autenticação em dois fatores desativada',
    profile_updated: 'Perfil atualizado',
    profile_update_fail: 'Falha ao atualizar perfil',
    profile_image_size: 'O arquivo deve ter no máximo 5MB',
    profile_image_updated: 'Foto do perfil atualizada',
    profile_image_fail: 'Falha ao enviar imagem',
    profile_not_set: 'Não definido',
    profile_basic_info: 'Informações básicas',
    profile_annual_income_unit: '万円',
    profile_registered_at: 'Registrado',
    profile_kyc_docs: 'Documentos de identidade',
    profile_go_kyc: 'Ir ao KYC',
    profile_kyc_status_label: 'Status KYC',
    profile_kyc_needed: 'Verificação necessária',
    profile_kyc_under_review: 'Em análise',
    profile_kyc_completed: 'Verificação concluída',
    profile_kyc_rejected_msg: 'Verificação rejeitada',
    profile_recent_transfers: 'Transferências recentes',
    profile_bio_fingerprint: 'Biometria (impressão digital)',
    profile_bio_login_desc: 'Login com impressão digital/Face ID',
    profile_bio_device_name: 'Dispositivo biométrico',
    profile_bio_none_desc: 'Nenhuma biometria registrada. Registre para login com impressão digital ou Face ID.',

    // KYC extra
    kyc_submitted_toast: 'Solicitação KYC enviada',
    kyc_submit_fail: 'Falha ao enviar KYC',
    kyc_files_uploaded: '{count} arquivo(s) enviado(s)',
    kyc_upload_fail: 'Falha ao enviar arquivo',
    kyc_status_pending_title: 'Em análise',
    kyc_status_pending_desc: 'Sua solicitação KYC está em análise. Normalmente 1-2 dias úteis.',
    kyc_status_approved_title: 'Aprovado',
    kyc_status_approved_full: 'KYC concluído. Você pode enviar dinheiro.',
    kyc_status_rejected_title: 'Rejeitado',
    kyc_status_rejected_full: 'KYC rejeitado. Veja os detalhes abaixo.',
    kyc_reviewer_notes: 'Comentários da análise',
    kyc_page_subtitle: 'Verificação de identidade',
    kyc_form_title: 'Enviar documentos de identidade',
    kyc_form_desc: 'Para enviar dinheiro, a verificação KYC é necessária. Preencha as informações abaixo.',
    kyc_doc_type_label: 'Tipo de documento',
    kyc_full_name_label: 'Nome completo (como no documento)',
    kyc_purpose_placeholder: 'Ex: envio para família, pagamento de estudos, etc.',
    kyc_submit_button: 'Enviar KYC',

    // KYC residence
    kyc_residence_section: 'Informações de residência',
    kyc_residence_status: 'Status de residência',
    kyc_residence_status_placeholder: 'Selecionar status',
    kyc_residence_card_number: 'Número do cartão de residência',
    kyc_residence_period: 'Período de estadia (data de vencimento)',
    kyc_residence_permanent: 'Residente permanente',
    kyc_residence_long_term: 'Residente de longa duração',
    kyc_residence_spouse: 'Cônjuge de japonês',
    kyc_residence_work: 'Visto de trabalho',
    kyc_residence_student: 'Estudante',
    kyc_residence_technical: 'Estagiário técnico',
    kyc_residence_specified: 'Habilidade específica',
    kyc_residence_other: 'Outro',

    // KYC photo sides
    kyc_photo_front: 'Frente',
    kyc_photo_back: 'Verso',
    kyc_photo_angled: 'Diagonal',
    kyc_photo_desc: 'Envie fotos do documento em 3 ângulos (frente, verso e diagonal).',

    // Recipients extra
    recipients_added: 'Destinatário adicionado',
    recipients_add_fail: 'Falha ao adicionar destinatário',
    recipients_deleted: 'Destinatário excluído',
    recipients_delete_fail: 'Falha ao excluir destinatário',
    recipients_new_title: 'Adicionar novo destinatário',
    recipients_new_desc: 'Insira os dados do destinatário',
    recipients_method: 'Método de recebimento',
    recipients_bank_account: 'Conta bancária',
    recipients_pix_placeholder: 'CPF, E-mail, Telefone ou chave aleatória',
    recipients_branch_number: 'Código da agência',
    recipients_nationality: 'Nacionalidade',
    recipients_postal_code: 'CEP',
    recipients_address: 'Endereço',
    recipients_phone: 'Telefone',
    recipients_email: 'E-mail',
    recipients_transfer_purpose: 'Finalidade da remessa',
    recipients_fund_source: 'Origem dos fundos',
    recipients_edit_title: 'Editar destinatário',
    recipients_edit_desc: 'Altere os dados do destinatário',
    recipients_updated: 'Destinatário atualizado',
    recipients_update_fail: 'Falha ao atualizar destinatário',
    recipients_save: 'Salvar',
    recipients_personal_info: 'Informações pessoais',
    recipients_bank_info: 'Informações bancárias',
    recipients_transfer_info: 'Informações de remessa',
    recipients_relationship_family: 'Família',
    recipients_relationship_friend: 'Amigo',
    recipients_relationship_business: 'Negócios',
    recipients_relationship_self: 'Próprio',
    recipients_relationship_other: 'Outro',
    recipients_purpose_living: 'Despesas de vida',
    recipients_purpose_education: 'Educação',
    recipients_purpose_business: 'Negócios',
    recipients_purpose_investment: 'Investimento',
    recipients_purpose_gift: 'Presente',
    recipients_purpose_other: 'Outro',
    recipients_fund_salary: 'Salário',
    recipients_fund_savings: 'Poupança',
    recipients_fund_business: 'Renda empresarial',
    recipients_fund_investment: 'Retorno de investimento',
    recipients_fund_other: 'Outro',

    // Recipient Invitation
    invite_title: 'Convidar destinatário',
    invite_subtitle: 'Peça ao destinatário para inserir suas informações diretamente',
    invite_name: 'Nome do destinatário',
    invite_email: 'E-mail do destinatário',
    invite_email_optional: '(Opcional - enviar link de convite por e-mail)',
    invite_send: 'Criar link de convite',
    invite_sending: 'Criando...',
    invite_success: 'Link de convite criado',
    invite_fail: 'Falha ao criar convite',
    invite_link_label: 'Link de convite',
    invite_copied: 'Link copiado',
    invite_share_email: 'E-mail',
    invite_share_line: 'LINE',
    invite_share_whatsapp: 'WhatsApp',
    invite_share_copy: 'Copiar',
    invite_share_title: 'Escolha como compartilhar',
    invite_share_message: '{name}, por favor insira suas informações de destinatário no link: {link}',
    invite_pending: 'Aguardando',
    invite_completed: 'Concluído',
    invite_tab_list: 'Lista de destinatários',
    invite_tab_invitations: 'Gerenciar convites',
    invite_empty: 'Nenhum convite',
    invite_delete_confirm: 'Excluir este convite?',
    invite_deleted: 'Convite excluído',
    invite_btn: 'Convidar para preencher',
    invite_form_title: 'Inserir informações do destinatário',
    invite_form_subtitle: '{sender} deseja registrá-lo como destinatário de transferência. Por favor, insira suas informações abaixo.',
    invite_form_submit: 'Enviar informações',
    invite_form_submitting: 'Enviando...',
    invite_form_success_title: 'Informações enviadas',
    invite_form_success_desc: 'Suas informações foram compartilhadas com o remetente. Obrigado!',
    invite_form_expired: 'Este link já foi utilizado',
    invite_form_not_found: 'Convite não encontrado',
    invite_email_sent: 'E-mail enviado',

    // Document pages
    income_cert_desc: 'Faça o upload da foto do seu comprovante de renda',
    income_cert_photo: 'Foto do documento',
    income_cert_annual: 'Renda anual',
    income_cert_monthly: 'Salário mensal',
    residence_card_title: 'Cartão de residência',
    residence_card_desc: 'Faça o upload da foto do seu cartão de residência',
    residence_card_photo: 'Foto do cartão de residência',
    residence_card_number: 'Número do cartão',
    residence_card_expiry: 'Data de validade',
    residence_card_front: 'Frente',
    residence_card_back: 'Verso',
    residence_card_both_required: 'Fotos da frente e do verso são obrigatórias',
    doc_status_pending: 'Em análise',
    doc_status_approved: 'Aprovado',
    doc_status_rejected: 'Rejeitado',
    doc_status_not_submitted: 'Não enviado',
    doc_photo_uploaded: 'Foto enviada',
    doc_upload_fail: 'Falha no envio',
    doc_photo_required: 'Foto é obrigatória',
    doc_submitted: 'Enviado com sucesso',
    doc_submit_fail: 'Falha ao enviar',
    doc_submit: 'Enviar',
    doc_submitting: 'Enviando...',
    doc_click_upload: 'Clique para enviar foto',
    doc_uploading: 'Enviando...',
    doc_change_photo: 'Trocar foto',
    doc_submitted_at: 'Data de envio',
    doc_reviewer_notes: 'Notas do revisor',
    doc_delete_confirm: 'Deseja excluir?',
    doc_deleted: 'Excluído',
    doc_delete_fail: 'Falha ao excluir',
    doc_delete_resubmit: 'Excluir e reenviar',
    doc_update: 'Atualizar',
    doc_updating: 'Atualizando...',
    doc_updated: 'Atualizado',
    doc_update_confirm: 'Deseja atualizar este documento? O status será alterado para pendente.',
    doc_add_new: 'Adicionar novo',
    doc_history: 'Histórico',
    doc_current: 'Atual',
    admin_income_cert_title: 'Comprovantes de renda',
    admin_income_cert_desc: 'Visualize e edite comprovantes de renda',
    admin_income_cert_review: 'Revisar comprovante',
    admin_income_cert_edit: 'Editar comprovante',
    admin_residence_card_title: 'Cartões de residência',
    admin_residence_card_desc: 'Visualize e edite cartões de residência',
    admin_residence_card_review: 'Revisar cartão',
    admin_residence_card_edit: 'Editar cartão',
    admin_doc_user: 'Usuário',
    admin_doc_status: 'Status',
    admin_doc_actions: 'Ações',
    admin_doc_approve: 'Aprovar',
    admin_doc_reject: 'Rejeitar',
    admin_doc_approved: 'Aprovado',
    admin_doc_rejected: 'Rejeitado',
    admin_doc_updated: 'Atualizado',
    admin_no_documents: 'Nenhum documento',
    admin_email_title: 'Gerenciamento de e-mail',
    admin_email_desc: 'Envie e receba e-mails',
    admin_email_refresh: 'Atualizar',
    admin_email_compose: 'Novo e-mail',
    admin_email_compose_desc: 'Enviar um e-mail',
    admin_email_from: 'De',
    admin_email_to: 'Para',
    admin_email_subject: 'Assunto',
    admin_email_body: 'Mensagem',
    admin_email_date: 'Data',
    admin_email_send: 'Enviar',
    admin_email_sending: 'Enviando...',
    admin_email_sent: 'E-mail enviado',
    admin_email_reply: 'Responder',
    admin_email_back: 'Voltar',
    admin_email_messages: 'mensagens',
    admin_email_empty: 'Nenhum e-mail',
    admin_email_fetch_fail: 'Falha ao buscar e-mails',
    admin_email_fill_all: 'Preencha todos os campos',
    admin_email_manage_accounts: 'Gerenciar contas',
    admin_email_accounts_title: 'Contas de e-mail',
    admin_email_add_account: 'Adicionar conta',
    admin_email_add_account_desc: 'Insira as informações de conexão',
    admin_email_address: 'Endereço de e-mail',
    admin_email_password: 'Senha',
    admin_email_label: 'Rótulo',
    admin_email_server: 'Servidor',
    admin_email_port: 'Porta',
    admin_email_test: 'Testar',
    admin_email_test_ok: 'Conexão bem-sucedida',
    admin_email_account_added: 'Conta adicionada',
    admin_email_account_deleted: 'Conta excluída',
    admin_email_delete_confirm: 'Excluir esta conta?',
    admin_email_no_accounts: 'Nenhuma conta',

    // Register extra
    register_password_mismatch: 'As senhas não coincidem',
    register_password_min: 'A senha deve ter pelo menos 6 caracteres',
    register_success: 'Cadastro realizado com sucesso',
    register_fail: 'Falha no cadastro',
    register_create_account: 'Criar conta',
    register_phone_optional: 'Telefone (opcional)',
    register_confirm_password: 'Confirmar senha',
    register_name_placeholder: 'Nome completo',

    // Support extra
    support_contact_methods: 'Formas de contato',
    support_email_title: 'E-mail',
    support_email_desc: 'Resposta em até 24 horas',
    support_phone_title: 'Telefone',
    support_phone_hours: 'Dias úteis 9:00-18:00',
    support_chat_title: 'Chat',
    support_chat_desc: 'Atendimento imediato',
    support_chat_start: 'Iniciar chat',
    support_faq_q1: 'Quanto tempo leva a transferência?',
    support_faq_a1: 'Via PIX, em minutos. Via transferência bancária, em até 24 horas.',
    support_faq_q2: 'Qual é a taxa?',
    support_faq_a2: 'Taxa fixa de ¥500 por envio. Sem custos ocultos.',
    support_faq_q3: 'A verificação KYC é obrigatória?',
    support_faq_a3: 'Sim, a verificação KYC é exigida pela legislação japonesa para transferências de dinheiro.',
    support_faq_q4: 'Existe limite de envio?',
    support_faq_a4: 'O limite é de ¥1.000.000 por transferência. Para valores maiores, entre em contato com o suporte.',

    // Admin Dashboard extra
    admin_dash_title: 'Painel',
    admin_dash_subtitle: 'Visão geral do sistema',
    admin_dash_total_volume: 'Volume total',
    admin_dash_pending_kyc_alert: 'KYC pendentes: {count}',
    admin_dash_pending_kyc_desc: 'Solicitações KYC aguardando análise',
    admin_dash_deposits: 'Total de depósitos',
    admin_dash_pending_deposits: 'depósitos pendentes',
    admin_dash_pending_deposits_desc: 'Depósitos aguardando aprovação',
    admin_dash_aml_alert: 'alertas AML',
    admin_dash_aml_alert_desc: 'Alertas AML requerem revisão',
    admin_dash_aml_open: 'Alertas abertos',
    admin_dash_referral_uses: 'Usos de indicação',
    admin_dash_email_accounts: 'Contas de e-mail',
    admin_dash_recipients: 'Destinatários',
    admin_dash_registered: 'Registrados',
    admin_dash_documents: 'Gestão de Documentos',
    admin_dash_management: 'Outras Gestões',
    admin_dash_recent_transfers: 'Transferências recentes',
    admin_dash_recent_users: 'Usuários recentes',
    view_all: 'Ver todos',
    total: 'Total',
    pending: 'Pendente',
    no_data: 'Sem dados',
    loading: 'Carregando...',

    // Admin Login extra
    admin_login_no_permission: 'Sem permissão de administrador',
    admin_login_success: 'Login realizado',
    admin_login_fail: 'Falha no login',
    admin_login_loading: 'Entrando...',

    // Missing keys - General
    deposit: 'Depósito',
    saving: 'Salvando...',
    income_cert_title: 'Comprovante de renda',
    login_or: 'ou',
    not_entered: 'Não preenchido',
    no_records: 'Sem registros',
    error_occurred: 'Ocorreu um erro',

    // Deposit page
    deposit_invalid_amount: 'Digite um valor válido',
    deposit_submitted: 'Solicitação de depósito enviada',
    deposit_submit_failed: 'Falha ao enviar solicitação de depósito',
    deposit_reference_placeholder: 'Nome do depositante, data, etc.',
    deposit_receipt_label: 'Enviar foto do comprovante',
    deposit_receipt_alt: 'Comprovante',
    deposit_receipt_preview_alt: 'Comprovante de transferência',

    // Print-related
    print_title_history: 'PRC Remit - Histórico de transferências',
    print_title_admin: 'PRC Remit - Gestão de transferências',
    print_date: 'Data de impressão',
    print_period: 'Período',
    print_period_all: 'Todo o período',
    print_no_start: 'Sem data inicial',
    print_no_end: 'Sem data final',
    print_total_jpy: 'Total enviado (JPY)',
    print_total_brl: 'Total recebido (BRL)',
    print_total_fee: 'Total de taxas',
    print_col_no: 'No.',
    print_col_date: 'Data/hora',
    print_col_recipient: 'Destinatário',
    print_col_sender: 'Remetente',
    print_col_amount_jpy: 'Valor (JPY)',
    print_col_fee: 'Taxa',
    print_col_total_jpy: 'Total (JPY)',
    print_col_amount_brl: 'Recebido (BRL)',
    print_col_rate: 'Taxa',
    print_col_status: 'Status',
    print_col_id: 'ID',
    print_col_payment: 'Pagamento',
    print_footer_user: 'Este documento é uma referência de transferências',
    print_footer_admin: 'Documento de gestão de transferências',
    print_admin_label: 'Admin',
    print_license: 'Licença',
    print_representative: 'Representante',
    print_items: 'itens',
    print_address: 'Endereço',
    print_phone: 'Telefone',
    print_email: 'E-mail',
    print_website: 'Website',
    print_payment_paid: 'Pago',
    print_payment_confirmed: 'Confirmado',
    print_pdf_read: 'PDF processado ({fields})',
    print_settlement_id: 'ID liquidação',
    print_settled_amount: 'Valor liquidado',

    // Admin AML page
    aml_subtitle: 'Gestão AML e registros de resolução',
    aml_created_at: 'Data de ocorrência',
    aml_resolve_record: 'Registro de resolução',
    aml_resolve_title: 'Resolução AML',
    aml_resolve_detail_title: 'Detalhes da resolução AML',
    aml_resolve_type: 'Tipo de resolução',
    aml_resolver_name: 'Nome do responsável',
    aml_resolved_date: 'Data de resolução',
    aml_resolution_notes: 'Notas de resolução',
    aml_resolution_notes_placeholder: 'Registrar detalhes...',
    aml_id_upload: 'Upload de documento de identidade',
    aml_id_doc: 'Documento de identidade',
    aml_id_front: 'Frente',
    aml_id_back: 'Verso',
    aml_save_resolve: 'Salvar resolução',
    aml_resolved_at: 'Data/hora da resolução',
    aml_resolver_label: 'Responsável',
    aml_resolved_date_label: 'Data',
    aml_notes_label: 'Registro',
    aml_id_attached: 'Documento anexado',
    aml_image_only: 'Apenas arquivos de imagem são permitidos',
    aml_upload_success: '{side} enviado',
    aml_upload_failed: 'Falha no upload',
    aml_name_required: 'Digite o nome do responsável',
    aml_date_required: 'Digite a data de resolução',
    aml_resolve_failed: 'Falha na resolução',
    aml_delete_failed: 'Falha ao excluir',
    aml_flag_label: 'Flag',
    aml_name_placeholder: 'Ex: João Silva',
    aml_user_id: 'ID do usuário',
    aml_risk_prefix: 'Risco',

    // AML Enhanced
    aml_stats_title: 'Estatísticas AML',
    aml_stats_total: 'Total de Flags',
    aml_stats_open: 'Abertos',
    aml_stats_investigating: 'Em investigação',
    aml_stats_resolved: 'Resolvidos',
    aml_stats_false_positive: 'Falso Positivo',
    aml_stats_high_risk: 'Alto Risco (Ativos)',
    aml_stats_medium_risk: 'Médio Risco (Ativos)',
    aml_stats_low_risk: 'Baixo Risco (Ativos)',
    aml_stats_today: 'Hoje',
    aml_stats_week: 'Esta Semana',
    aml_stats_month: 'Este Mês',
    aml_stats_held: 'Transferências Retidas',
    aml_stats_risky_users: 'Usuários de Alto Risco',
    aml_settings_title: 'Configurações AML',
    aml_settings_desc: 'Configure limites das regras de detecção',
    aml_settings_high_amount: 'Limite Alto (JPY)',
    aml_settings_medium_amount: 'Limite Médio (JPY)',
    aml_settings_daily_limit: 'Limite Diário (JPY)',
    aml_settings_weekly_limit: 'Limite Semanal (JPY)',
    aml_settings_hourly_freq: 'Limite de Frequência/Hora',
    aml_settings_same_recipient: 'Limite Mesmo Destinatário/Dia',
    aml_settings_new_user_amount: 'Limite Novo Usuário (JPY)',
    aml_settings_new_user_days: 'Período Novo Usuário (Dias)',
    aml_settings_night_start: 'Início Noturno (JST)',
    aml_settings_night_end: 'Fim Noturno (JST)',
    aml_settings_night_threshold: 'Limite Noturno (JPY)',
    aml_settings_round_threshold: 'Limite Valor Redondo (JPY)',
    aml_settings_auto_hold: 'Retenção automática alto risco',
    aml_settings_saved: 'Configurações AML salvas',
    aml_settings_save_failed: 'Falha ao salvar configurações AML',
    aml_tab_flags: 'Flags',
    aml_tab_stats: 'Estatísticas',
    aml_tab_settings: 'Configurações',
    aml_tab_users: 'Usuários de Risco',
    aml_filter_all: 'Todos',
    aml_filter_open: 'Abertos',
    aml_filter_investigating: 'Investigando',
    aml_filter_resolved: 'Resolvidos',
    aml_filter_high: 'Alto Risco',
    aml_filter_medium: 'Médio Risco',
    aml_filter_low: 'Baixo Risco',
    aml_set_investigating: 'Definir Investigação',
    aml_user_name: 'Nome do Usuário',
    aml_user_email: 'Email',
    aml_user_risk_score: 'Pontuação de Risco',
    aml_user_risk_tier: 'Nível de Risco',
    aml_risk_critical: 'Crítico',
    aml_flag_type_labels: 'Tipo de Detecção',
    aml_flag_high_amount: 'Valor Alto',
    aml_flag_high_frequency: 'Alta Frequência',
    aml_flag_daily_limit: 'Limite Diário Excedido',
    aml_flag_weekly_limit: 'Limite Semanal Excedido',
    aml_flag_same_recipient: 'Mesmo Destinatário',
    aml_flag_new_user_high_value: 'Novo Usuário Alto Valor',
    aml_flag_night_transfer: 'Transferência Noturna',
    aml_flag_round_amount_pattern: 'Padrão Valor Redondo',

    // Admin Transfers extra
    admin_transfers_edit_title: 'Editar status da transferência',
    admin_transfers_completion_info: 'Informações de conclusão',
    admin_transfers_settlement_id: 'ID de liquidação',
    admin_transfers_completed_date: 'Data de conclusão',
    admin_transfers_completed_required: 'Digite a data de conclusão',
    admin_transfers_settled_amount: 'Valor liquidado',
    admin_transfers_proof: 'Comprovante de transferência',
    admin_transfers_proof_pdf: 'PDF do comprovante',
    admin_transfers_open_new_tab: 'Abrir em nova aba',
    admin_transfers_not_uploaded: 'Não enviado',
    admin_transfers_completed_at: 'Data de conclusão',
    admin_transfers_edit_status_btn: 'Editar status',
    admin_transfers_pdf_only: 'Apenas arquivos PDF são permitidos',
    admin_transfers_pdf_uploaded: 'PDF enviado',
    admin_transfers_upload_failed: 'Falha no upload',
    admin_transfers_status_label: 'Status',
    admin_transfers_payment_label: 'Status do pagamento',
    admin_transfers_settlement_placeholder: 'Ex: TXN-20260315-001',
    admin_transfers_required: 'Obrigatório',

    // Admin Deposits extra
    admin_deposits_method_label: 'Método de depósito',
    admin_deposits_status_label: 'Status',
    admin_deposits_request_date: 'Data da solicitação',
    admin_deposits_process_date: 'Data de processamento',
    admin_deposits_memo: 'Nota',
    admin_deposits_user_memo: 'Nota do usuário',
    admin_deposits_receipt: 'Comprovante',
    admin_deposits_click_enlarge: 'Clique para ampliar',
    admin_deposits_no_receipt: 'Sem comprovante',
    admin_deposits_reject_confirm_text: 'Rejeitar este depósito?',
    admin_deposits_delete_confirm_text: 'Excluir este depósito? Se confirmado, o valor será deduzido do saldo.',

    // Admin Referrals extra
    admin_ref_code_updated: 'Código atualizado',
    admin_ref_code_update_failed: 'Falha ao atualizar código',
    admin_ref_code_deleted: 'Código excluído',
    admin_ref_delete_failed: 'Falha ao excluir',
    admin_ref_delete_confirm: 'Excluir código "{code}"?',

    // Admin Users extra
    admin_users_details_btn: 'Detalhes',
    admin_users_balance_manage: 'Gerenciar saldo',
    admin_users_edit_btn: 'Editar',
    admin_users_delete_btn: 'Excluir',
    admin_users_amount_placeholder: 'Digite o valor',

    // Admin Settings extra
    admin_settings_account_type_default: 'Corrente',
    admin_settings_branch_placeholder: 'Sede',
    admin_settings_notes_placeholder: 'Notas sobre transferência, etc.',

    // Additional missing keys
    print: 'Imprimir',
    clear_filter: 'Limpar',
    date_start: 'Data inicial',
    date_end: 'Data final',
    admin_ref_code_col: 'Código de indicação',
    admin_ref_user_col: 'Usuário',
    admin_ref_count_col: 'Indicações',
    admin_ref_completed_col: 'Concluídas',
    admin_ref_issued_col: 'Data de emissão',
    admin_ref_actions_col: 'Ações',
    admin_ref_no_codes: 'Nenhum código emitido',
    admin_deposits_detail_title: 'Detalhes do depósito',
    admin_deposits_user_col: 'Usuário',
    admin_deposits_amount_col: 'Valor',
    admin_deposits_receipt_col: 'Comprovante',
    admin_reports_fetch_failed: 'Falha ao buscar dados',
    admin_transfers_payment_status: 'Status do pagamento',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    uploading: 'Enviando...',

    // Transfer limit
    admin_users_transfer_limit: 'Limite de transferência',
    admin_users_transfer_limit_placeholder: 'Ex: 500000 (vazio = sem limite)',
    admin_users_transfer_limit_hint: 'Limite por transferência (JPY). Vazio = sem limite',
    send_transfer_limit: 'Limite de transferência',
    send_over_limit: 'Valor excede o limite de transferência',
    send_over_limit_msg: 'O limite por transferência é ¥{limit}',
  },

  en: {
    // Common
    login: 'Login',
    logout: 'Logout',
    register: 'Sign Up',
    email: 'Email',
    password: 'Password',
    name: 'Full Name',
    phone: 'Phone Number',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    update: 'Update',
    withdraw: 'Withdraw',
    deposit_method: 'Deposit method',
    confirm: 'Confirm',
    loading: 'Loading...',
    back: 'Back',
    submit: 'Submit',
    search: 'Search',
    processing: 'Processing...',
    fee: 'Fee',
    total: 'Total',
    amount: 'Amount',
    balance: 'Balance',
    bank_account: 'Bank Account',

    // Landing Page
    landing_login: 'Login',
    landing_hero_title_1: 'From Japan to Brazil',
    landing_hero_title_2: 'Easy & Secure',
    landing_hero_title_3: 'Remittance',
    landing_hero_desc: 'Send money in 3 clicks. Low-cost, high-speed transfers to deliver money to your loved ones.',
    landing_cta: 'Get Started',
    landing_calculator: 'Rate Calculator',
    landing_fee_label: 'Transfer Fee',
    landing_arrival: 'Delivery',
    landing_click_send: 'Click Send',
    landing_send_amount: 'Send Amount',
    landing_why_title: 'Why PRC Remit?',
    landing_why_subtitle: 'Safe, secure, and convenient international transfers',
    landing_feature_fast: 'Fast Transfers',
    landing_feature_fast_desc: 'PIX support for near-instant delivery. Bank transfers delivered within 24 hours.',
    landing_feature_secure: 'Secure',
    landing_feature_secure_desc: 'Licensed money transfer operator. Full KYC/AML compliance for your peace of mind.',
    landing_feature_cheap: 'Low Cost',
    landing_feature_cheap_desc: 'Fees from just ¥{fee}. Transparent pricing with no hidden costs.',
    landing_how_title: 'How It Works',
    landing_how_subtitle: 'Send money in 3 easy steps',
    landing_step1_title: 'Create Account',
    landing_step1_desc: 'Register with email and password. Complete identity verification (KYC).',
    landing_step2_title: 'Add Recipient',
    landing_step2_desc: 'Register your Brazilian recipient info (PIX key or bank account).',
    landing_step3_title: 'Send Money',
    landing_step3_desc: 'Enter amount and send. Pay via bank transfer and processing begins immediately.',
    landing_pricing_title: 'Pricing',
    landing_pricing_subtitle: 'Simple and transparent pricing',
    landing_per_transfer: 'per transfer',
    landing_exchange_rate: 'Exchange Rate',
    landing_market_rate: 'Market Rate',
    landing_markup_about: 'Markup approx. {rate}%',
    landing_no_hidden: 'No hidden fees',
    landing_pix_bank: 'PIX & bank transfer supported',
    landing_24h_support: '24/7 support',
    landing_cta_title: 'Start Sending Money Today',
    landing_cta_desc: 'Free to sign up. Get started in minutes.',
    landing_cta_button: 'Create Free Account',
    landing_footer_desc: 'International remittance from Japan to Brazil. Safe, secure, and convenient.',
    landing_footer_service: 'Services',
    landing_footer_company: 'Company',
    landing_footer_transfer_methods: 'Transfer Methods',
    landing_footer_pricing: 'Pricing',
    landing_footer_docs: 'Documentation',
    pwa_install_title: 'Install App',
    pwa_install_desc: 'Add to home screen for quick access',
    pwa_install_btn: 'Install',
    pwa_ios_title: 'Add to Home Screen',
    pwa_ios_desc: 'Follow these steps to install the app',
    pwa_ios_step1: 'Tap the Share button (↑) at the bottom of Safari',
    pwa_ios_step2: 'Select "Add to Home Screen"',
    pwa_ios_step3: 'Tap "Add" to complete',
    pwa_ios_close: 'Close',
    landing_footer_about: 'About Us',
    landing_footer_terms: 'Terms of Service',
    landing_footer_privacy: 'Privacy Policy',
    landing_footer_admin: 'Admin Login',

    // Send Money
    send_title: 'Send Money',
    send_subtitle: 'Transfer from balance to Brazil',
    send_balance: 'Available Balance',
    send_insufficient: 'Insufficient balance (short: ¥{amount})',
    send_kyc_required_title: 'KYC verification required',
    send_kyc_required_desc: 'Please complete identity verification before sending money.',
    send_step1: 'Enter Amount',
    send_amount_label: 'Amount',
    send_amount: 'Send Amount',
    send_fee: 'Fee',
    send_total: 'Total Payment',
    send_deduct: 'Deduct from balance',
    send_receive: 'Recipient Gets',
    send_rate: 'Exchange Rate',
    send_step2: 'Select Recipient',
    send_no_recipients: 'No recipients registered',
    send_add_recipient: 'Add Recipient',
    send_recipient_label: 'Recipient',
    send_select_recipient: 'Select recipient...',
    send_btn_processing: 'Processing...',
    send_btn_insufficient: 'Insufficient Balance',
    send_btn_submit: 'Send from Balance',
    send_go_deposit: 'Go to Deposit',
    send_success_title: 'Transfer Complete',
    send_success_desc: 'Deducted from balance and transfer processing has started',
    send_success_toast: 'Transfer complete! Deducted from your balance.',
    send_error: 'Transfer failed',
    send_kyc_error: 'KYC verification required',
    send_select_error: 'Please select a recipient',
    send_balance_error: 'Insufficient balance. Please deposit first.',
    send_id: 'Transfer ID',
    send_total_deducted: 'Total Deducted',
    send_go_history: 'View History',
    send_new: 'New Transfer',
    send_currency_hint_jpy: 'Fee will be deducted from the send amount',
    send_currency_hint_brl: 'Specify the amount the recipient receives (fee added separately)',
    send_fee_exceeds: 'Amount is less than the fee. Please increase the amount.',
    send_input_amount: 'Input Amount',
    send_net_amount: 'After Fee Deduction',
    send_total_debit: 'Balance Deducted',
    send_free_transfer: 'Referral Perk: Free Transfer!',
    send_tier_discount: 'Tier Perk: {percent}% OFF fee',
    nav_referral: 'Referrals',
    ref_title: 'Referral Program',
    ref_subtitle: 'Invite friends and earn free transfers!',
    ref_total: 'Total Referrals',
    ref_completed: 'Completed',
    ref_pending: 'Pending',
    ref_free_transfers: 'Free Transfers',
    ref_your_code: 'Your Referral Code',
    ref_link_copied: 'Link copied',
    ref_code_copied: 'Code copied',
    ref_share_message: 'Send money from Japan to Brazil easily with PRC Remit! Register now and get your first transfer fee-free: {link}',
    ref_share_subject: 'PRC Remit - Japan to Brazil Transfer',
    ref_email: 'Email',
    ref_tier_title: 'Tier Bonuses',
    ref_current_tier: 'Current Tier',
    ref_fee_discount: 'Fee Discount',
    ref_people: 'people',
    ref_history: 'Referral History',
    ref_no_referrals: 'No referrals yet. Share your code to get started!',
    ref_status_completed: 'Completed',
    ref_status_pending: 'Pending',
    register_referral_code: 'Referral Code (optional)',
    register_referral_applied: 'Referral code applied! First transfer fee-free',
    admin_nav_referrals: 'Referrals',
    admin_ref_title: 'Referral Management',
    admin_ref_total: 'Total',
    admin_ref_completed: 'Completed',
    admin_ref_pending: 'Pending',
    admin_ref_codes: 'Codes Issued',
    admin_ref_tab_list: 'List',
    admin_ref_tab_settings: 'Settings',
    admin_ref_referrer: 'Referrer',
    admin_ref_referee: 'Referee',
    admin_ref_status: 'Status',
    admin_ref_date: 'Date',
    admin_ref_empty: 'No referral data',
    admin_ref_referrer_reward: 'Referrer Reward (free transfers)',
    admin_ref_referee_reward: 'Referee Reward (free transfers)',
    admin_ref_free_desc: 'Granted on first transfer completion',
    admin_ref_min_amount: 'Min Transfer Amount',
    admin_ref_tier_enabled: 'Enable tier bonuses',
    admin_ref_tier_config: 'Tier Configuration',
    admin_ref_tier_name: 'Tier Name',
    admin_ref_tier_min: 'Min Referrals',
    admin_ref_tier_discount: 'Discount (%)',
    admin_ref_settings_saved: 'Referral settings saved',

    // Transfer History
    history_title: 'Transfer History',
    history_subtitle: 'Your transfer records',
    history_empty_title: 'No transfer history',
    history_empty_desc: 'Your transfers will appear here',
    history_amount: 'Amount',

    // Exchange Calculator
    calc_title: 'Exchange Calculator',
    calc_subtitle: 'Simulate before sending',
    calc_amount_label: 'Amount to send (JPY)',
    calc_amount: 'Send Amount',
    calc_note: '* Exchange rates fluctuate. Final rate is determined at time of transfer.',

    // Login
    login_success: 'Login successful',
    login_error: 'Login failed',
    login_bio_success: 'Logged in with biometrics',
    login_bio_error: 'Biometric auth failed. Please use password.',
    login_go_register: 'Login',

    // Register
    register_go_login: 'Login',

    // Status
    status_pending: 'Pending',
    status_processing: 'Processing',
    status_completed: 'Completed',
    status_failed: 'Failed',
    status_cancelled: 'Cancelled',
    history_payment_status: 'Payment Status',
    payment_awaiting: 'Awaiting',
    payment_paid: 'Paid',
    payment_confirmed: 'Confirmed',

    // Calculator extra
    calc_rate_title: 'Exchange Rate Info',
    calc_market_rate: 'Market Rate',
    calc_markup: 'Markup',
    calc_applied_rate: 'Applied Rate',
    close: 'Close',
    create: 'Create',
    actions: 'Actions',
    details: 'Details',
    status: 'Status',
    date: 'Date',
    amount: 'Amount',
    method: 'Method',
    note: 'Note',
    all: 'All',
    active: 'Active',
    suspended: 'Suspended',
    restricted: 'Restricted',
    user: 'User',
    admin: 'Admin',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    submitted: 'Submitted',
    confirmed: 'Confirmed',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    yes: 'Yes',
    no: 'No',
    none: 'None',
    total: 'Total',
    jpy: 'JPY',
    brl: 'BRL',

    // Nav
    nav_dashboard: 'Dashboard',
    nav_deposit: 'Deposit',
    nav_send: 'Send',
    nav_recipients: 'Recipients',
    nav_history: 'History',
    nav_exchange: 'Exchange',
    nav_kyc: 'KYC Verification',
    nav_income_cert: 'Income Certificate',
    nav_residence_card: 'Residence Card',
    nav_notifications: 'Notifications',
    nav_profile: 'Profile',
    nav_support: 'Support',

    // Dashboard
    dashboard_greeting: 'Hello, {name}',
    dashboard_welcome: 'Welcome to PRC Remit Dashboard',
    dashboard_balance: 'Balance',
    dashboard_transfer_count: 'Transfers',
    dashboard_total_sent: 'Total sent',
    dashboard_deposit_btn: 'Deposit',
    dashboard_send_btn: 'Send',
    dashboard_send_money: 'Send Money',
    dashboard_send_desc: 'Send to Brazil',
    dashboard_recipients: 'Recipients',
    dashboard_recipients_desc: 'Add and manage',
    dashboard_history: 'History',
    dashboard_history_desc: 'View past transfers',
    dashboard_exchange_rate: 'Current Exchange Rate',
    dashboard_per_jpy: 'per 1 JPY',
    dashboard_open_calc: 'Open calculator',
    dashboard_recent: 'Recent Transfers',
    dashboard_view_all: 'View all',
    dashboard_no_transfers: 'No transfers yet',
    dashboard_first_transfer: 'Make your first transfer',

    // KYC
    kyc_required: 'KYC Verification Required',
    kyc_required_desc: 'Complete identity verification to send money.',
    kyc_start: 'Start KYC Verification',
    kyc_title: 'Identity Verification (KYC)',
    kyc_subtitle: 'Complete verification for secure transfers',
    kyc_status_title: 'KYC Submitted',
    kyc_status_under_review: 'Under review. Please wait for confirmation.',
    kyc_status_approved: 'KYC Approved',
    kyc_status_approved_desc: 'Your identity has been verified. You can now send money.',
    kyc_status_rejected: 'KYC Rejected',
    kyc_status_rejected_desc: 'Your verification was rejected. Please resubmit.',
    kyc_resubmit: 'Resubmit',
    kyc_submit_form: 'Submit identity documents',
    kyc_doc_type: 'Document type',
    kyc_doc_type_passport: 'Passport',
    kyc_doc_type_residence: 'Residence card',
    kyc_doc_type_license: "Driver's license",
    kyc_doc_number: 'Document number',
    kyc_full_name: 'Full name (as on document)',
    kyc_dob: 'Date of birth',
    kyc_address: 'Address',
    kyc_occupation: 'Occupation',
    kyc_purpose: 'Purpose of transfer',
    kyc_purpose_family: 'Family support',
    kyc_purpose_savings: 'Savings/Investment',
    kyc_purpose_education: 'Education',
    kyc_purpose_business: 'Business',
    kyc_purpose_other: 'Other',
    kyc_documents: 'Identity documents (image/PDF, up to 3)',
    kyc_upload: 'Click to select file',
    kyc_upload_limit: 'Upload limit reached',
    kyc_upload_desc: 'Front and back (JPEG, PNG, WebP, PDF - max 10MB)',
    kyc_uploading: 'Uploading...',
    kyc_submit_btn: 'Submit KYC documents',
    kyc_submitting: 'Submitting...',
    kyc_submitted_docs: 'Submitted documents',
    kyc_submitted_at: 'Submitted on',

    // Status
    status_pending: 'Pending',
    status_processing: 'Processing',
    status_completed: 'Completed',
    status_failed: 'Failed',
    status_cancelled: 'Cancelled',

    // Login
    login_title: 'Login',
    login_desc: 'Sign in to your account',
    login_no_account: "Don't have an account?",
    login_error: 'Invalid email or password',
    login_biometric: 'Login with biometrics',
    login_bio_required_title: 'Biometric authentication required',
    login_bio_required_desc: 'This account has biometric authentication enabled. Please verify with your fingerprint or Face ID.',
    login_bio_verify: 'Verify with biometrics',
    login_bio_locked: 'Maximum attempts exceeded. Please login with password.',
    login_bio_locked_hint: 'Biometric authentication temporarily locked. Please use password.',
    login_bio_waiting: 'Verifying biometrics...',
    login_bio_attempts: 'Attempts: {{current}}/{{max}}',
    login_bio_error: 'Biometric authentication failed',
    login_use_password: 'Login with password',
    login_2fa_title: 'Two-Factor Authentication',
    login_2fa_desc: 'Enter the 6-digit code from your authenticator app',
    login_2fa_verify: 'Verify',
    login_2fa_verifying: 'Verifying...',
    login_2fa_back: 'Back',

    // Register
    register_title: 'Sign Up',
    register_desc: 'Create your account',
    register_has_account: 'Already have an account?',
    register_btn: 'Sign Up',
    register_registering: 'Signing up...',

    // Deposit
    deposit_title: 'Balance & Deposits',
    deposit_subtitle: 'Deposit funds for transfers',
    deposit_card_title: 'Credit Card',
    deposit_card_subtitle: 'Instant credit',
    deposit_card_btn: 'Deposit with card',
    deposit_card_processing: 'Processing...',
    deposit_bank_title: 'Bank Transfer',
    deposit_bank_subtitle: 'Manual confirmation',
    deposit_bank_info: 'Bank details',
    deposit_bank_name: 'Bank',
    deposit_branch_name: 'Branch',
    deposit_account_type: 'Account type',
    deposit_account_number: 'Account number',
    deposit_account_holder: 'Account holder',
    deposit_amount: 'Deposit amount (JPY)',
    deposit_reference: 'Depositor name / Reference',
    deposit_receipt: 'Receipt (optional)',
    deposit_submit: 'Submit deposit request',
    deposit_history: 'Deposit History',
    deposit_no_history: 'No deposits yet',
    deposit_select_amount: 'Select an amount',
    deposit_success_title: 'Deposit Complete',
    deposit_success_reflected: 'Balance has been updated',
    deposit_success_go_dashboard: 'Go to Dashboard',
    deposit_pending_title: 'Processing',
    deposit_pending_desc: 'Payment is being processed. Please wait.',
    deposit_pending_back: 'Back to deposits',
    deposit_error_title: 'Error',
    deposit_error_desc: 'Failed to verify payment',
    deposit_checking: 'Verifying payment...',

    // Send Money
    send_title: 'Send Money',
    send_subtitle: 'Send money to Brazil securely',
    send_select_recipient: 'Select recipient',
    send_add_recipient: 'Add new recipient',
    send_amount_jpy: 'Amount (JPY)',
    send_fee: 'Fee',
    send_exchange_rate: 'Exchange rate',
    send_recipient_gets: 'Recipient gets',
    send_total: 'Total debit',
    send_balance: 'Balance',
    send_insufficient: 'Insufficient balance',
    send_deposit_first: 'Go to deposits',
    send_confirm: 'Confirm transfer',
    send_confirm_title: 'Confirm Transfer',
    send_confirm_desc: 'Send with the following details?',
    send_recipient: 'Recipient',
    send_execute: 'Send now',
    send_executing: 'Processing...',
    send_complete_title: 'Transfer Complete',
    send_complete_desc: 'Your transfer has been processed',
    send_transfer_id: 'Transfer ID',
    send_view_history: 'View history',
    send_new_transfer: 'New transfer',

    // Recipients
    recipients_title: 'Recipients',
    recipients_subtitle: 'Manage recipients in Brazil',
    recipients_add: 'Add recipient',
    recipients_none: 'No recipients yet',
    recipients_add_first: 'Add your first recipient',
    recipients_name: 'Recipient name',
    recipients_bank: 'Bank',
    recipients_branch: 'Branch code',
    recipients_account: 'Account number',
    recipients_type: 'Account type',
    recipients_pix: 'PIX key',
    recipients_cpf: 'CPF number',
    recipients_relationship: 'Relationship',
    recipients_edit: 'Edit recipient',
    recipients_delete_confirm: 'Delete this recipient?',
    recipients_checking: 'Checking',
    recipients_savings: 'Savings',

    // Transfer History
    history_title: 'Transfer History',
    history_subtitle: 'Past transfer records',
    history_no_records: 'No transfers yet',
    history_first_send: 'Make your first transfer',
    history_go_send: 'Go to send',
    history_recipient: 'Recipient',
    history_amount: 'Amount',
    history_fee: 'Fee',
    history_rate: 'Rate',
    history_date: 'Date',

    // Exchange Calculator
    exchange_title: 'Exchange Calculator',
    exchange_subtitle: 'JPY → BRL Real-time Rate',
    exchange_amount_label: 'Amount (JPY)',
    exchange_result: 'Recipient gets (BRL)',
    exchange_rate_label: 'Exchange rate',
    exchange_fee_label: 'Fee',
    exchange_total_label: 'Total debit',
    exchange_live: 'Live rate',

    // Profile
    profile_title: 'Profile',
    profile_subtitle: 'View and edit account information',
    profile_personal: 'Personal Information',
    profile_address: 'Address',
    profile_dob: 'Date of Birth',
    profile_occupation: 'Occupation',
    profile_income: 'Annual Income',
    profile_update: 'Update Profile',
    profile_updating: 'Updating...',
    profile_photo: 'Profile Photo',
    profile_stats: 'Usage Statistics',
    profile_total_transfers: 'Total Transfers',
    profile_total_amount: 'Total Sent',
    profile_total_recipients: 'Registered Recipients',
    profile_biometric: 'Biometric Authentication',
    profile_biometric_not_supported: 'Biometrics not supported in this browser',
    profile_biometric_register: 'Register biometrics',
    profile_biometric_add: 'Add another device',
    profile_biometric_max: 'Registration limit (5) reached',
    profile_biometric_registering: 'Registering...',
    profile_biometric_device: 'Device',
    profile_biometric_registered: 'Registered on',
    profile_2fa_title: 'Two-Factor Authentication (2FA)',
    profile_2fa_enabled: 'Enabled',
    profile_2fa_disabled: 'Disabled',
    profile_2fa_totp: 'TOTP Authenticator App',
    profile_2fa_active: 'Two-factor authentication is enabled',
    profile_2fa_enter_code: 'Enter authentication code',
    profile_2fa_disable: 'Disable',
    profile_2fa_setup: 'Set up 2FA',
    profile_2fa_setup_title: 'Set up Two-Factor Authentication',
    profile_2fa_scan_desc: 'Scan the QR code below with an authenticator app like Google Authenticator.',
    profile_2fa_manual: 'Manual entry secret key:',
    profile_2fa_code_label: 'Verification code',
    profile_2fa_code_placeholder: '6-digit code',
    profile_2fa_activate: 'Activate',

    // Support
    support_title: 'Support',
    support_subtitle: 'Contact us if you need help',
    support_faq: 'FAQ',
    support_contact: 'Contact',
    support_email: 'Email support',
    support_hours: 'Business hours',
    support_hours_value: 'Weekdays 9:00 - 18:00',

    // Notifications
    notif_title: 'Notifications',
    notif_mark_all: 'Mark all as read',
    notif_empty: 'No notifications',
    notif_view_all: 'View all notifications',
    notif_page_title: 'Notifications',
    notif_page_subtitle: 'Alerts and updates',
    notif_total: 'Total',
    notif_unread: 'Unread',
    notif_read: 'Read',
    notif_clear_read: 'Clear read',
    notif_filter_all: 'All',
    notif_filter_unread: 'Unread',
    notif_filter_read: 'Read',
    notif_filter_empty: 'No notifications found',
    notif_view_detail: 'View details',
    notif_mark_read: 'Mark as read',

    // Admin Nav
    admin_nav_dashboard: 'Dashboard',
    admin_nav_users: 'Users',
    admin_nav_transfers: 'Transfers',
    admin_nav_deposits: 'Deposits',
    admin_nav_kyc: 'KYC Review',
    admin_nav_income_cert: 'Income Certificates',
    admin_nav_residence_card: 'Residence Cards',
    admin_nav_email: 'Email',
    admin_nav_aml: 'AML Monitor',
    admin_nav_balance_cert: 'Balance Certificates',

    // Balance Certificate
    bal_cert_title: 'Balance Certificates',
    bal_cert_subtitle: 'Manage balance certificate issuance and delivery',
    bal_cert_send_all: 'Send to all',
    bal_cert_send_all_confirm: 'Send balance certificates to all users?',
    bal_cert_sent: '{count} certificates sent',
    bal_cert_send_failed: 'Failed to send',
    bal_cert_delete_confirm: 'Delete this record?',
    bal_cert_schedule_settings: 'Schedule Settings',
    bal_cert_schedule_desc: 'Configure automatic balance certificate delivery',
    bal_cert_schedule_saved: 'Schedule saved',
    bal_cert_auto_schedule: 'Auto Schedule',
    bal_cert_auto_enabled: 'Enable auto send',
    bal_cert_schedule_disabled: 'Disabled',
    bal_cert_day_of_week: 'Day of week',
    bal_cert_hour: 'Hour',
    bal_cert_minute: 'Minute',
    bal_cert_col_date: 'Issued Date',
    bal_cert_col_user: 'User',
    bal_cert_col_balance: 'Balance',
    bal_cert_col_email_status: 'Email Status',
    bal_cert_col_type: 'Type',
    bal_cert_sent_status: 'Sent',
    bal_cert_unsent_status: 'Not sent',
    bal_cert_type_auto: 'Auto',
    bal_cert_type_manual: 'Manual',
    bal_cert_empty: 'No certificates found',
    bal_cert_detail_title: 'Certificate Details',
    bal_cert_sent_at: 'Sent at',
    day_monday: 'Monday',
    day_tuesday: 'Tuesday',
    day_wednesday: 'Wednesday',
    day_thursday: 'Thursday',
    day_friday: 'Friday',
    day_saturday: 'Saturday',
    day_sunday: 'Sunday',
    admin_nav_reports: 'Reports',
    admin_nav_settings: 'Settings',
    admin_nav_company: 'Company',

    // Company Profile
    company_admin_title: 'Company Profile',
    company_admin_subtitle: 'Manage company information shown on public pages',
    company_page_title: 'About Us',
    company_page_subtitle: 'About PRC Remit',
    company_back: 'Back',
    company_no_data: 'Company information not yet registered',
    company_company_name: 'Company Name',
    company_representative: 'Representative',
    company_established: 'Established',
    company_capital: 'Capital',
    company_license_number: 'License Number',
    company_address: 'Address',
    company_phone: 'Phone',
    company_email: 'Email',
    company_website: 'Website',
    company_business_description: 'Business Description',
    company_save_btn: 'Save Company Profile',
    company_saved: 'Company profile updated',
    company_save_failed: 'Failed to save',

    // Legal Pages (Terms & Privacy)
    admin_nav_terms: 'Terms of Service',
    admin_nav_privacy: 'Privacy Policy',
    legal_title_label: 'Title',
    legal_revised_label: 'Last revised',
    legal_content_label: 'Content',
    legal_content_hint: 'Line breaks are preserved as-is',
    legal_last_revised: 'Last revised',
    legal_no_data: 'Not yet registered',
    terms_admin_title: 'Terms of Service',
    terms_admin_subtitle: 'Manage terms of service shown on public pages',
    terms_page_title: 'Terms of Service',
    terms_title_placeholder: 'PRC Remit Terms of Service',
    terms_content_placeholder: 'Enter terms of service content...',
    terms_save_btn: 'Save Terms',
    terms_saved: 'Terms of service updated',
    terms_save_failed: 'Failed to save',
    privacy_admin_title: 'Privacy Policy',
    privacy_admin_subtitle: 'Manage privacy policy shown on public pages',
    privacy_page_title: 'Privacy Policy',
    privacy_title_placeholder: 'PRC Remit Privacy Policy',
    privacy_content_placeholder: 'Enter privacy policy content...',
    privacy_save_btn: 'Save Policy',
    privacy_saved: 'Privacy policy updated',
    privacy_save_failed: 'Failed to save',

    // Content Pages
    content_save_failed: 'Failed to save',
    admin_nav_transfer_methods: 'Transfer Methods',
    admin_nav_pricing: 'Pricing',
    admin_nav_faq: 'FAQ',
    admin_nav_footer: 'Footer',
    tm_admin_title: 'Transfer Methods',
    tm_admin_subtitle: 'Manage transfer methods shown on public pages',
    tm_page_title: 'Transfer Methods',
    tm_title_placeholder: 'PRC Remit Transfer Methods',
    tm_content_placeholder: 'Enter transfer methods content...',
    tm_save_btn: 'Save',
    transfer_methods_saved: 'Transfer methods updated',
    pricing_admin_title: 'Pricing',
    pricing_admin_subtitle: 'Manage pricing information shown on public pages',
    pricing_page_title: 'Pricing',
    pricing_title_placeholder: 'PRC Remit Pricing',
    pricing_content_placeholder: 'Enter pricing information...',
    pricing_save_btn: 'Save',
    pricing_saved: 'Pricing updated',
    faq_admin_title: 'FAQ',
    faq_admin_subtitle: 'Manage frequently asked questions',
    faq_page_title: 'Frequently Asked Questions',
    faq_page_subtitle: 'Common questions about PRC Remit',
    faq_add: 'Add Question',
    faq_save_btn: 'Save FAQ',
    faq_saved: 'FAQ updated',
    faq_empty: 'No FAQs registered yet',
    faq_question_placeholder: 'Enter question',
    faq_answer_placeholder: 'Enter answer',
    footer_admin_title: 'Footer Settings',
    footer_admin_subtitle: 'Manage the footer text shown on the landing page',
    footer_text_label: 'Footer Text',
    footer_text_hint: 'Displayed at the bottom of the landing page',
    footer_preview: 'Preview',
    footer_save_btn: 'Save Footer',
    footer_saved: 'Footer updated',
    admin_title: 'Admin',

    // Admin Dashboard
    admin_dash_total_users: 'Total Users',
    admin_dash_total_transfers: 'Total Transfers',
    admin_dash_pending_kyc: 'Pending KYC',
    admin_dash_aml_flags: 'AML Flags',

    // Admin Users
    admin_users_title: 'User Management',
    admin_users_subtitle: 'Manage and edit users',
    admin_users_create: 'New User',
    admin_users_edit: 'Edit User',
    admin_users_role_admin: 'Admin',
    admin_users_role_user: 'User',
    admin_users_create_desc: 'Create a user as admin',
    admin_users_search: 'Search users...',
    admin_users_actions: 'Actions',
    admin_users_balance: 'Balance',
    admin_users_role: 'Role',
    admin_users_kyc: 'KYC',
    admin_users_status: 'Status',
    admin_users_no_results: 'No users found',
    admin_users_create_title: 'Create User',
    admin_users_edit_title: 'Edit User',
    admin_users_kyc_status: 'KYC Status',
    admin_users_account_status: 'Account Status',
    admin_users_initial_balance: 'Initial Balance (JPY)',
    admin_users_not_submitted: 'Not submitted',
    admin_users_balance_adjust: 'Adjust Balance',
    admin_users_balance_add: 'Add',
    admin_users_balance_subtract: 'Subtract',
    admin_users_balance_amount: 'Amount',
    admin_users_balance_reason: 'Reason',
    admin_users_balance_current: 'Current Balance',
    admin_users_balance_after: 'Balance After',
    admin_users_detail_title: 'User Details',
    admin_users_basic_info: 'Basic Info',
    admin_users_deposit_history: 'Deposit History',
    admin_users_transfer_history: 'Transfer History',
    admin_users_no_deposits: 'No deposits',
    admin_users_no_transfers: 'No transfers',
    admin_users_delete_confirm: 'Delete this user? This action cannot be undone.',

    // Admin Transfers
    admin_transfers_title: 'Transfer Management',
    admin_transfers_subtitle: 'Manage and update transfer status',
    admin_transfers_search: 'Search transfers...',
    admin_transfers_filter_status: 'Filter by status',
    admin_transfers_sender: 'Sender',
    admin_transfers_recipient: 'Recipient',
    admin_transfers_amount_jpy: 'Amount (JPY)',
    admin_transfers_amount_brl: 'Amount (BRL)',
    admin_transfers_rate: 'Rate',
    admin_transfers_fee: 'Fee',
    admin_transfers_no_results: 'No transfers found',
    admin_transfers_detail: 'Transfer Details',
    admin_transfers_edit: 'Edit Transfer Status',
    admin_transfers_delete_confirm: 'Delete this transfer?',

    // Admin Deposits
    admin_deposits_title: 'Deposit Management',
    admin_deposits_subtitle: 'Manage and approve deposits',
    admin_deposits_create: 'Add Deposit',
    admin_deposits_search: 'Search deposits...',
    admin_deposits_filter_status: 'Filter by status',
    admin_deposits_user: 'User',
    admin_deposits_no_results: 'No deposits found',
    admin_deposits_deposit_id: 'Deposit ID',
    admin_deposits_detail: 'Deposit Details',
    admin_deposits_edit: 'Edit Deposit',
    admin_deposits_approve: 'Approve',
    admin_deposits_reject: 'Reject',
    admin_deposits_delete_confirm: 'Delete this deposit?',
    admin_deposits_create_title: 'Add Deposit',
    admin_deposits_user_id: 'User ID',

    // Admin KYC
    admin_kyc_title: 'KYC Review',
    admin_kyc_subtitle: 'Review identity documents',
    admin_kyc_search: 'Search KYC...',
    admin_kyc_filter_status: 'Filter by status',
    admin_kyc_doc_type: 'Document type',
    admin_kyc_doc_number: 'Document number',
    admin_kyc_submitted_at: 'Submitted on',
    admin_kyc_no_results: 'No KYC requests found',
    admin_kyc_approve: 'Approve',
    admin_kyc_reject: 'Reject',
    admin_kyc_edit: 'Edit KYC',
    admin_kyc_documents: 'Submitted Documents',
    admin_kyc_preview: 'Document Preview',
    admin_kyc_purpose: 'Purpose of Transfer',
    admin_kyc_passport: 'Passport',
    admin_kyc_residence_card: 'Residence Card',
    admin_kyc_drivers_license: "Driver's License",

    // Admin AML
    admin_aml_title: 'AML Monitor',
    admin_aml_subtitle: 'Anti-Money Laundering',
    admin_aml_search: 'Search AML flags...',
    admin_aml_user: 'User',
    admin_aml_flag_type: 'Flag type',
    admin_aml_risk_level: 'Risk level',
    admin_aml_description: 'Description',
    admin_aml_transfer_id: 'Transfer ID',
    admin_aml_no_results: 'No AML flags found',
    admin_aml_delete_confirm: 'Delete this AML flag?',
    admin_aml_risk_high: 'High',
    admin_aml_risk_medium: 'Medium',
    admin_aml_risk_low: 'Low',

    // Admin Reports
    admin_reports_title: 'Reports',
    admin_reports_subtitle: 'Transfer, user, and revenue statistics',
    admin_reports_total_transfers: 'Total Transfers',
    admin_reports_total_volume: 'Total Volume',
    admin_reports_fee_revenue: 'Fee Revenue',
    admin_reports_total_users: 'Total Users',
    admin_reports_this_month: 'This month',
    admin_reports_kyc_approved: 'KYC approved',
    admin_reports_daily_chart: 'Last 7 Days Volume',
    admin_reports_daily_chart_desc: 'Daily transfer volume and count',
    admin_reports_user_stats: 'User Statistics',
    admin_reports_user_stats_desc: 'Active users and KYC status',
    admin_reports_active_users: 'Active Users',
    admin_reports_kyc_approved_users: 'KYC Approved',
    admin_reports_new_users: 'New this month',
    admin_reports_today_transfers: "Today's transfers",
    admin_reports_week_transfers: "This week's transfers",
    admin_reports_top_users: 'Top Users by Volume',
    admin_reports_top_users_desc: 'Cumulative transfer volume ranking',
    admin_reports_no_data: 'No data',
    admin_reports_rank: '#',
    admin_reports_count: 'Transfers',
    admin_reports_volume: 'Total Volume',

    // Admin Settings
    admin_settings_title: 'Fee Settings',
    admin_settings_subtitle: 'Configure transfer fees and markup',
    admin_settings_flat_fee: 'Flat Fee (JPY)',
    admin_settings_markup: 'Exchange Markup (%)',
    admin_settings_save: 'Save Settings',
    admin_settings_saving: 'Saving...',
    admin_settings_reset: 'Reset',
    admin_settings_revenue: 'Revenue Structure',
    admin_settings_fee_per: 'Fixed fee revenue',
    admin_settings_spread_per: 'Spread revenue',
    admin_settings_total_revenue: 'Total revenue',
    admin_settings_per_transfer: '/ transfer',
    admin_settings_bank_title: 'Bank Details',
    admin_settings_bank_subtitle: 'Bank account info shown on user deposit page',
    admin_settings_bank_name: 'Bank Name',
    admin_settings_branch_name: 'Branch Name',
    admin_settings_account_type: 'Account Type',
    admin_settings_account_number: 'Account Number',
    admin_settings_account_holder: 'Account Holder',
    admin_settings_bank_notes: 'Notes (optional)',
    admin_settings_bank_save: 'Save Bank Details',

    // Logo Settings
    admin_settings_logo_title: 'Company Logo',
    admin_settings_logo_subtitle: 'Logo displayed across the site',
    admin_settings_logo_current: 'Current Logo',
    admin_settings_logo_upload: 'Upload Logo',
    admin_settings_logo_uploading: 'Uploading...',
    admin_settings_logo_change: 'Change Logo',
    admin_settings_logo_delete: 'Delete Logo',
    admin_settings_logo_deleting: 'Deleting...',
    admin_settings_logo_success: 'Logo uploaded successfully',
    admin_settings_logo_delete_success: 'Logo deleted',
    admin_settings_logo_error: 'Failed to upload logo',
    admin_settings_logo_delete_error: 'Failed to delete logo',
    admin_settings_logo_formats: 'Formats: JPEG, PNG, WebP, SVG (max 5MB)',
    admin_settings_logo_default: 'Using default logo',

    // Landing Settings
    admin_settings_landing_title: 'Landing Page Display',
    admin_settings_landing_subtitle: 'Amount displayed in the calculator widget on the landing page',
    admin_settings_landing_amount_label: 'Display Amount (JPY)',
    admin_settings_landing_amount_desc: 'Sample remittance amount shown in the hero section of the landing page',
    admin_settings_landing_saved: 'Display settings saved',
    admin_settings_landing_error: 'Failed to save settings',
    admin_settings_landing_invalid: 'Please enter a valid amount',
    admin_settings_hero_title: 'Hero Text Editor',
    admin_settings_hero_line1: 'Title line 1',
    admin_settings_hero_line2: 'Title line 2 (accent color)',
    admin_settings_hero_line3: 'Title line 3',
    admin_settings_hero_desc: 'Description',
    admin_settings_hero_hint: 'Leave blank to use default text. Use JA/PT/EN tabs to edit each language.',

    // Market Rate Settings
    settings_market_rate_title: 'Market Exchange Rate',
    settings_market_rate_subtitle: 'Auto-updated every 3 hours via Frankfurter API (ECB)',
    settings_current_rate: 'Current Market Rate',
    settings_manual_mode: 'Manual',
    settings_live_mode: 'Live',
    settings_last_updated: 'Last Updated',
    settings_source: 'Source',
    settings_source_manual: 'Manual override',
    settings_auto_refresh: 'Auto Refresh',
    settings_every_3h: 'Every 3 hours',
    settings_next_refresh: 'Next refresh',
    settings_refresh_now: 'Refresh Now',
    settings_refreshing: 'Refreshing...',
    settings_manual_rate: 'Manual Rate',
    settings_override: 'Override',
    settings_enable_auto: 'Enable Auto',
    settings_rate_refreshed: 'Exchange rate updated',
    settings_rate_refresh_failed: 'Failed to update rate',
    settings_rate_invalid: 'Please enter a valid rate',
    settings_rate_overridden: 'Rate manually overridden',
    settings_rate_auto_enabled: 'Automatic rate fetching enabled',
    settings_fee_title: 'Fee Settings',
    settings_flat_fee_desc: 'Fixed fee added to each transfer',
    settings_markup_desc: 'Markup applied on market exchange rate',
    settings_saved: 'Fee settings updated',
    settings_save_failed: 'Failed to save settings',
    settings_bank_saved: 'Bank details saved',
    settings_bank_save_failed: 'Failed to save bank details',
    settings_simulation_title: 'Simulation',
    settings_sim_amount: 'Transfer amount',
    settings_sim_fee: 'Fixed fee',
    settings_sim_total: 'Total paid',
    settings_sim_market_rate: 'Market rate',
    settings_sim_applied_rate: 'Applied rate (after markup)',
    settings_sim_receive: 'Recipient gets',

    // Admin Login
    admin_login_title: 'Admin Login',
    admin_login_desc: 'Sign in with admin account',

    // Login
    login_success: 'Login successful',
    login_fail: 'Login failed',
    login_email_not_verified: 'Email not verified. Please check your email for the verification code.',

    // Deposit extra
    deposit_receipt_upload_fail: 'Failed to upload file',

    // Send extra
    send_kyc_required: 'KYC verification required',
    send_select_recipient: 'Please select a recipient',
    send_insufficient_balance: 'Insufficient balance. Please deposit funds first.',

    // Admin Toast Messages
    admin_users_created: 'User created',
    admin_users_create_failed: 'Failed to create user',
    admin_users_updated: 'User updated',
    admin_users_update_failed: 'Failed to update user',
    admin_users_deleted: 'User deleted',
    admin_users_delete_failed: 'Failed to delete user',
    admin_users_balance_updated: 'Balance updated',
    admin_users_balance_failed: 'Failed to update balance',
    admin_users_password_placeholder: 'Enter new password (leave blank to keep current)',
    admin_users_password_hint: 'Leave blank to keep current password. Minimum 6 characters.',
    admin_users_deposit_added: 'Deposit added',
    admin_users_deposit_failed: 'Failed to add deposit',
    admin_transfers_updated: 'Transfer updated',
    admin_transfers_update_failed: 'Failed to update transfer',
    admin_transfers_deleted: 'Transfer record deleted',
    admin_transfers_delete_failed: 'Failed to delete transfer',
    admin_transfers_delete_confirm: 'Delete this transfer?',
    admin_transfers_payment_status: 'Payment Status',
    admin_transfers_period_filter: 'Period filter',
    admin_transfers_count_records: ' transfer records',
    admin_transfers_transfer_id: 'Transfer ID',
    admin_kyc_reviewed: 'KYC {action}',
    admin_kyc_review_failed: 'Failed to review KYC',
    admin_kyc_updated: 'KYC updated',
    admin_kyc_update_failed: 'Failed to update KYC',
    admin_kyc_notes: 'Review Notes',
    admin_kyc_notes_placeholder: 'Enter review notes...',
    admin_kyc_review_title: 'KYC Review',
    admin_deposits_confirmed: 'Deposit approved',
    admin_deposits_confirm_failed: 'Failed to approve deposit',
    admin_deposits_rejected: 'Deposit rejected',
    admin_deposits_reject_failed: 'Failed to reject deposit',
    admin_deposits_reject_confirm: 'Reject this deposit?',
    admin_deposits_deleted: 'Deposit deleted',
    admin_deposits_delete_failed: 'Failed to delete deposit',
    admin_deposits_pending_count: 'Pending: {count}',
    admin_deposits_method_bank: 'Bank transfer',
    admin_deposits_method_convenience: 'Convenience store',
    admin_deposits_method_admin: 'Admin manual',
    admin_deposits_method_stripe: 'Stripe',
    admin_deposits_status_confirmed: 'Confirmed',
    admin_deposits_status_rejected: 'Rejected',
    admin_aml_resolved: 'AML flag resolved',
    admin_aml_resolve_failed: 'Failed to resolve AML flag',
    admin_aml_deleted: 'AML flag deleted',
    admin_aml_delete_failed: 'Failed to delete AML flag',
    admin_aml_risk_prefix: 'Risk',
    admin_aml_status_open: 'Open',
    admin_aml_status_investigating: 'Investigating',
    admin_aml_status_resolved: 'Resolved',
    admin_aml_status_false_positive: 'False positive',
    admin_aml_resolve: 'Resolve',
    admin_aml_investigate: 'Investigate',
    admin_aml_false_positive_btn: 'False positive',
    admin_reports_loading: 'Loading...',
    admin_reports_error: 'Failed to load data',
    admin_data_not_found: 'Data not found',
    status_active: 'Active',
    status_suspended: 'Suspended',
    status_frozen: 'Frozen',
    all: 'All',

    // Back to home
    back_to_home: 'Back to Home',
    // Count suffix
    count_suffix: 'x',
    count_people: '',
    count_items: '',

    // Profile extra
    profile_account_info: 'Account information and statistics',
    profile_bio_success: 'Biometrics registered. Use fingerprint for next login.',
    profile_bio_cancel: 'Biometric registration cancelled',
    profile_bio_fail: 'Failed to register biometrics',
    profile_bio_delete_confirm: 'Delete this biometric credential?',
    profile_bio_deleted: 'Biometric credential deleted',
    profile_bio_delete_fail: 'Failed to delete biometric credential',
    profile_2fa_setup_fail: 'Failed to start 2FA setup',
    profile_2fa_verified: 'Two-factor authentication enabled',
    profile_2fa_invalid_code: 'Invalid authentication code',
    profile_2fa_disabled_msg: 'Two-factor authentication disabled',
    profile_updated: 'Profile updated',
    profile_update_fail: 'Failed to update profile',
    profile_image_size: 'File size must be 5MB or less',
    profile_image_updated: 'Profile photo updated',
    profile_image_fail: 'Failed to upload image',
    profile_not_set: 'Not set',
    profile_basic_info: 'Basic Information',
    profile_annual_income_unit: '万円',
    profile_registered_at: 'Registered',
    profile_kyc_docs: 'Identity Documents',
    profile_go_kyc: 'Go to KYC',
    profile_kyc_status_label: 'KYC Status',
    profile_kyc_needed: 'Verification required',
    profile_kyc_under_review: 'Under review',
    profile_kyc_completed: 'Verification complete',
    profile_kyc_rejected_msg: 'Verification rejected',
    profile_recent_transfers: 'Recent Transfers',
    profile_bio_fingerprint: 'Biometric (Fingerprint)',
    profile_bio_login_desc: 'Login with fingerprint/Face ID',
    profile_bio_device_name: 'Biometric device',
    profile_bio_none_desc: 'No biometrics registered. Register to use fingerprint or Face ID for login.',

    // KYC extra
    kyc_submitted_toast: 'KYC application submitted',
    kyc_submit_fail: 'Failed to submit KYC',
    kyc_files_uploaded: '{count} file(s) uploaded',
    kyc_upload_fail: 'Failed to upload file',
    kyc_status_pending_title: 'Under Review',
    kyc_status_pending_desc: 'Your KYC is being reviewed. Usually takes 1-2 business days.',
    kyc_status_approved_title: 'Approved',
    kyc_status_approved_full: 'KYC verification complete. You can now send money.',
    kyc_status_rejected_title: 'Rejected',
    kyc_status_rejected_full: 'KYC application was rejected. See details below.',
    kyc_reviewer_notes: 'Reviewer Notes',
    kyc_page_subtitle: 'Identity verification process',
    kyc_form_title: 'Submit Identity Documents',
    kyc_form_desc: 'KYC verification is required to send money. Please fill in the information below.',
    kyc_doc_type_label: 'Document type',
    kyc_full_name_label: 'Full name (as on document)',
    kyc_purpose_placeholder: 'e.g. Family support, tuition payment, etc.',
    kyc_submit_button: 'Submit KYC',

    // KYC residence
    kyc_residence_section: 'Residence Information',
    kyc_residence_status: 'Residence Status',
    kyc_residence_status_placeholder: 'Select status',
    kyc_residence_card_number: 'Residence Card Number',
    kyc_residence_period: 'Period of Stay (Expiry Date)',
    kyc_residence_permanent: 'Permanent Resident',
    kyc_residence_long_term: 'Long-term Resident',
    kyc_residence_spouse: 'Spouse of Japanese National',
    kyc_residence_work: 'Work Visa',
    kyc_residence_student: 'Student',
    kyc_residence_technical: 'Technical Intern',
    kyc_residence_specified: 'Specified Skilled Worker',
    kyc_residence_other: 'Other',

    // KYC photo sides
    kyc_photo_front: 'Front',
    kyc_photo_back: 'Back',
    kyc_photo_angled: 'Angled',
    kyc_photo_desc: 'Upload photos of your document from 3 angles (front, back, and angled).',

    // Recipients extra
    recipients_added: 'Recipient added',
    recipients_add_fail: 'Failed to add recipient',
    recipients_deleted: 'Recipient deleted',
    recipients_delete_fail: 'Failed to delete recipient',
    recipients_new_title: 'Add New Recipient',
    recipients_new_desc: 'Enter the recipient details',
    recipients_method: 'Receiving method',
    recipients_bank_account: 'Bank account',
    recipients_pix_placeholder: 'CPF, Email, Phone, or Random key',
    recipients_branch_number: 'Branch number',
    recipients_nationality: 'Nationality',
    recipients_postal_code: 'Postal code',
    recipients_address: 'Address',
    recipients_phone: 'Phone number',
    recipients_email: 'Email',
    recipients_transfer_purpose: 'Transfer purpose',
    recipients_fund_source: 'Source of funds',
    recipients_edit_title: 'Edit recipient',
    recipients_edit_desc: 'Update recipient information',
    recipients_updated: 'Recipient updated',
    recipients_update_fail: 'Failed to update recipient',
    recipients_save: 'Save',
    recipients_personal_info: 'Personal information',
    recipients_bank_info: 'Bank information',
    recipients_transfer_info: 'Transfer information',
    recipients_relationship_family: 'Family',
    recipients_relationship_friend: 'Friend',
    recipients_relationship_business: 'Business',
    recipients_relationship_self: 'Self',
    recipients_relationship_other: 'Other',
    recipients_purpose_living: 'Living expenses',
    recipients_purpose_education: 'Education',
    recipients_purpose_business: 'Business',
    recipients_purpose_investment: 'Investment',
    recipients_purpose_gift: 'Gift',
    recipients_purpose_other: 'Other',
    recipients_fund_salary: 'Salary',
    recipients_fund_savings: 'Savings',
    recipients_fund_business: 'Business income',
    recipients_fund_investment: 'Investment returns',
    recipients_fund_other: 'Other',

    // Recipient Invitation
    invite_title: 'Invite Recipient',
    invite_subtitle: 'Ask the recipient to enter their information directly',
    invite_name: 'Recipient name',
    invite_email: 'Recipient email',
    invite_email_optional: '(Optional - send invite link via email)',
    invite_send: 'Create invite link',
    invite_sending: 'Creating...',
    invite_success: 'Invite link created',
    invite_fail: 'Failed to create invitation',
    invite_link_label: 'Invite link',
    invite_copied: 'Link copied',
    invite_share_email: 'Email',
    invite_share_line: 'LINE',
    invite_share_whatsapp: 'WhatsApp',
    invite_share_copy: 'Copy',
    invite_share_title: 'Choose how to share',
    invite_share_message: '{name}, please enter your recipient information at: {link}',
    invite_pending: 'Pending',
    invite_completed: 'Completed',
    invite_tab_list: 'Recipient list',
    invite_tab_invitations: 'Manage invitations',
    invite_empty: 'No invitations',
    invite_delete_confirm: 'Delete this invitation?',
    invite_deleted: 'Invitation deleted',
    invite_btn: 'Invite to fill in',
    invite_form_title: 'Enter Recipient Information',
    invite_form_subtitle: '{sender} would like to register you as a transfer recipient. Please enter your information below.',
    invite_form_submit: 'Submit information',
    invite_form_submitting: 'Submitting...',
    invite_form_success_title: 'Information submitted',
    invite_form_success_desc: 'Your information has been shared with the sender. Thank you!',
    invite_form_expired: 'This link has already been used',
    invite_form_not_found: 'Invitation not found',
    invite_email_sent: 'Email sent',

    // Document pages
    income_cert_title: 'Income Certificate',
    income_cert_desc: 'Upload a photo of your income certificate',
    income_cert_photo: 'Document photo',
    income_cert_annual: 'Annual income',
    income_cert_monthly: 'Monthly salary',
    residence_card_title: 'Residence Card',
    residence_card_desc: 'Upload a photo of your residence card',
    residence_card_photo: 'Residence card photo',
    residence_card_number: 'Card number',
    residence_card_expiry: 'Expiry date',
    residence_card_front: 'Front side',
    residence_card_back: 'Back side',
    residence_card_both_required: 'Both front and back photos are required',
    doc_status_pending: 'Under review',
    doc_status_approved: 'Approved',
    doc_status_rejected: 'Rejected',
    doc_status_not_submitted: 'Not submitted',
    doc_photo_uploaded: 'Photo uploaded',
    doc_upload_fail: 'Upload failed',
    doc_photo_required: 'Photo is required',
    doc_submitted: 'Submitted successfully',
    doc_submit_fail: 'Submission failed',
    doc_submit: 'Submit',
    doc_submitting: 'Submitting...',
    doc_click_upload: 'Click to upload photo',
    doc_uploading: 'Uploading...',
    doc_change_photo: 'Change photo',
    doc_submitted_at: 'Submitted on',
    doc_reviewer_notes: 'Reviewer notes',
    doc_delete_confirm: 'Are you sure you want to delete?',
    doc_deleted: 'Deleted',
    doc_delete_fail: 'Failed to delete',
    doc_delete_resubmit: 'Delete and resubmit',
    doc_update: 'Update',
    doc_updating: 'Updating...',
    doc_updated: 'Updated',
    doc_update_confirm: 'Update this document? Status will be changed to pending review.',
    doc_add_new: 'Add New',
    doc_history: 'History',
    doc_current: 'Current',
    admin_income_cert_title: 'Income Certificates',
    admin_income_cert_desc: 'View and edit income certificates',
    admin_income_cert_review: 'Review income certificate',
    admin_income_cert_edit: 'Edit income certificate',
    admin_residence_card_title: 'Residence Cards',
    admin_residence_card_desc: 'View and edit residence cards',
    admin_residence_card_review: 'Review residence card',
    admin_residence_card_edit: 'Edit residence card',
    admin_doc_user: 'User',
    admin_doc_status: 'Status',
    admin_doc_actions: 'Actions',
    admin_doc_approve: 'Approve',
    admin_doc_reject: 'Reject',
    admin_doc_approved: 'Approved',
    admin_doc_rejected: 'Rejected',
    admin_doc_updated: 'Updated',
    admin_no_documents: 'No documents',
    admin_email_title: 'Email Management',
    admin_email_desc: 'Send and receive emails',
    admin_email_refresh: 'Refresh',
    admin_email_compose: 'Compose',
    admin_email_compose_desc: 'Send an email',
    admin_email_from: 'From',
    admin_email_to: 'To',
    admin_email_subject: 'Subject',
    admin_email_body: 'Body',
    admin_email_date: 'Date',
    admin_email_send: 'Send',
    admin_email_sending: 'Sending...',
    admin_email_sent: 'Email sent',
    admin_email_reply: 'Reply',
    admin_email_back: 'Back',
    admin_email_messages: 'messages',
    admin_email_empty: 'No emails',
    admin_email_fetch_fail: 'Failed to fetch emails',
    admin_email_fill_all: 'Please fill all fields',
    admin_email_manage_accounts: 'Manage accounts',
    admin_email_accounts_title: 'Email accounts',
    admin_email_add_account: 'Add account',
    admin_email_add_account_desc: 'Enter the email account connection details',
    admin_email_address: 'Email address',
    admin_email_password: 'Password',
    admin_email_label: 'Label',
    admin_email_server: 'Server',
    admin_email_port: 'Port',
    admin_email_test: 'Test',
    admin_email_test_ok: 'Connection successful',
    admin_email_account_added: 'Account added',
    admin_email_account_deleted: 'Account deleted',
    admin_email_delete_confirm: 'Delete this account?',
    admin_email_no_accounts: 'No accounts',

    // Register extra
    register_password_mismatch: 'Passwords do not match',
    register_password_min: 'Password must be at least 6 characters',
    register_success: 'Registration successful',
    register_fail: 'Registration failed',
    register_create_account: 'Create Account',
    register_phone_optional: 'Phone (optional)',
    register_confirm_password: 'Confirm Password',
    register_name_placeholder: 'Full Name',

    // Support extra
    support_contact_methods: 'Contact Methods',
    support_email_title: 'Email',
    support_email_desc: 'We reply within 24 hours',
    support_phone_title: 'Phone',
    support_phone_hours: 'Weekdays 9:00-18:00',
    support_chat_title: 'Chat',
    support_chat_desc: 'Instant support',
    support_chat_start: 'Start chat',
    support_faq_q1: 'How long does a transfer take?',
    support_faq_a1: 'Via PIX, within minutes. Via bank transfer, within 24 hours.',
    support_faq_q2: 'What are the fees?',
    support_faq_a2: 'A flat fee of ¥500 per transfer. No hidden costs.',
    support_faq_q3: 'Is KYC verification required?',
    support_faq_a3: 'Yes, KYC is mandatory under Japanese law for money transfers.',
    support_faq_q4: 'Is there a transfer limit?',
    support_faq_a4: 'The maximum is ¥1,000,000 per transfer. Contact support for larger amounts.',

    // Admin Dashboard extra
    admin_dash_title: 'Dashboard',
    admin_dash_subtitle: 'System overview',
    admin_dash_total_volume: 'Total Volume',
    admin_dash_pending_kyc_alert: 'Pending KYC: {count}',
    admin_dash_pending_kyc_desc: 'KYC applications awaiting review',
    admin_dash_deposits: 'Total Deposits',
    admin_dash_pending_deposits: 'deposits pending',
    admin_dash_pending_deposits_desc: 'Deposits awaiting approval',
    admin_dash_aml_alert: 'AML flags',
    admin_dash_aml_alert_desc: 'AML flags require review',
    admin_dash_aml_open: 'Open flags',
    admin_dash_referral_uses: 'Referral uses',
    admin_dash_email_accounts: 'Email accounts',
    admin_dash_recipients: 'Recipients',
    admin_dash_registered: 'Registered',
    admin_dash_documents: 'Document Management',
    admin_dash_management: 'Other Management',
    admin_dash_recent_transfers: 'Recent Transfers',
    admin_dash_recent_users: 'Recent Users',
    view_all: 'View all',
    total: 'Total',
    pending: 'Pending',
    no_data: 'No data',
    loading: 'Loading...',

    // Admin Login extra
    admin_login_no_permission: 'Admin access not authorized',
    admin_login_success: 'Login successful',
    admin_login_fail: 'Login failed',
    admin_login_loading: 'Logging in...',

    // Missing keys - General
    deposit: 'Deposit',
    saving: 'Saving...',
    login_or: 'or',
    not_entered: 'Not entered',
    no_records: 'No records',
    error_occurred: 'An error occurred',

    // Deposit page
    deposit_invalid_amount: 'Please enter a valid amount',
    deposit_submitted: 'Deposit request submitted',
    deposit_submit_failed: 'Failed to submit deposit request',
    deposit_reference_placeholder: 'Depositor name, date, etc.',
    deposit_receipt_label: 'Upload receipt photo',
    deposit_receipt_alt: 'Receipt',
    deposit_receipt_preview_alt: 'Transfer receipt',

    // Print-related
    print_title_history: 'PRC Remit - Transfer History',
    print_title_admin: 'PRC Remit - Transfer Management',
    print_date: 'Print Date',
    print_period: 'Period',
    print_period_all: 'All periods',
    print_no_start: 'No start date',
    print_no_end: 'No end date',
    print_total_jpy: 'Total Sent (JPY)',
    print_total_brl: 'Total Received (BRL)',
    print_total_fee: 'Total Fees',
    print_col_no: 'No.',
    print_col_date: 'Date/Time',
    print_col_recipient: 'Recipient',
    print_col_sender: 'Sender',
    print_col_amount_jpy: 'Amount (JPY)',
    print_col_fee: 'Fee',
    print_col_total_jpy: 'Total (JPY)',
    print_col_amount_brl: 'Received (BRL)',
    print_col_rate: 'Rate',
    print_col_status: 'Status',
    print_col_id: 'Transfer ID',
    print_col_payment: 'Payment',
    print_footer_user: 'This document is a transfer record reference',
    print_footer_admin: 'Transfer management record',
    print_admin_label: 'Admin',
    print_license: 'License No.',
    print_representative: 'Representative',
    print_items: 'items',
    print_address: 'Address',
    print_phone: 'Phone',
    print_email: 'Email',
    print_website: 'Website',
    print_payment_paid: 'Paid',
    print_payment_confirmed: 'Confirmed',
    print_pdf_read: 'PDF processed ({fields})',
    print_settlement_id: 'Settlement ID',
    print_settled_amount: 'Settled amount',

    // Admin AML page
    aml_subtitle: 'Anti-Money Laundering management and resolution records',
    aml_created_at: 'Date occurred',
    aml_resolve_record: 'Resolution Record',
    aml_resolve_title: 'AML Resolution Record',
    aml_resolve_detail_title: 'AML Resolution Detail',
    aml_resolve_type: 'Resolution Type',
    aml_resolver_name: 'Staff Name',
    aml_resolved_date: 'Resolution Date',
    aml_resolution_notes: 'Resolution Notes',
    aml_resolution_notes_placeholder: 'Record details...',
    aml_id_upload: 'ID Document Upload',
    aml_id_doc: 'ID Document',
    aml_id_front: 'Front',
    aml_id_back: 'Back',
    aml_save_resolve: 'Save Resolution',
    aml_resolved_at: 'Resolution Date/Time',
    aml_resolver_label: 'Staff',
    aml_resolved_date_label: 'Date',
    aml_notes_label: 'Record',
    aml_id_attached: 'ID document attached',
    aml_image_only: 'Only image files are allowed',
    aml_upload_success: '{side} uploaded',
    aml_upload_failed: 'Upload failed',
    aml_name_required: 'Please enter staff name',
    aml_date_required: 'Please enter resolution date',
    aml_resolve_failed: 'Resolution failed',
    aml_delete_failed: 'Delete failed',
    aml_flag_label: 'Flag',
    aml_name_placeholder: 'e.g. Taro Yamada',
    aml_user_id: 'User ID',
    aml_risk_prefix: 'Risk',

    // AML Enhanced
    aml_stats_title: 'AML Statistics',
    aml_stats_total: 'Total Flags',
    aml_stats_open: 'Open',
    aml_stats_investigating: 'Investigating',
    aml_stats_resolved: 'Resolved',
    aml_stats_false_positive: 'False Positive',
    aml_stats_high_risk: 'High Risk (Active)',
    aml_stats_medium_risk: 'Medium Risk (Active)',
    aml_stats_low_risk: 'Low Risk (Active)',
    aml_stats_today: 'Today',
    aml_stats_week: 'This Week',
    aml_stats_month: 'This Month',
    aml_stats_held: 'Held Transfers',
    aml_stats_risky_users: 'High Risk Users',
    aml_settings_title: 'AML Settings',
    aml_settings_desc: 'Configure detection rule thresholds',
    aml_settings_high_amount: 'High Amount Threshold (JPY)',
    aml_settings_medium_amount: 'Medium Amount Threshold (JPY)',
    aml_settings_daily_limit: 'Daily Cumulative Limit (JPY)',
    aml_settings_weekly_limit: 'Weekly Cumulative Limit (JPY)',
    aml_settings_hourly_freq: 'Hourly Frequency Limit',
    aml_settings_same_recipient: 'Same Recipient Daily Limit',
    aml_settings_new_user_amount: 'New User High Amount (JPY)',
    aml_settings_new_user_days: 'New User Period (Days)',
    aml_settings_night_start: 'Night Start Hour (JST)',
    aml_settings_night_end: 'Night End Hour (JST)',
    aml_settings_night_threshold: 'Night Transfer Threshold (JPY)',
    aml_settings_round_threshold: 'Round Amount Threshold (JPY)',
    aml_settings_auto_hold: 'Auto-hold High Risk',
    aml_settings_saved: 'AML settings saved',
    aml_settings_save_failed: 'Failed to save AML settings',
    aml_tab_flags: 'Flags',
    aml_tab_stats: 'Statistics',
    aml_tab_settings: 'Settings',
    aml_tab_users: 'Risk Users',
    aml_filter_all: 'All',
    aml_filter_open: 'Open',
    aml_filter_investigating: 'Investigating',
    aml_filter_resolved: 'Resolved',
    aml_filter_high: 'High Risk',
    aml_filter_medium: 'Medium Risk',
    aml_filter_low: 'Low Risk',
    aml_set_investigating: 'Set Investigating',
    aml_user_name: 'User Name',
    aml_user_email: 'Email',
    aml_user_risk_score: 'Risk Score',
    aml_user_risk_tier: 'Risk Level',
    aml_risk_critical: 'Critical',
    aml_flag_type_labels: 'Detection Type',
    aml_flag_high_amount: 'High Amount',
    aml_flag_high_frequency: 'High Frequency',
    aml_flag_daily_limit: 'Daily Limit Exceeded',
    aml_flag_weekly_limit: 'Weekly Limit Exceeded',
    aml_flag_same_recipient: 'Same Recipient',
    aml_flag_new_user_high_value: 'New User High Value',
    aml_flag_night_transfer: 'Night Transfer',
    aml_flag_round_amount_pattern: 'Round Amount Pattern',
    admin_transfers_edit_title: 'Edit Transfer Status',
    admin_transfers_completion_info: 'Completion Information',
    admin_transfers_settlement_id: 'Settlement ID',
    admin_transfers_completed_date: 'Completion Date',
    admin_transfers_completed_required: 'Please enter completion date',
    admin_transfers_settled_amount: 'Settled Amount',
    admin_transfers_proof: 'Transfer Proof',
    admin_transfers_proof_pdf: 'Transfer Proof PDF',
    admin_transfers_open_new_tab: 'Open in new tab',
    admin_transfers_not_uploaded: 'Not uploaded',
    admin_transfers_completed_at: 'Completed At',
    admin_transfers_edit_status_btn: 'Edit Status',
    admin_transfers_pdf_only: 'Only PDF files are allowed',
    admin_transfers_pdf_uploaded: 'PDF uploaded',
    admin_transfers_upload_failed: 'Upload failed',
    admin_transfers_status_label: 'Status',
    admin_transfers_payment_label: 'Payment Status',
    admin_transfers_settlement_placeholder: 'e.g. TXN-20260315-001',
    admin_transfers_required: 'Required',

    // Admin Deposits extra
    admin_deposits_method_label: 'Deposit Method',
    admin_deposits_status_label: 'Status',
    admin_deposits_request_date: 'Request Date',
    admin_deposits_process_date: 'Process Date',
    admin_deposits_memo: 'Memo',
    admin_deposits_user_memo: 'User Memo',
    admin_deposits_receipt: 'Receipt',
    admin_deposits_click_enlarge: 'Click to enlarge',
    admin_deposits_no_receipt: 'No receipt',
    admin_deposits_reject_confirm_text: 'Reject this deposit?',
    admin_deposits_delete_confirm_text: 'Delete this deposit? If confirmed, the amount will be deducted from balance.',

    // Admin Referrals extra
    admin_ref_code_updated: 'Code updated',
    admin_ref_code_update_failed: 'Failed to update code',
    admin_ref_code_deleted: 'Code deleted',
    admin_ref_delete_failed: 'Delete failed',
    admin_ref_delete_confirm: 'Delete referral code "{code}"?',

    // Admin Users extra
    admin_users_details_btn: 'Details',
    admin_users_balance_manage: 'Manage Balance',
    admin_users_edit_btn: 'Edit',
    admin_users_delete_btn: 'Delete',
    admin_users_amount_placeholder: 'Enter amount',

    // Admin Settings extra
    admin_settings_account_type_default: 'Savings',
    admin_settings_branch_placeholder: 'Main',
    admin_settings_notes_placeholder: 'Notes about transfers, etc.',

    // Additional missing keys
    print: 'Print',
    clear_filter: 'Clear',
    date_start: 'Start Date',
    date_end: 'End Date',
    admin_ref_code_col: 'Referral Code',
    admin_ref_user_col: 'User',
    admin_ref_count_col: 'Referrals',
    admin_ref_completed_col: 'Completed',
    admin_ref_issued_col: 'Issued Date',
    admin_ref_actions_col: 'Actions',
    admin_ref_no_codes: 'No codes issued',
    admin_deposits_detail_title: 'Deposit Details',
    admin_deposits_user_col: 'User',
    admin_deposits_amount_col: 'Amount',
    admin_deposits_receipt_col: 'Receipt',
    admin_reports_fetch_failed: 'Failed to fetch data',
    admin_transfers_payment_status: 'Payment Status',
    approve: 'Approve',
    reject: 'Reject',
    uploading: 'Uploading...',

    // Transfer limit
    admin_users_transfer_limit: 'Transfer Limit',
    admin_users_transfer_limit_placeholder: 'e.g. 500000 (empty = no limit)',
    admin_users_transfer_limit_hint: 'Per-transfer limit (JPY). Empty = no limit',
    send_transfer_limit: 'Transfer Limit',
    send_over_limit: 'Amount exceeds transfer limit',
    send_over_limit_msg: 'Per-transfer limit is ¥{limit}',
  }
};

export default translations;
